import { LawFirm } from '../types';

// Auto-generated law firms catalog (deduplicated)
// Total firms: 654
// Unique firms after deduplication

export const allLawFirms: LawFirm[] = [
  {
    "id": "advocacy_firms_1",
    "name": "AAESHA ALTENEIJI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/03/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_1",
        "address": "السابع - مكتب 704 ,قرية الأعمال - بلوك B ,دوار الساعة ,183303 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142280050",
        "email": "aisha@aishalawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_15",
      "legal_consultancy_individual_2063"
    ],
    "slug": "aaesha-alteneiji-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_2",
    "name": "ABDALLA AL YASSI ADVOCATES AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_2",
        "address": "",
        "emirate": "Dubai",
        "phone": "97140000000 / 971507448882",
        "email": "a.alyassi@alyassi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_101",
      "advocacy_individual_102",
      "legal_consultancy_individual_188",
      "legal_consultancy_individual_189"
    ],
    "slug": "abdalla-al-yassi-advocates-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_3",
    "name": "ABDALLA ALMAZROOQI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/10/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_3",
        "address": "Abdalla Saleh Almarzooqi ,4th ,   Business Avenue 515 ,Dubai Airport ,111107 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145750781 / 971504108014",
        "email": "abdallaalmarzooqi@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_26"
    ],
    "slug": "abdalla-almazrooqi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_4",
    "name": "ABDALLA ALNAKHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_4",
        "address": "mohamed mahmoud mohamed elkormany ,بناية الوصل ,R549 يناية الوصل ,سيتي سنتر ديره ,83620 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142542000",
        "email": "info@aaalegalconsultants.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1139",
      "legal_consultancy_individual_1733"
    ],
    "slug": "abdalla-alnakhi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_5",
    "name": "ABDALLA ALOWAIS ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/09/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_5",
        "address": "702-703 ,THE EXCHANGE TOWER ,NEAR IN BUSINESS BAY METRO STATION ,90009 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142327888",
        "email": "info@alowaislaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_25",
      "legal_consultancy_individual_140",
      "legal_consultancy_individual_400",
      "legal_consultancy_individual_1162",
      "legal_consultancy_individual_1163",
      "legal_consultancy_individual_1901",
      "legal_consultancy_individual_1902",
      "legal_consultancy_individual_3163"
    ],
    "slug": "abdalla-alowais-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_6",
    "name": "ABDELAZIZ AL BLOUSHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_6",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142396646",
        "email": "advo_alblooshi@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_32",
      "legal_consultancy_individual_1370",
      "legal_consultancy_individual_1371",
      "legal_consultancy_individual_2566",
      "legal_consultancy_individual_2937",
      "legal_consultancy_individual_2938"
    ],
    "slug": "abdelaziz-al-bloushi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_7",
    "name": "ABDELAZIZ AL KHAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/03/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_7",
        "address": "ABDELAZIZ MOHAMED ABDELGHANI AL KHAMIRI AL ALI ,3 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,128334 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145519341 / 971505788557",
        "email": "info@raalc.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_35",
      "advocacy_individual_1063",
      "legal_consultancy_individual_858",
      "legal_consultancy_individual_2236",
      "legal_consultancy_individual_2237",
      "legal_consultancy_individual_2238",
      "legal_consultancy_individual_2239",
      "legal_consultancy_individual_2240",
      "legal_consultancy_individual_2241",
      "legal_consultancy_individual_2242"
    ],
    "slug": "abdelaziz-al-khamiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_8",
    "name": "ABDELAZIZ AL ZAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/02/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_8",
        "address": "طابق الميزانين ، مكتب M05 ,ملتقى الأعمال (بناية تسهيل) ,خلف نادي النصر الرياضي ,414121 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143888252",
        "email": "alzaabiadvo8@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdelaziz-al-zaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_9",
    "name": "ABDELAZIZ ALHANAEE ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_9",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143316868 / 971561446981",
        "email": "info@alhanaee.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdelaziz-alhanaee-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_10",
    "name": "ABDELRAHMAN AL MAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/02/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_10",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142552220",
        "email": "almaazmi.office@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_41",
      "advocacy_individual_1418",
      "advocacy_individual_1419",
      "legal_consultancy_individual_659",
      "legal_consultancy_individual_1311",
      "legal_consultancy_individual_1312",
      "legal_consultancy_individual_2302",
      "legal_consultancy_individual_2498"
    ],
    "slug": "abdelrahman-al-maazmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_11",
    "name": "ABDUL HADI JASIM AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/08/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_11",
        "address": "Office 214 ,Dubai Autism Center ,Makani No: 3349592541 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971503377345",
        "email": "abd3377345@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_36",
      "advocacy_individual_37"
    ],
    "slug": "abdul-hadi-jasim-al-hammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_12",
    "name": "ABDUL RAHMAN AL MOTAWA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_12",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142664424",
        "email": "nagm009@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1688"
    ],
    "slug": "abdul-rahman-al-motawa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_13",
    "name": "ABDUL RAHMAN LOOTAH & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_13",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142944111",
        "email": "info@lootahlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_144",
      "advocacy_individual_145"
    ],
    "slug": "abdul-rahman-lootah-associates-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_14",
    "name": "ABDUL RAHMAN NASEEB ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 13,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_14",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144472020",
        "email": "info@arnadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_153",
      "advocacy_individual_154",
      "advocacy_individual_607",
      "advocacy_individual_608",
      "legal_consultancy_individual_72",
      "legal_consultancy_individual_73",
      "legal_consultancy_individual_160",
      "legal_consultancy_individual_161",
      "legal_consultancy_individual_934",
      "legal_consultancy_individual_935",
      "legal_consultancy_individual_1976",
      "legal_consultancy_individual_1977",
      "legal_consultancy_individual_2626"
    ],
    "slug": "abdul-rahman-naseeb-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_15",
    "name": "ABDULBASET ABDULLA ALJNEIBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/02/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_15",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143240008 / 971555573999",
        "email": "info@asolutions.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_51"
    ],
    "slug": "abdulbaset-abdulla-aljneibi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_16",
    "name": "ABDULHAKIM BINHERZ ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/05/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_16",
        "address": "Abdulhakim Habib Mansoor Binherz  ,38 ,Latifa Tower  , Crowne Plaza Hotel ,97598 ,Dubai",
        "emirate": "Dubai",
        "phone": "97102544490",
        "email": "litigation@binherzadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_52",
      "advocacy_individual_53",
      "legal_consultancy_individual_197"
    ],
    "slug": "abdulhakim-binherz-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_17",
    "name": "ABDULHAMEED ALJASMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/10/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_17",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142251011",
        "email": "info@ajlc.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_54",
      "advocacy_individual_55"
    ],
    "slug": "abdulhameed-aljasmi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_18",
    "name": "ABDULHAMID YOUSUF ALBALOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/05/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_18",
        "address": "Zahraa ALSaedi ,Floor 14 - Offices No.1401,1402,1404 ,Aspin Commercial Tower  ,Shangri-La Hotel ,62999 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142224460 / 97142224460",
        "email": "info@dubailawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_57",
      "advocacy_individual_58"
    ],
    "slug": "abdulhamid-yousuf-albalooshi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_19",
    "name": "ABDULLA AL - ALI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_19",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142959933",
        "email": "alaliadv@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_3",
      "legal_consultancy_individual_1272",
      "legal_consultancy_individual_1273"
    ],
    "slug": "abdulla-al-ali-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_20",
    "name": "ABDULLA AL AWADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_20",
        "address": "Advo. Abdulla Al Awadi ,العاشر  ,برايم تاور  ,فندق فيدا ,26665 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143352200",
        "email": "info@abdullaalawadi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_154",
      "legal_consultancy_individual_155",
      "legal_consultancy_individual_489",
      "legal_consultancy_individual_1254",
      "legal_consultancy_individual_1255",
      "legal_consultancy_individual_2178"
    ],
    "slug": "abdulla-al-awadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_21",
    "name": "ABDULLA AL HADDAD ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/09/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_21",
        "address": "الطابق الثالث ,مجمع المحكمة العليا دبي ,مجمع المحكمة العليا دبي ,45556 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145570632 / 971503977375",
        "email": "rasmi@aahadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1043",
      "legal_consultancy_individual_1044",
      "legal_consultancy_individual_2509",
      "legal_consultancy_individual_2510"
    ],
    "slug": "abdulla-al-haddad-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_22",
    "name": "ABDULLA AL MANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/09/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_22",
        "address": "abdulla al mansoori ,الطابق السابع  ,الغزال ستاندرد  ,مول الغزال ,393164 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145531403 / 971569305848",
        "email": "info@abmadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_109",
      "advocacy_individual_110"
    ],
    "slug": "abdulla-al-mansoori-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_23",
    "name": "ABDULLA AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/11/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_23",
        "address": "Office No.B3604 ,Latifa tower  ,Sheikh zayed rd ,895 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971000000000",
        "email": "alraeesi@aradvoc.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_66",
      "advocacy_individual_67",
      "legal_consultancy_individual_142"
    ],
    "slug": "abdulla-al-raeesi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_24",
    "name": "ABDULLA AL SUWAIDI ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/12/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_24",
        "address": "بلوك بي  ,R338 ,بجانب بناية سيتي بنك - بجوار مركز وافي  ,0554060326 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143337444",
        "email": "info@alsuwaidi-advo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1623",
      "legal_consultancy_individual_2135"
    ],
    "slug": "abdulla-al-suwaidi-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_25",
    "name": "ABDULLA AL ZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_25",
        "address": "ABDULLAH AMIN ALZAROONI ,209+210+611+211 ,بزنس افينيو ,خلف وكالة النيسان ,12781 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142954299",
        "email": "zaroonilawyers@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_74",
      "advocacy_individual_185",
      "advocacy_individual_186",
      "legal_consultancy_individual_2079"
    ],
    "slug": "abdulla-al-zarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_0",
    "name": "ABDULLA ALATEIBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/04/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_0",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145859327 / 971503148845",
        "email": "info@amalc.net",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_90",
      "advocacy_individual_91"
    ],
    "slug": "abdulla-alateibi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_26",
    "name": "ABDULLA ALI ALJNAIBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/10/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_26",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "admin@aljunaibi-advocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdulla-ali-aljnaibi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_27",
    "name": "ABDULLA ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 9,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/11/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_27",
        "address": "abdulla nasser mansour hamad alkaabi ,life pharmacy ,al safa ,millennium plaza hotel ,113713 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143598998",
        "email": "advo.akd@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_113",
      "advocacy_individual_114",
      "legal_consultancy_individual_2020",
      "legal_consultancy_individual_2021",
      "legal_consultancy_individual_2535",
      "legal_consultancy_individual_2536",
      "legal_consultancy_individual_2811",
      "legal_consultancy_individual_2943",
      "legal_consultancy_individual_2944"
    ],
    "slug": "abdulla-alkaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_28",
    "name": "ABDULLA ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/11/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_28",
        "address": "31/3107 ,ابراج لطيفة ,بنك الكويت الوطني ,442 ,Dubai",
        "emirate": "Dubai",
        "phone": "97197143706 / 971558775654",
        "email": "alnajjar_ab@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_130",
      "legal_consultancy_individual_514",
      "legal_consultancy_individual_515"
    ],
    "slug": "abdulla-alnajjar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_29",
    "name": "ABDULLA ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_29",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142200065",
        "email": "Abdulla-Alnuaimi-legal@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_105",
      "advocacy_individual_106"
    ],
    "slug": "abdulla-alnuaimi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_30",
    "name": "ABDULLA ALOBEIDLI ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_30",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142775444 / 971507886668",
        "email": "info@abdlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_72",
      "advocacy_individual_73",
      "advocacy_individual_1352",
      "advocacy_individual_1353",
      "legal_consultancy_individual_1580",
      "legal_consultancy_individual_1581"
    ],
    "slug": "abdulla-alobeidli-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_31",
    "name": "ABDULLA ALOMRAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/11/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_31",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143528314",
        "email": "alomran.advocates@alaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_94",
      "advocacy_individual_95",
      "legal_consultancy_individual_942",
      "legal_consultancy_individual_943"
    ],
    "slug": "abdulla-alomran-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_32",
    "name": "ABDULLA ALQADI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/08/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_32",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971506278383",
        "email": "alqadi1974@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_96",
      "advocacy_individual_97"
    ],
    "slug": "abdulla-alqadi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_33",
    "name": "ABDULLA BINHAMAD ALMHEIRI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_33",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142944000 / 971501826000",
        "email": "info@binhamadlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdulla-binhamad-almheiri-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_34",
    "name": "ABDULLA EBRAHIM ALMANSOORI LAWYERS AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_34",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142343373 / 971507004104",
        "email": "almansoorilawyer@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_862",
      "advocacy_individual_863",
      "legal_consultancy_individual_326",
      "legal_consultancy_individual_327"
    ],
    "slug": "abdulla-ebrahim-almansoori-lawyers-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_35",
    "name": "ABDULLA EBRAHIM ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_35",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145571020",
        "email": "abdullaalmansoori80@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2118"
    ],
    "slug": "abdulla-ebrahim-almulla-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_36",
    "name": "ABDULLA HAJI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_36",
        "address": "الطابق السادس  مكتب 602 ,المسعود ,دوار الساعة  ,97766 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142369336",
        "email": "ahlawyer20@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_79"
    ],
    "slug": "abdulla-haji-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_37",
    "name": "ABDULLA MATAR ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "28/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_37",
        "address": "الطابق 23 - مكتب رقم 2304 ,ايريس باي ,رقم مكاني: 2466086696 ,23328 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143250002 / 971508090162",
        "email": "aflawfirm@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdulla-matar-alfalasi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_39",
    "name": "ABDULLA MOHAMMED RASOUL ALHARMOODI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/02/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_39",
        "address": "1 ,Crystal Tower ,Business Bay ,1859 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142956661",
        "email": "info@amrplc.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdulla-mohammed-rasoul-alharmoodi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_40",
    "name": "ABDULLAH HUSSAIN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/11/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_40",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142512221",
        "email": "info@ahal-advocacy.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2359"
    ],
    "slug": "abdullah-hussain-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_41",
    "name": "ABDULLATIF AL HAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_41",
        "address": "ABDULLATIF ALHAMMADI ,1 ,ABDULLA KAMBER BUSINESS CENTRE , ABU BAKER AL SIDDIQUE METRO STATION ,202142 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143212266",
        "email": "alhammadi@alhammadilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_137",
      "advocacy_individual_138"
    ],
    "slug": "abdullatif-al-hammadi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_42",
    "name": "ABDULLATIF ALJASSMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/12/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_42",
        "address": "Abdullatif Aljassmi ,Floor No.23- Office No. 2309 ,Burlington Tower ,The Oberoi Dubai ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97147700321 / 971506441515",
        "email": "info@aaljassmiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdullatif-aljassmi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_43",
    "name": "ABDULLJAWAD ALQASEM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_43",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143304457",
        "email": "abduljawad@alqasemadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abdulljawad-alqasem-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_44",
    "name": "ABDULMALIK & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_44",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142227008 / 971506245451",
        "email": "info@abdulmaliklaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1019",
      "advocacy_individual_1020",
      "legal_consultancy_individual_164",
      "legal_consultancy_individual_1996"
    ],
    "slug": "abdulmalik-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_45",
    "name": "ABDULRAHMAN AHMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/07/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_45",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148843777 / 971508825889",
        "email": "info@arlawyers.me",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_226",
      "legal_consultancy_individual_227",
      "legal_consultancy_individual_1848"
    ],
    "slug": "abdulrahman-ahmed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_46",
    "name": "ABDULRAHMAN ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_46",
        "address": "ABDULRAHMAN MOHAMED ALAAMRI ,306 ,ACICO BUISINESS PARK ,NISSAN SHOW ROOM ,33731 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148819818 / 971503933245",
        "email": "info@alaamri.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_150",
      "advocacy_individual_548",
      "advocacy_individual_549",
      "legal_consultancy_individual_2027",
      "legal_consultancy_individual_2028"
    ],
    "slug": "abdulrahman-alameri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_47",
    "name": "ABDULRAZAQ MARJAN ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/03/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_47",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143218833 / 971506563555",
        "email": "abmarjanadv@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_157",
      "advocacy_individual_158",
      "advocacy_individual_823",
      "advocacy_individual_824"
    ],
    "slug": "abdulrazaq-marjan-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_48",
    "name": "ABDULRHMAN ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/11/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_48",
        "address": "Abdulrahman Ali Alshaali  ,7 ,برج المسعود 2 ,معرض سيارات تويوتا - ديره ,00000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143300780 / 971971454749",
        "email": "abdulrahman@alshaalilegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2364"
    ],
    "slug": "abdulrhman-alshaali-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_49",
    "name": "ABEER MUSABBAH OBAID ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "17/01/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_49",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "info@abeeradvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "abeer-musabbah-obaid-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_51",
    "name": "ACCORD INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_51",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143366080",
        "email": "info@accordlawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_893",
      "legal_consultancy_individual_1538",
      "legal_consultancy_individual_1539",
      "legal_consultancy_individual_1540",
      "legal_consultancy_individual_1541"
    ],
    "slug": "accord-international-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_52",
    "name": "ADEL AL GHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/08/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_52",
        "address": "Adel Salem Abdulla Salem Alghafri ,16th floor, Office: 1602 ,Aspect Tower ,Bay Avenue Mall ,444470 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142807052 / 971555666589",
        "email": "info@adelalghafri.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_171",
      "advocacy_individual_172",
      "advocacy_individual_333",
      "legal_consultancy_individual_967",
      "legal_consultancy_individual_968",
      "legal_consultancy_individual_1935",
      "legal_consultancy_individual_1936"
    ],
    "slug": "adel-al-ghafri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_53",
    "name": "ADEL ALJNEIBI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/08/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_53",
        "address": "Adel Abdulla Khamis Musallem Aljuneibi ,903 ,السركال 2 ,خلف البيت الاخضر بالقرب من معرض TOYOTA  الفطيم ,26620 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144523399 / 971504487844",
        "email": "aljneibimk@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_167",
      "advocacy_individual_168"
    ],
    "slug": "adel-aljneibi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_54",
    "name": "ADIL ALMAAMRI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/02/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_54",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143347598 / 971509571957",
        "email": "alitezanlawyers@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "adil-almaamri-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_55",
    "name": "ADIL FAKHIR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/05/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_55",
        "address": "Adil Fakhir ,الطابق الخامس - 502 ,العويس ,خلف وكالة النيسان ,231211 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143232888",
        "email": "a.fakhir@adilfakhir.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "adil-fakhir-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_56",
    "name": "ADNAN OBAID ALSHAALI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_56",
        "address": "ADNAN OBAID ALSHAALI , Second floor - FLAT 201A ,Al Khaimah Building ,Al Ittihad Road, Deira ,238837 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142392332 / 971505544558",
        "email": "adnan@alshaali-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_175",
      "advocacy_individual_176",
      "legal_consultancy_individual_2724",
      "legal_consultancy_individual_2725"
    ],
    "slug": "adnan-obaid-alshaali-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_57",
    "name": "ADVOCATES UNIT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_57",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "advocates-unit"
  },
  {
    "id": "advocacy_firms_59",
    "name": "AFAF MARJAN ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/05/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_59",
        "address": "AFAF MARJAN NASIB ,3 ,GULF TOWERS  ,DUBAI MUNICIPALITY ,35192 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143333929 / 97143333929",
        "email": "info@afafmarjan.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "afaf-marjan-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_60",
    "name": "AHMAD ABDULLA AHLI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_60",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142244442",
        "email": "info@ahli-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmad-abdulla-ahli-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_62",
    "name": "AHMAD GALADARI & ASSOCIATES ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_62",
        "address": "AHMAD HASSAN IBRAIM GALADARI ,السابع  ,بناية مكاتب  ,وكالة نسيان للسيارات  ,99664 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142977884",
        "email": "mr.galadari@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmad-galadari-associates-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_63",
    "name": "AHMED ABDULRAHMAN ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/06/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_63",
        "address": "Office No. 116 ,Makeen Building ,Makani No: 3312794001 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142558462 / 971506358668",
        "email": "ahmed_alzarooni@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_212"
    ],
    "slug": "ahmed-abdulrahman-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_64",
    "name": "AHMED AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_64",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971000000000",
        "email": "ahmed.advo@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_206",
      "advocacy_individual_207",
      "legal_consultancy_individual_1207"
    ],
    "slug": "ahmed-al-ali-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_65",
    "name": "AHMED AL AMIRI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_65",
        "address": "العاشر ,المسعود ,بجوار معرض تويوتا ,20085 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142945554",
        "email": "ahmedalamiri_law@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_99",
      "legal_consultancy_individual_1261",
      "legal_consultancy_individual_1262",
      "legal_consultancy_individual_2025",
      "legal_consultancy_individual_2026",
      "legal_consultancy_individual_2039",
      "legal_consultancy_individual_2040"
    ],
    "slug": "ahmed-al-amiri-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_66",
    "name": "AHMED AL RAEESI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/04/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_66",
        "address": "Ahmed alraeesi  ,1303 ,Salmiya Tower ,Salmiya Tower ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222330 / 971502727580",
        "email": "admin@alraeesilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmed-al-raeesi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_67",
    "name": "AHMED ALHAMLI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/11/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_67",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142508799 / 971504748037",
        "email": "info@alhamlifirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_976"
    ],
    "slug": "ahmed-alhamli-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_68",
    "name": "AHMED ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_68",
        "address": "الاول 107 ,مجمع المحكمة العليا بدبي  ,محاكم دبي  ,56637 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142568008",
        "email": "info@almaazmi-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmed-almaazmi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_69",
    "name": "AHMED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/09/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_69",
        "address": "الطابق العاشر - 1003 ,برج الريم ,خلف مقر اتصالات - ديرة ,64166 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143395953 / 971502110022",
        "email": "info@almazroueiadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1933",
      "legal_consultancy_individual_1934",
      "legal_consultancy_individual_2659",
      "legal_consultancy_individual_2660",
      "legal_consultancy_individual_3161",
      "legal_consultancy_individual_3162"
    ],
    "slug": "ahmed-almazrouei-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_70",
    "name": "AHMED ALSHAALI ATTORNEYS AT LAW",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/12/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_70",
        "address": "Office M21 ,Garhoud Business Center ,Near GG Ko Metro Station Makani No: 4002124052 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142527751 / 971567778217",
        "email": "alshaaliattorneys25@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_213",
      "advocacy_individual_214",
      "legal_consultancy_individual_1962"
    ],
    "slug": "ahmed-alshaali-attorneys-at-law"
  },
  {
    "id": "advocacy_firms_71",
    "name": "AHMED ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/11/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_71",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143331110",
        "email": "info@azlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_225",
      "advocacy_individual_226"
    ],
    "slug": "ahmed-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_72",
    "name": "AHMED BIN DHAHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_72",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143573330",
        "email": "admin@dhahiadvocate.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_148",
      "legal_consultancy_individual_149",
      "legal_consultancy_individual_382",
      "legal_consultancy_individual_383",
      "legal_consultancy_individual_1903",
      "legal_consultancy_individual_1904"
    ],
    "slug": "ahmed-bin-dhahi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_73",
    "name": "AHMED EISA ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/01/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_73",
        "address": "Ahmed Eisa Mohammed Eisa  ,2nd floor- office 210  ,Al Khaima  ,Al Khabaisi Park ,14748 ,Dubai",
        "emirate": "Dubai",
        "phone": "97197150649 / 971506496333",
        "email": "ahmedissaadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmed-eisa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_74",
    "name": "AHMED GERMAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_74",
        "address": "AHMAD GERMAN ,Frist Floor office 03 ,GARHOUD ,Makani Number 32607 94119 ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97140000000 / 971521477743",
        "email": "ahmadjarman2@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmed-german-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_75",
    "name": "AHMED HASSAN ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/10/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_75",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142594601",
        "email": "info@almazmilawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_195",
      "advocacy_individual_196",
      "legal_consultancy_individual_1049",
      "legal_consultancy_individual_1050",
      "legal_consultancy_individual_1168",
      "legal_consultancy_individual_2157"
    ],
    "slug": "ahmed-hassan-almaazmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_76",
    "name": "AHMED IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_76",
        "address": "4/406 ,Acico Business Park  ,Behind Nissan Showroom ,186344 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142989888 / 971505948989",
        "email": "AHMEDIBRAHIMLAW@GMAIL.COM",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_217",
      "advocacy_individual_218",
      "legal_consultancy_individual_168",
      "legal_consultancy_individual_169",
      "legal_consultancy_individual_1949",
      "legal_consultancy_individual_1950",
      "legal_consultancy_individual_2491"
    ],
    "slug": "ahmed-ibrahim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_77",
    "name": "AHMED KHAMIES ALZEYOUDI ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_77",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142212205 / 971558866989",
        "email": "info@akzlawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_408"
    ],
    "slug": "ahmed-khamies-alzeyoudi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_78",
    "name": "AHMED MATAR AL MHEIRI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/01/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_78",
        "address": "Ahmed Mohammed Matar Matar Almheiri ,4 ,SOBHA SAPPHIRE ,Bussines Bay ,393294 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143387880 / 971506478881",
        "email": "almheiricourts@bridgelg.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_236",
      "legal_consultancy_individual_12",
      "legal_consultancy_individual_13"
    ],
    "slug": "ahmed-matar-al-mheiri-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_79",
    "name": "AHMED MOHAMED MOBARAK ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/03/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_79",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143333379",
        "email": "mubarak.legalfirm@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ahmed-mohamed-mobarak-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_80",
    "name": "AHMED MOHAMMED BASHIR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/04/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_80",
        "address": "801/802 ,Park Place ,WTC ,384557 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143203999",
        "email": "info.dubai@alemlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_233",
      "advocacy_individual_234",
      "advocacy_individual_911",
      "advocacy_individual_912",
      "legal_consultancy_individual_938",
      "legal_consultancy_individual_939",
      "legal_consultancy_individual_1605",
      "legal_consultancy_individual_1606",
      "legal_consultancy_individual_1990",
      "legal_consultancy_individual_1991",
      "legal_consultancy_individual_2347",
      "legal_consultancy_individual_2348"
    ],
    "slug": "ahmed-mohammed-bashir-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_81",
    "name": "AHMED RAMADAN ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_81",
        "address": "18 ,برج السلام ,سما تاور ,68068 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143519700 / 971507973939",
        "email": "info@ramadanlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_19",
      "advocacy_individual_20",
      "legal_consultancy_individual_27",
      "legal_consultancy_individual_219"
    ],
    "slug": "ahmed-ramadan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_82",
    "name": "AISHA AL MANSOORI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/02/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_82",
        "address": "Aisha Al Mansoori ,الطابق 3   - مكتب 303 ,برج بيناري ,دبي مول ,65452 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144058200 / 97144058200",
        "email": "aisha@aalmansoori.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "aisha-al-mansoori-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_83",
    "name": "AISHA ATEEQ ADVOCETS AND LEGAL CONSALTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_83",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142515900 / 971509394393",
        "email": "mail@aaadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "aisha-ateeq-advocets-and-legal-consaltant"
  },
  {
    "id": "advocacy_firms_84",
    "name": "AISHAH KHALAF ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/09/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_84",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142881170 / 971502080879",
        "email": "aka_lawyers@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "aishah-khalaf-almazrouei-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_85",
    "name": "AL AHLI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "13/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_85",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143352000",
        "email": "info@alahlialkhaja.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1127",
      "advocacy_individual_1128",
      "advocacy_individual_502",
      "legal_consultancy_individual_30",
      "legal_consultancy_individual_31"
    ],
    "slug": "al-ahli-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_87",
    "name": "AL AIDAROUS ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 16,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_87",
        "address": "Gamal Yassein Abdalla ,الطابق 13  Floor No 13 ,بناية مركز ابروي (The Oberoi Center) ,فندق ابروي (The Oberoi Hotel) ,33299 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142828000",
        "email": "litigation@alaidarous.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_300",
      "advocacy_individual_468",
      "advocacy_individual_469",
      "advocacy_individual_622",
      "advocacy_individual_623",
      "legal_consultancy_individual_547",
      "legal_consultancy_individual_845",
      "legal_consultancy_individual_1061",
      "legal_consultancy_individual_1062",
      "legal_consultancy_individual_2078",
      "legal_consultancy_individual_2152",
      "legal_consultancy_individual_2153",
      "legal_consultancy_individual_2853",
      "legal_consultancy_individual_2854",
      "legal_consultancy_individual_3124",
      "legal_consultancy_individual_3125"
    ],
    "slug": "al-aidarous-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_88",
    "name": "AL BAHAR & ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_88",
        "address": "Third Floor - Office 310 ,Oud Metha Offices ,DEWA ,49408 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143245444",
        "email": "bahradvt@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_807"
    ],
    "slug": "al-bahar-associates-advocates-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_89",
    "name": "AL BANNAI & AL RASHEDAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_89",
        "address": "الطابق الخامس  ,القيادة ,مطار دبى رقم 2 ,13917 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142949003",
        "email": "info@brlegalese.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_192",
      "advocacy_individual_193",
      "legal_consultancy_individual_1279",
      "legal_consultancy_individual_1280"
    ],
    "slug": "al-bannai-al-rashedan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_90",
    "name": "AL BASTAKI & Al JASMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_90",
        "address": "Bader Aljassmy ,3 ,دبي كوميرسيتي ,دبي كوميرسيتي ,410004 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148760777 / 971586842086",
        "email": "info@bajlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_731",
      "advocacy_individual_732",
      "advocacy_individual_873",
      "legal_consultancy_individual_1890",
      "legal_consultancy_individual_2017"
    ],
    "slug": "al-bastaki-al-jasmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_91",
    "name": "AL BAWARDI ADVOCATE & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_91",
        "address": "7th floor, 701 ,Al Khaleej Centre ,near Al Fahidi Metro Station ,5083 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143591115",
        "email": "jummaadv@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_752",
      "advocacy_individual_753"
    ],
    "slug": "al-bawardi-advocate-legal-consultants"
  },
  {
    "id": "advocacy_firms_92",
    "name": "AL DHAHERI INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_92",
        "address": "4th Floor/ Office no. 401 ,Business Avenue  ,Infront- Terminal 2  ,115263 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144518866",
        "email": "info@aldhaheriinternational.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_308",
      "advocacy_individual_450",
      "advocacy_individual_747",
      "legal_consultancy_individual_930",
      "legal_consultancy_individual_936",
      "legal_consultancy_individual_2006"
    ],
    "slug": "al-dhaheri-international-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_93",
    "name": "AL FADEELA ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/09/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_93",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142288824",
        "email": "alfad224@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-fadeela-advocates"
  },
  {
    "id": "advocacy_firms_94",
    "name": "AL FAJER ADVOCATE & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_94",
        "address": "ABDULKARIM MAKKI ,1605 ,Exchange Tower ,JW Marriott Marquis Hotel Dubai ,98777 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142406606",
        "email": "info@alfajeradvocate.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_61"
    ],
    "slug": "al-fajer-advocate-legal-consultants"
  },
  {
    "id": "advocacy_firms_95",
    "name": "AL FALASI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_95",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143456345 / 971582878951",
        "email": "alfalasi_advocates@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_311",
      "legal_consultancy_individual_2987"
    ],
    "slug": "al-falasi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_96",
    "name": "AL HADDAD & ASSOCIATES  ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_96",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143311224",
        "email": "info@alhaddadco.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-haddad-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_97",
    "name": "AL HAJEYA ALNOOBI ADVOCATES AND LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_97",
        "address": "Alhajeya salem saeed alnoobi ,3rd  ,Al-hawai Tower  ,Behind financial center metro station  ,39779 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142963813",
        "email": "adv_aljazeera@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_265",
      "legal_consultancy_individual_1706",
      "legal_consultancy_individual_1707",
      "legal_consultancy_individual_1986",
      "legal_consultancy_individual_2047",
      "legal_consultancy_individual_2048",
      "legal_consultancy_individual_2474",
      "legal_consultancy_individual_2475",
      "legal_consultancy_individual_2841",
      "legal_consultancy_individual_2842"
    ],
    "slug": "al-hajeya-alnoobi-advocates-and-legal-consultant"
  },
  {
    "id": "advocacy_firms_98",
    "name": "AL HOSANY ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_98",
        "address": "Noushad kn ,1 ,sama tower ,Chello Restaurant  ,87706 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142822744",
        "email": "info@hosanilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_770",
      "legal_consultancy_individual_246",
      "legal_consultancy_individual_247",
      "legal_consultancy_individual_1122",
      "legal_consultancy_individual_2185"
    ],
    "slug": "al-hosany-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_99",
    "name": "AL HOUBY ADVOCATE & LEGAL CONSULTANCY OFFICE",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_99",
        "address": "16 مكتب رقم 1606 ,ذا بريم تاور ,رقم مكاني 2583686879 ,13050 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142662233",
        "email": "info@houbylaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-houby-advocate-legal-consultancy-office"
  },
  {
    "id": "advocacy_firms_100",
    "name": "AL HUQOOQ FOR ADVOCACY AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_100",
        "address": "ABDULRAHMAN OMAR  ABDULLA MUKHAYER  ,NBK BANK ,LATIFA TOWER  ,NEAR CROWN PLAZA  ,185616 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143296968",
        "email": "hlp@hlplawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_155",
      "advocacy_individual_156",
      "advocacy_individual_925",
      "advocacy_individual_926",
      "legal_consultancy_individual_114",
      "legal_consultancy_individual_574",
      "legal_consultancy_individual_575"
    ],
    "slug": "al-huqooq-for-advocacy-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_101",
    "name": "AL INSAF ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_101",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142515101",
        "email": "legal@alinsaf.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_874",
      "advocacy_individual_875",
      "legal_consultancy_individual_2721"
    ],
    "slug": "al-insaf-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_102",
    "name": "AL JABRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_102",
        "address": "الميزانين - مكتب رقم 2  ,جسكوم جراند ريزيدنس  ,خلف المستشفي الكندي  ,12923 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142224668",
        "email": "aljabriadvocates@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_676",
      "advocacy_individual_677"
    ],
    "slug": "al-jabri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_103",
    "name": "AL JALLAF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_103",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143366260",
        "email": "mail@aljallaflegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_373",
      "advocacy_individual_374",
      "legal_consultancy_individual_2487",
      "legal_consultancy_individual_2488"
    ],
    "slug": "al-jallaf-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_104",
    "name": "AL KAITOOB ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/10/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_104",
        "address": "khalid al kaitoob ,12 ,نسيمية تاور الطابق 12 1202 B ,فندق الفوكو  ,10755 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143586555",
        "email": "info@alkaitooblawyer.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_784",
      "advocacy_individual_785",
      "legal_consultancy_individual_26",
      "legal_consultancy_individual_902",
      "legal_consultancy_individual_1270",
      "legal_consultancy_individual_1271",
      "legal_consultancy_individual_1992"
    ],
    "slug": "al-kaitoob-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_105",
    "name": "AL KAMALI & COMPANY ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_105",
        "address": "3-505 ,AL KHABEESI BLDG ,AL KABEESI ,4948 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222228",
        "email": "info@alkamali.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1025",
      "advocacy_individual_1026",
      "legal_consultancy_individual_528",
      "legal_consultancy_individual_529",
      "legal_consultancy_individual_1400",
      "legal_consultancy_individual_1930",
      "legal_consultancy_individual_2361",
      "legal_consultancy_individual_2362",
      "legal_consultancy_individual_2446",
      "legal_consultancy_individual_2447"
    ],
    "slug": "al-kamali-company-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_106",
    "name": "AL KHALEEJ ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/02/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_106",
        "address": "2 ,B62 ,Clock Tower ,13903 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142288808",
        "email": "Lawfirm@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_128",
      "advocacy_individual_129",
      "advocacy_individual_913",
      "advocacy_individual_914"
    ],
    "slug": "al-khaleej-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_107",
    "name": "AL KUMAITI ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_107",
        "address": "ABDULHAMEED ALI ALKUMITY ,الطابق الأول  ,BMTC ,معرض هيونداي للسيارات  ,33998 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142686855",
        "email": "info@alkumaitiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_39",
      "advocacy_individual_1433"
    ],
    "slug": "al-kumaiti-advocates"
  },
  {
    "id": "advocacy_firms_108",
    "name": "AL MAARIF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_108",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142229944",
        "email": "almaarif_law@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_384",
      "legal_consultancy_individual_2707",
      "legal_consultancy_individual_2708"
    ],
    "slug": "al-maarif-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_109",
    "name": "AL MADANI & ASSOCIATES ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_109",
        "address": "abdulla almadani ,6th Floor, Office No. 604 ,Dubai National Insurance Company ,Deira City Center ,80305 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143978578",
        "email": "almadanilawfirm@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_135",
      "advocacy_individual_136"
    ],
    "slug": "al-madani-associates-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_110",
    "name": "AL MADHANI & AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 11,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_110",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143298881",
        "email": "info@mslawuae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_88",
      "advocacy_individual_89",
      "advocacy_individual_1158",
      "legal_consultancy_individual_35",
      "legal_consultancy_individual_905",
      "legal_consultancy_individual_906",
      "legal_consultancy_individual_1511",
      "legal_consultancy_individual_1532",
      "legal_consultancy_individual_1533",
      "legal_consultancy_individual_3082",
      "legal_consultancy_individual_3083"
    ],
    "slug": "al-madhani-al-shamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_111",
    "name": "AL MAIDOOR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "01/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_111",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143348481",
        "email": "lawyers@maidor.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-maidoor-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_113",
    "name": "AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_113",
        "address": "4TH FLOOR ,AL HARTHY ,DUBAI CUSTOMS ,34143 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143930039",
        "email": "admin@advocatesuae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2455",
      "legal_consultancy_individual_2456"
    ],
    "slug": "al-matrooshi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_114",
    "name": "AL MENHALI ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_114",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142504080",
        "email": "alminhaliadv@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-menhali-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_115",
    "name": "AL MIDFA & ASSOCIATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_115",
        "address": "10th Floor ,AlReem Tower ,Dubai Land Department ,32367 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142272701",
        "email": "midfaadv@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_307",
      "advocacy_individual_771",
      "legal_consultancy_individual_1491",
      "legal_consultancy_individual_1627",
      "legal_consultancy_individual_1628",
      "legal_consultancy_individual_1911",
      "legal_consultancy_individual_1912"
    ],
    "slug": "al-midfa-associates"
  },
  {
    "id": "advocacy_firms_116",
    "name": "AL MUDHARREB & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_116",
        "address": "الثاني ,الفجر للاعمال  ,مركز القرهود للياقة الطبية - مستشفى القرهود  ,15105 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222800",
        "email": "info@almudharreb.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_64",
      "legal_consultancy_individual_1286",
      "legal_consultancy_individual_1287",
      "legal_consultancy_individual_2882"
    ],
    "slug": "al-mudharreb-company-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_117",
    "name": "AL MUHAMOON AL ARAB LAWYER & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_117",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142736666",
        "email": "almohmon@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1117",
      "advocacy_individual_1118",
      "legal_consultancy_individual_143",
      "legal_consultancy_individual_144"
    ],
    "slug": "al-muhamoon-al-arab-lawyer-legal-consultancy"
  },
  {
    "id": "advocacy_firms_118",
    "name": "AL NASSAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_118",
        "address": "HOSSAM GAMAL MOHAMED ELSOKARY ,26 ,Citadel tower ,Marasi Drive ,5586 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142555110",
        "email": "fetouh@alnassar.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_558",
      "legal_consultancy_individual_2068"
    ],
    "slug": "al-nassar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_119",
    "name": "AL OTAIBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/05/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_119",
        "address": "Ahmad Al Otaibi ,6th floor /606 ,Century 21 Tower ,Alqabayel Center ,126936 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142697670",
        "email": "info@otaibilc.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1531",
      "legal_consultancy_individual_2635",
      "legal_consultancy_individual_2636"
    ],
    "slug": "al-otaibi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_120",
    "name": "AL OWAIS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_120",
        "address": "Sultan Hadif Al Owais ,504 ,Oud Metha ,Wafi Mall ,16686 ,Dubai",
        "emirate": "Dubai",
        "phone": "97105053953 / 971509793158",
        "email": "info@alowaislegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-owais-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_121",
    "name": "AL QARI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_121",
        "address": "الخامس  ,مكاتب عود ميثاء ,فندق رافلز ,11268 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143243330",
        "email": "avocat@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_462",
      "advocacy_individual_463",
      "advocacy_individual_915",
      "legal_consultancy_individual_1850",
      "legal_consultancy_individual_2500",
      "legal_consultancy_individual_2712",
      "legal_consultancy_individual_2713"
    ],
    "slug": "al-qari-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_122",
    "name": "AL RAYA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_122",
        "address": "saadaldain ,407 ,سيتي باي مركز الاعمال  ,المستشفي الكندي ,182435 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142280908",
        "email": "alraya990@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1236",
      "advocacy_individual_1237",
      "legal_consultancy_individual_1530"
    ],
    "slug": "al-raya-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_123",
    "name": "AL REDHA & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_123",
        "address": "الثاني 201 ,مركز البخيت ,بالقرب من مركز القبائل للتخفيضات ,12020 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142664411",
        "email": "redhalaw@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1170",
      "legal_consultancy_individual_1171"
    ],
    "slug": "al-redha-company-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_124",
    "name": "AL SAFAR & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 17,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_124",
        "address": "4th floor ,Al Saaha Offices Block D office 401A ,Burj Khalifa ,283773 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144221944",
        "email": "gov.depts@alsafarpartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_927",
      "legal_consultancy_individual_166",
      "legal_consultancy_individual_407",
      "legal_consultancy_individual_481",
      "legal_consultancy_individual_1499",
      "legal_consultancy_individual_1657",
      "legal_consultancy_individual_1830",
      "legal_consultancy_individual_1831",
      "legal_consultancy_individual_1945",
      "legal_consultancy_individual_1946",
      "legal_consultancy_individual_2390",
      "legal_consultancy_individual_2391",
      "legal_consultancy_individual_2423",
      "legal_consultancy_individual_2424",
      "legal_consultancy_individual_2499",
      "legal_consultancy_individual_3219",
      "legal_consultancy_individual_3220"
    ],
    "slug": "al-safar-partners-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_125",
    "name": "AL SAHLAWI & CO ADVOCATES & CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 19,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_125",
        "address": "الطابق الخامس ,الساحة ,سوق البحار ,26011 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142277717",
        "email": "info@alsahlawico.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_401",
      "advocacy_individual_494",
      "advocacy_individual_605",
      "advocacy_individual_696",
      "advocacy_individual_697",
      "advocacy_individual_797",
      "advocacy_individual_798",
      "advocacy_individual_1313",
      "advocacy_individual_1482",
      "advocacy_individual_1483",
      "legal_consultancy_individual_751",
      "legal_consultancy_individual_752",
      "legal_consultancy_individual_859",
      "legal_consultancy_individual_1721",
      "legal_consultancy_individual_1722",
      "legal_consultancy_individual_2411",
      "legal_consultancy_individual_2412",
      "legal_consultancy_individual_3175",
      "legal_consultancy_individual_3176"
    ],
    "slug": "al-sahlawi-co-advocates-consultants"
  },
  {
    "id": "advocacy_firms_126",
    "name": "AL SAQER ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_126",
        "address": "MOUHAMAD RAMEZ YOUSSEF FUSTUQ ,212 ,DIAMOND BUSINESS CENTER 1 - B ,Dubai Miracle Garden ,81359 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142384727",
        "email": "mandflaw@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1045",
      "advocacy_individual_1046"
    ],
    "slug": "al-saqer-advocates"
  },
  {
    "id": "advocacy_firms_127",
    "name": "AL SAYYAH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 22,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_127",
        "address": "Hamdan Abdulla Mohamed Al Sayyah ,First Floor Office 108 ,Alserkal Building ,Beside Alkhoory Sky Gardens ,116499 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144491085",
        "email": "info@als-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_5",
      "legal_consultancy_individual_456",
      "legal_consultancy_individual_457",
      "legal_consultancy_individual_458",
      "legal_consultancy_individual_459",
      "legal_consultancy_individual_460",
      "legal_consultancy_individual_461",
      "legal_consultancy_individual_462",
      "legal_consultancy_individual_463",
      "legal_consultancy_individual_464",
      "legal_consultancy_individual_465",
      "legal_consultancy_individual_466",
      "legal_consultancy_individual_467",
      "legal_consultancy_individual_468",
      "legal_consultancy_individual_469",
      "legal_consultancy_individual_470",
      "legal_consultancy_individual_471",
      "legal_consultancy_individual_472",
      "legal_consultancy_individual_473",
      "legal_consultancy_individual_474",
      "legal_consultancy_individual_475",
      "legal_consultancy_individual_476"
    ],
    "slug": "al-sayyah-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_128",
    "name": "AL SHAALI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_128",
        "address": "Ibrahim Nagi ,Office 207, Level 2 ,Al Khaimah Building ,Behind Nissan Showroom ,20220 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142950001",
        "email": "info@alshaali-co.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1306",
      "legal_consultancy_individual_1256"
    ],
    "slug": "al-shaali-company-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_129",
    "name": "AL SHAMSI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "25/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_129",
        "address": "",
        "emirate": "Dubai",
        "phone": "97108307033",
        "email": "general.alshamsi@lawuae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-shamsi-partners-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_131",
    "name": "AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_131",
        "address": "7 ,سوفيتل ,محطة برج خليفة  ,8867 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143488808",
        "email": "secretary@dubailaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_268",
      "legal_consultancy_individual_668",
      "legal_consultancy_individual_1923",
      "legal_consultancy_individual_2018",
      "legal_consultancy_individual_2033",
      "legal_consultancy_individual_2034"
    ],
    "slug": "al-sharif-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_132",
    "name": "AL TAHER & AL SABRI ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/01/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_132",
        "address": "السادس , مباني الحضيبة للجوائز  ,علم الاتحاد ,200 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143545111",
        "email": "altaher_alsabri@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_81",
      "legal_consultancy_individual_847",
      "legal_consultancy_individual_1263",
      "legal_consultancy_individual_1264",
      "legal_consultancy_individual_1521",
      "legal_consultancy_individual_1522",
      "legal_consultancy_individual_1523"
    ],
    "slug": "al-taher-al-sabri-advocates"
  },
  {
    "id": "advocacy_firms_133",
    "name": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 100,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_133",
        "address": "Ban AbdulQadir ,full floors 6 and 7 ,Central Park Office Tower ,DIFC ,9275 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143641731",
        "email": "j.morris@tamimi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_201",
      "advocacy_individual_405",
      "advocacy_individual_478",
      "advocacy_individual_479",
      "advocacy_individual_547",
      "advocacy_individual_586",
      "advocacy_individual_740",
      "advocacy_individual_741",
      "advocacy_individual_802",
      "advocacy_individual_930",
      "advocacy_individual_963",
      "advocacy_individual_964",
      "advocacy_individual_996",
      "advocacy_individual_1434",
      "legal_consultancy_individual_124",
      "legal_consultancy_individual_125",
      "legal_consultancy_individual_199",
      "legal_consultancy_individual_200",
      "legal_consultancy_individual_250",
      "legal_consultancy_individual_251",
      "legal_consultancy_individual_289",
      "legal_consultancy_individual_316",
      "legal_consultancy_individual_317",
      "legal_consultancy_individual_320",
      "legal_consultancy_individual_321",
      "legal_consultancy_individual_334",
      "legal_consultancy_individual_348",
      "legal_consultancy_individual_394",
      "legal_consultancy_individual_477",
      "legal_consultancy_individual_493",
      "legal_consultancy_individual_494",
      "legal_consultancy_individual_591",
      "legal_consultancy_individual_646",
      "legal_consultancy_individual_647",
      "legal_consultancy_individual_660",
      "legal_consultancy_individual_833",
      "legal_consultancy_individual_834",
      "legal_consultancy_individual_860",
      "legal_consultancy_individual_861",
      "legal_consultancy_individual_933",
      "legal_consultancy_individual_956",
      "legal_consultancy_individual_957",
      "legal_consultancy_individual_1234",
      "legal_consultancy_individual_1249",
      "legal_consultancy_individual_1276",
      "legal_consultancy_individual_1288",
      "legal_consultancy_individual_1410",
      "legal_consultancy_individual_1411",
      "legal_consultancy_individual_1435",
      "legal_consultancy_individual_1465",
      "legal_consultancy_individual_1466",
      "legal_consultancy_individual_1518",
      "legal_consultancy_individual_1519",
      "legal_consultancy_individual_1536",
      "legal_consultancy_individual_1537",
      "legal_consultancy_individual_1711",
      "legal_consultancy_individual_1723",
      "legal_consultancy_individual_1724",
      "legal_consultancy_individual_1758",
      "legal_consultancy_individual_1779",
      "legal_consultancy_individual_1780",
      "legal_consultancy_individual_1806",
      "legal_consultancy_individual_1807",
      "legal_consultancy_individual_2007",
      "legal_consultancy_individual_2008",
      "legal_consultancy_individual_2045",
      "legal_consultancy_individual_2046",
      "legal_consultancy_individual_2091",
      "legal_consultancy_individual_2092",
      "legal_consultancy_individual_2098",
      "legal_consultancy_individual_2099",
      "legal_consultancy_individual_2179",
      "legal_consultancy_individual_2180",
      "legal_consultancy_individual_2214",
      "legal_consultancy_individual_2215",
      "legal_consultancy_individual_2303",
      "legal_consultancy_individual_2342",
      "legal_consultancy_individual_2343",
      "legal_consultancy_individual_2344",
      "legal_consultancy_individual_2506",
      "legal_consultancy_individual_2507",
      "legal_consultancy_individual_2558",
      "legal_consultancy_individual_2559",
      "legal_consultancy_individual_2615",
      "legal_consultancy_individual_2668",
      "legal_consultancy_individual_2670",
      "legal_consultancy_individual_2676",
      "legal_consultancy_individual_2677",
      "legal_consultancy_individual_2765",
      "legal_consultancy_individual_2766",
      "legal_consultancy_individual_2851",
      "legal_consultancy_individual_2852",
      "legal_consultancy_individual_2955",
      "legal_consultancy_individual_2956",
      "legal_consultancy_individual_2993",
      "legal_consultancy_individual_2994",
      "legal_consultancy_individual_3165",
      "legal_consultancy_individual_3171",
      "legal_consultancy_individual_3172",
      "legal_consultancy_individual_3195"
    ],
    "slug": "al-tamimi-company-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_134",
    "name": "AL TAMIMI & COMPANY ADVOCATES & LEGAL CONSULTANTS LLC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 16,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_134",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143641686 / 971506288801",
        "email": "b.kadir@tamimi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1188",
      "advocacy_individual_1189",
      "legal_consultancy_individual_398",
      "legal_consultancy_individual_399",
      "legal_consultancy_individual_699",
      "legal_consultancy_individual_700",
      "legal_consultancy_individual_1124",
      "legal_consultancy_individual_1125",
      "legal_consultancy_individual_2226",
      "legal_consultancy_individual_2227",
      "legal_consultancy_individual_2504",
      "legal_consultancy_individual_2505",
      "legal_consultancy_individual_2649",
      "legal_consultancy_individual_2650",
      "legal_consultancy_individual_3136",
      "legal_consultancy_individual_3137"
    ],
    "slug": "al-tamimi-company-advocates-legal-consultants-llc"
  },
  {
    "id": "advocacy_firms_135",
    "name": "AL TAMIMI & COMPANY LIMITED",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 77,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/04/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_135",
        "address": "Ban AbdulQadir ,Level 6 & Level 7 ,Central Park Tower ,DIFC  ,9275 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143641737 / 971502796684",
        "email": "j.morris@tamimi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_121",
      "legal_consultancy_individual_122",
      "legal_consultancy_individual_137",
      "legal_consultancy_individual_358",
      "legal_consultancy_individual_359",
      "legal_consultancy_individual_380",
      "legal_consultancy_individual_381",
      "legal_consultancy_individual_796",
      "legal_consultancy_individual_797",
      "legal_consultancy_individual_855",
      "legal_consultancy_individual_937",
      "legal_consultancy_individual_1055",
      "legal_consultancy_individual_1056",
      "legal_consultancy_individual_1098",
      "legal_consultancy_individual_1099",
      "legal_consultancy_individual_1112",
      "legal_consultancy_individual_1183",
      "legal_consultancy_individual_1392",
      "legal_consultancy_individual_1398",
      "legal_consultancy_individual_1399",
      "legal_consultancy_individual_1413",
      "legal_consultancy_individual_1480",
      "legal_consultancy_individual_1552",
      "legal_consultancy_individual_1607",
      "legal_consultancy_individual_1608",
      "legal_consultancy_individual_1660",
      "legal_consultancy_individual_1824",
      "legal_consultancy_individual_1825",
      "legal_consultancy_individual_1826",
      "legal_consultancy_individual_1827",
      "legal_consultancy_individual_1870",
      "legal_consultancy_individual_1871",
      "legal_consultancy_individual_1876",
      "legal_consultancy_individual_1877",
      "legal_consultancy_individual_2029",
      "legal_consultancy_individual_2030",
      "legal_consultancy_individual_2102",
      "legal_consultancy_individual_2103",
      "legal_consultancy_individual_2278",
      "legal_consultancy_individual_2281",
      "legal_consultancy_individual_2282",
      "legal_consultancy_individual_2283",
      "legal_consultancy_individual_2284",
      "legal_consultancy_individual_2285",
      "legal_consultancy_individual_2286",
      "legal_consultancy_individual_2287",
      "legal_consultancy_individual_2288",
      "legal_consultancy_individual_2289",
      "legal_consultancy_individual_2290",
      "legal_consultancy_individual_2291",
      "legal_consultancy_individual_2292",
      "legal_consultancy_individual_2293",
      "legal_consultancy_individual_2294",
      "legal_consultancy_individual_2295",
      "legal_consultancy_individual_2296",
      "legal_consultancy_individual_2297",
      "legal_consultancy_individual_2298",
      "legal_consultancy_individual_2299",
      "legal_consultancy_individual_2300",
      "legal_consultancy_individual_2301",
      "legal_consultancy_individual_2338",
      "legal_consultancy_individual_2369",
      "legal_consultancy_individual_2401",
      "legal_consultancy_individual_2402",
      "legal_consultancy_individual_2543",
      "legal_consultancy_individual_2643",
      "legal_consultancy_individual_2671",
      "legal_consultancy_individual_2905",
      "legal_consultancy_individual_2906",
      "legal_consultancy_individual_3036",
      "legal_consultancy_individual_3037",
      "legal_consultancy_individual_3074",
      "legal_consultancy_individual_3075",
      "legal_consultancy_individual_3153",
      "legal_consultancy_individual_3154",
      "legal_consultancy_individual_3157",
      "legal_consultancy_individual_3158"
    ],
    "slug": "al-tamimi-company-limited"
  },
  {
    "id": "advocacy_firms_136",
    "name": "AL WASL INTERNATIONAL GROUP - ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 11,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_136",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143212555",
        "email": "awigdubai@awiglaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_31",
      "advocacy_individual_329",
      "advocacy_individual_330",
      "advocacy_individual_846",
      "advocacy_individual_847",
      "legal_consultancy_individual_14",
      "legal_consultancy_individual_556",
      "legal_consultancy_individual_557",
      "legal_consultancy_individual_901",
      "legal_consultancy_individual_1037",
      "legal_consultancy_individual_1038"
    ],
    "slug": "al-wasl-international-group-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_137",
    "name": "AL WASL INTERNATIONAL GROUP ADVOCATES AND LEGAL CONSULTANTS- THE DUBAI TECHNOLOGY AND MEDIA FREE ZONE BRANCH",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_137",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143901155",
        "email": "legal@awigdic.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1397",
      "advocacy_individual_1398",
      "legal_consultancy_individual_1047",
      "legal_consultancy_individual_1048"
    ],
    "slug": "al-wasl-international-group-advocates-and-legal-consultants-the-dubai-technology-and-media-free-zone-branch"
  },
  {
    "id": "advocacy_firms_138",
    "name": "AL ZAHMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_138",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142865353 / 971551986013",
        "email": "info@alzahmyadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_242",
      "advocacy_individual_379"
    ],
    "slug": "al-zahmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_139",
    "name": "AL ZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_139",
        "address": "مركز وافي للتسوق  ,بلوك ايه ,خلف فندق موفنبيك ,11672 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143796990",
        "email": "alzeyoudi@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_376"
    ],
    "slug": "al-zeyoudi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_168",
    "name": "AL-KABBAN & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_168",
        "address": "29TH  ,PRISM TOWER ,J W MARRIOTT MARQUIS HOTEL  ,4790 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144539090",
        "email": "info@alkabban.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1220",
      "legal_consultancy_individual_617",
      "legal_consultancy_individual_618",
      "legal_consultancy_individual_2755",
      "legal_consultancy_individual_2756"
    ],
    "slug": "al-kabban-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_184",
    "name": "AL-SUWAIDI & COMPANY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 15,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_184",
        "address": "Samia Luqman ,2nd floor ,Emarat Atrium Building ,across Holiday Inn Express Safa Park ,7273 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143211000",
        "email": "info@alsuwaidi.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_9",
      "advocacy_individual_181",
      "advocacy_individual_182",
      "advocacy_individual_343",
      "legal_consultancy_individual_183",
      "legal_consultancy_individual_1140",
      "legal_consultancy_individual_1141",
      "legal_consultancy_individual_1851",
      "legal_consultancy_individual_1927",
      "legal_consultancy_individual_1953",
      "legal_consultancy_individual_1954",
      "legal_consultancy_individual_2478",
      "legal_consultancy_individual_2534",
      "legal_consultancy_individual_3092",
      "legal_consultancy_individual_3093"
    ],
    "slug": "al-suwaidi-company"
  },
  {
    "id": "advocacy_firms_140",
    "name": "ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_140",
        "address": "111 ,AL HATHBOUR ,CANADIAN HOSPITAL ,96555 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142656000",
        "email": "alawadhi.advocates@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_506",
      "legal_consultancy_individual_2467",
      "legal_consultancy_individual_2468"
    ],
    "slug": "alawadhi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_141",
    "name": "ALAWAMI ALMANSOORI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/01/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_141",
        "address": "Mohammed Saghaer Ali Al Awami Al Mansoori ,3 ,IT PLAZA ,Green Belt Supermarket ,25626 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143338885",
        "email": "info@alawami.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "alawami-almansoori-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_142",
    "name": "ALAWI ALJABERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_142",
        "address": "Alawi Ghaleb Ali Saeed Aljaberi ,M ,Bussiness venue building  ,al nase club ,10103 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143436652",
        "email": "ajadvo017@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_264",
      "legal_consultancy_individual_2136"
    ],
    "slug": "alawi-aljaberi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_143",
    "name": "ALBALOOSHI AND ALMARASHIDA ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/01/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_143",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143333245 / 97143333245",
        "email": "y.albulooshi@yhadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_134",
      "advocacy_individual_290",
      "advocacy_individual_1448",
      "advocacy_individual_1449",
      "advocacy_individual_1485",
      "advocacy_individual_1486",
      "legal_consultancy_individual_225",
      "legal_consultancy_individual_352",
      "legal_consultancy_individual_869",
      "legal_consultancy_individual_870"
    ],
    "slug": "albalooshi-and-almarashida-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_144",
    "name": "ALBANNAI & CO.",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_144",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142946164",
        "email": "info@albannai-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_940",
      "legal_consultancy_individual_941",
      "legal_consultancy_individual_1229",
      "legal_consultancy_individual_1230",
      "legal_consultancy_individual_2657",
      "legal_consultancy_individual_2658"
    ],
    "slug": "albannai-co"
  },
  {
    "id": "advocacy_firms_145",
    "name": "ALEASIMA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/05/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_145",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144470190",
        "email": "maged.elfawal@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1374",
      "advocacy_individual_1375"
    ],
    "slug": "aleasima-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_146",
    "name": "ALGHARIB & PARTNERS ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "30/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_146",
        "address": "الطابق الثاني - مكتب رقم 203 و 204  ,سيتي أفينو ,سيتى سنتر ديرة  ,83666 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142955050",
        "email": "adv.algharib@alghariblawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "algharib-partners-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_148",
    "name": "ALHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/04/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_148",
        "address": "Hamad Abdul wahab alqawadi ,الطابق العاشر / مكتب 1002 ,فندق ذا اتش  ,المركز التجاري  ,00000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145681225",
        "email": "alhamad_advo@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1106"
    ],
    "slug": "alhamad-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_149",
    "name": "ALHASHIMI LAW FIRMS AND LEGAL CONSULTING",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_149",
        "address": "HASHIM SAYED AHMED SAYED A RAHIM ALHASHIMI ,ZOOM ,بناية مكاتب ,مقابل معرض تويوتا - خلف وكالة نيسان ,2852 ,Dubai",
        "emirate": "Dubai",
        "phone": "",
        "email": "lawyers@alhashimi-lf.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_6"
    ],
    "slug": "alhashimi-law-firms-and-legal-consulting"
  },
  {
    "id": "advocacy_firms_150",
    "name": "ALHEFEITI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_150",
        "address": "13 ,Fairmont Hotel ,World Trade Centre metro station ,187082 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142367881",
        "email": "info@alhefeitilaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "alhefeiti-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_151",
    "name": "ALI AHMED ALDIQQI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/05/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_151",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143384004 / 971566651137",
        "email": "aaldiqqi@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_274",
      "advocacy_individual_275"
    ],
    "slug": "ali-ahmed-aldiqqi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_152",
    "name": "ALI AL MANNAEI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_152",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142552008",
        "email": "info@alialmannaei.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_272",
      "advocacy_individual_273"
    ],
    "slug": "ali-al-mannaei-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_153",
    "name": "ALI AL NUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_153",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143241116 / 971501264770",
        "email": "info@uaealnuaimi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ali-al-nuaimi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_154",
    "name": "ALI AL SHIMMARI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/02/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_154",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142500717",
        "email": "alishamrilawfirm@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_280",
      "advocacy_individual_281",
      "legal_consultancy_individual_526",
      "legal_consultancy_individual_527",
      "legal_consultancy_individual_1267"
    ],
    "slug": "ali-al-shimmari-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_155",
    "name": "ALI ALETER ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/10/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_155",
        "address": "ali mohamed saif ,مكتب 1501 ,داماس ,رقة البطين ,25900 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142555779 / 971553616616",
        "email": "info@aleter.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ali-aleter-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_156",
    "name": "ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/03/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_156",
        "address": "110 ,بناية مكاتب عود ميثاء R338 ,مقابل وافى مول وفندق رافلز دبى ,624494 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143231881",
        "email": "info@alialhammadi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_266"
    ],
    "slug": "ali-alhammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_157",
    "name": "ALI ALSHOWAB ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/03/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_157",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144205111",
        "email": "info@showab.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_314",
      "advocacy_individual_403"
    ],
    "slug": "ali-alshowab-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_158",
    "name": "ALI BIN TAMIM & CO ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_158",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142689978",
        "email": "info@abtadvo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ali-bin-tamim-co-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_159",
    "name": "ALI HABIB AND ASSOCIATES ADVOCATES AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_159",
        "address": "",
        "emirate": "Dubai",
        "phone": "97100000000",
        "email": "dubai@ahlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_14",
      "advocacy_individual_1376",
      "advocacy_individual_1377"
    ],
    "slug": "ali-habib-and-associates-advocates-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_160",
    "name": "ALI HASAN ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/11/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_160",
        "address": "التاسع ,مكتب 903 ملك خالد عبدالرحيم احمد العطار - ذا تاور بلازا ,ذا تاور بلازا ,38350 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145873377 / 971564643109",
        "email": "ahm@ahmlawfirms.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_279"
    ],
    "slug": "ali-hasan-alhammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_161",
    "name": "ALI IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_161",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142280002",
        "email": "advoali2020@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_284",
      "advocacy_individual_285",
      "advocacy_individual_1469",
      "legal_consultancy_individual_178",
      "legal_consultancy_individual_179",
      "legal_consultancy_individual_904",
      "legal_consultancy_individual_2002",
      "legal_consultancy_individual_2003",
      "legal_consultancy_individual_2804",
      "legal_consultancy_individual_2805"
    ],
    "slug": "ali-ibrahim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_162",
    "name": "ALI KHALAF ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/03/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_162",
        "address": "برج المناره ,برج المناره ,فندق جي دبليو ماريوت ماركيز ,135574 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144226166 / 971506464911",
        "email": "info@alialhosani.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ali-khalaf-alhosani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_163",
    "name": "ALI MUSABBAH ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/04/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_163",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143334212",
        "email": "secretary@alimusabbah.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_304",
      "advocacy_individual_654",
      "advocacy_individual_655"
    ],
    "slug": "ali-musabbah-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_164",
    "name": "ALI NAQI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/04/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_164",
        "address": "ali mohamed amin  ,205 - 104  ,اثراء  ,بالقرب من فندق جميرا طيران الامارات  ,10155 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143967188",
        "email": "aliadvocates71@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_294",
      "legal_consultancy_individual_1088",
      "legal_consultancy_individual_1089",
      "legal_consultancy_individual_1772",
      "legal_consultancy_individual_1909",
      "legal_consultancy_individual_1910"
    ],
    "slug": "ali-naqi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_165",
    "name": "ALI OBAID ALSHAMSI LAWYERS & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/02/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_165",
        "address": "1606 ,فندق الكونراد - برج المكاتب ,فندق الفيرمونت ,84333 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142218787 / 971505773332",
        "email": "info@alshamsilawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_306"
    ],
    "slug": "ali-obaid-alshamsi-lawyers-legal-consultants"
  },
  {
    "id": "advocacy_firms_166",
    "name": "ALI YOUSUF ALAWADHI ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/11/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_166",
        "address": "",
        "emirate": "Dubai",
        "phone": "97122222222",
        "email": "info@ayalegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_321",
      "legal_consultancy_individual_345",
      "legal_consultancy_individual_346",
      "legal_consultancy_individual_3000"
    ],
    "slug": "ali-yousuf-alawadhi-advocates-legal-consultants-llc"
  },
  {
    "id": "advocacy_firms_167",
    "name": "ALIA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_167",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148876711",
        "email": "info@alattarlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "alia-alattar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_169",
    "name": "ALLIED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_169",
        "address": "403 ,الطابق الاول مكتب 101 ,بناية الكنال سنترال ,اكاديمية هايونداي للتدريب  ,90209 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142970007",
        "email": "altdamon@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_955",
      "advocacy_individual_956",
      "legal_consultancy_individual_585",
      "legal_consultancy_individual_586"
    ],
    "slug": "allied-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_170",
    "name": "ALMASA ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_170",
        "address": "FATIMA MOHAMMAD ALMAZAM ,3RD FLOOR ,LIBERTY ,BESIDE BANK OF SHARJAH ,35630 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142822278",
        "email": "tanany@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_529",
      "advocacy_individual_530",
      "legal_consultancy_individual_3007",
      "legal_consultancy_individual_3008"
    ],
    "slug": "almasa-advocates"
  },
  {
    "id": "advocacy_firms_171",
    "name": "ALMUBASHERI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_171",
        "address": "611-612 ,مباني الحضيبة للجوائز  ,متحف الإتحاد ,6178 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143589998 / 971553690566",
        "email": "info@mublegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "almubasheri-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_172",
    "name": "ALNAQBI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 20,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_172",
        "address": "YASIR AL NAQBI ,21 ,48 BURJ ,SOFITEL DOWN  TOWN ,181111 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142689949",
        "email": "info@alnaqbipartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_742",
      "advocacy_individual_782",
      "advocacy_individual_783",
      "advocacy_individual_1254",
      "advocacy_individual_1255",
      "advocacy_individual_1465",
      "advocacy_individual_1466",
      "legal_consultancy_individual_322",
      "legal_consultancy_individual_686",
      "legal_consultancy_individual_890",
      "legal_consultancy_individual_903",
      "legal_consultancy_individual_1003",
      "legal_consultancy_individual_1179",
      "legal_consultancy_individual_1235",
      "legal_consultancy_individual_1275",
      "legal_consultancy_individual_1534",
      "legal_consultancy_individual_1535",
      "legal_consultancy_individual_1810",
      "legal_consultancy_individual_1811",
      "legal_consultancy_individual_1896"
    ],
    "slug": "alnaqbi-partners-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_173",
    "name": "ALNASR OFFCE ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_173",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142989455",
        "email": "adv_nasr@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_332",
      "advocacy_individual_1115",
      "advocacy_individual_1116",
      "advocacy_individual_1162",
      "advocacy_individual_1163"
    ],
    "slug": "alnasr-offce-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_174",
    "name": "ALOBAIDLI & ALZAROONI ADVOCATES&LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_174",
        "address": "ادارة ا لمبنى  ,الريم ,الاتصالات  ,42423 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222066",
        "email": "info@ozleco.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_211",
      "advocacy_individual_282",
      "advocacy_individual_283",
      "advocacy_individual_426",
      "advocacy_individual_427",
      "advocacy_individual_1156",
      "advocacy_individual_1157",
      "advocacy_individual_1280",
      "advocacy_individual_1281",
      "legal_consultancy_individual_1917",
      "legal_consultancy_individual_1965",
      "legal_consultancy_individual_1966"
    ],
    "slug": "alobaidli-alzarooni-advocateslegal-consultants"
  },
  {
    "id": "advocacy_firms_175",
    "name": "ALOMAR & ALSABAH ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/09/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_175",
        "address": "omar abdulazizi alomar ,15 ,prime tower ,blom bank france ,211940 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143808838 / 971504598082",
        "email": "omar.omar@oghlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_965",
      "advocacy_individual_966",
      "legal_consultancy_individual_184",
      "legal_consultancy_individual_185",
      "legal_consultancy_individual_186",
      "legal_consultancy_individual_1699",
      "legal_consultancy_individual_1951",
      "legal_consultancy_individual_1952",
      "legal_consultancy_individual_2839",
      "legal_consultancy_individual_2840",
      "legal_consultancy_individual_3166",
      "legal_consultancy_individual_3167"
    ],
    "slug": "alomar-alsabah-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_176",
    "name": "ALOTAIBA & HAMDAN BUDEBES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_176",
        "address": "HAMDAN BUDEBES  ,1614 ,BLUE BAY TOWER ,BUSINESS BAY ,127637 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142505612",
        "email": "info-dubai@alotaiba-law.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_600",
      "advocacy_individual_601",
      "advocacy_individual_1184",
      "advocacy_individual_1185"
    ],
    "slug": "alotaiba-hamdan-budebes-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_177",
    "name": "ALOWAIS & AL MATROOSHI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/01/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_177",
        "address": "Mezzanine / 09 ,Business Point  ,Behind Nissan Showroom ,85825 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142595777",
        "email": "ALMATROOSHI@OMALC.AE",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1043",
      "advocacy_individual_1044",
      "legal_consultancy_individual_1118",
      "legal_consultancy_individual_1119",
      "legal_consultancy_individual_1971",
      "legal_consultancy_individual_1972",
      "legal_consultancy_individual_2592"
    ],
    "slug": "alowais-al-matrooshi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_178",
    "name": "ALPHA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_178",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 97151111146",
        "email": "info@alphalegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_539",
      "advocacy_individual_1051",
      "advocacy_individual_1052"
    ],
    "slug": "alpha-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_179",
    "name": "ALRAAISI & ALOWAIS ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/03/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_179",
        "address": "samia ibrahim hassan ahmed alraisi ,الميزانين مكتب رقم 8 ,الطوار سنتر ,بجوار وزارة التربية والتعليم  ووزارة العدل ,239353 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142680030 / 971503004400",
        "email": "info@aalegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "alraaisi-alowais-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_180",
    "name": "ALRASHEED & PARTNERS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_180",
        "address": "6 ,Business Point ,Nissan Showroom  ,443 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142999991",
        "email": "dubai@alrasheed.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_202",
      "advocacy_individual_203",
      "advocacy_individual_388",
      "advocacy_individual_725",
      "advocacy_individual_1059",
      "advocacy_individual_1060",
      "legal_consultancy_individual_1687"
    ],
    "slug": "alrasheed-partners"
  },
  {
    "id": "advocacy_firms_181",
    "name": "ALSAEEDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_181",
        "address": "almetaq insurance  ,alnouf tower ,business vilage  ,92422 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142974555",
        "email": "info@alsaeedilaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1",
      "advocacy_individual_2",
      "advocacy_individual_239",
      "advocacy_individual_364"
    ],
    "slug": "alsaeedi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_182",
    "name": "ALSALMAN ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_182",
        "address": "2 ,BUSINESS AVENUE BUILDING ,NISSAN SHOWROOM  ,95230 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142999099",
        "email": "info@alsalmanadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_811",
      "legal_consultancy_individual_47",
      "legal_consultancy_individual_48"
    ],
    "slug": "alsalman-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_183",
    "name": "ALSHAIBA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_183",
        "address": "MOHAMED IBRAHIM HASSAN ALSHAIBA ,KANA CAF ,51TOWER ,KANA CAFE ,35351 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142384444",
        "email": "Alshaiba@alshaibaadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1037",
      "advocacy_individual_1038",
      "legal_consultancy_individual_2699",
      "legal_consultancy_individual_2700"
    ],
    "slug": "alshaiba-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_185",
    "name": "AMAL AL RASHDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/12/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_185",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142414303",
        "email": "info@eslegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_342",
      "legal_consultancy_individual_928",
      "legal_consultancy_individual_929"
    ],
    "slug": "amal-al-rashdi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_186",
    "name": "AMAL ALBASTAKI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 17,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_186",
        "address": "amal albastaki ,1903 ,court ,business bay ,127477 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142522202",
        "email": "info@amaladvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_345",
      "advocacy_individual_1006",
      "legal_consultancy_individual_390",
      "legal_consultancy_individual_391",
      "legal_consultancy_individual_876",
      "legal_consultancy_individual_949",
      "legal_consultancy_individual_950",
      "legal_consultancy_individual_1160",
      "legal_consultancy_individual_1161",
      "legal_consultancy_individual_1694",
      "legal_consultancy_individual_1695",
      "legal_consultancy_individual_1884",
      "legal_consultancy_individual_1885",
      "legal_consultancy_individual_2476",
      "legal_consultancy_individual_2495",
      "legal_consultancy_individual_3001",
      "legal_consultancy_individual_3002"
    ],
    "slug": "amal-albastaki-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_187",
    "name": "AMAL ALSUBAEI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_187",
        "address": "1302/ مكتب 1302 ,فندق الفيرمونت ,محطة مترو المركز التجاري ,33026 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143586113",
        "email": "info@ablawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_349",
      "legal_consultancy_individual_579"
    ],
    "slug": "amal-alsubaei-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_188",
    "name": "AMAL KHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/10/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_188",
        "address": "Amal Khamis Darwish Al Blooshi ,floor23-office2304 ,Aspect Tower ,Bay Avenue ,103951 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142276165",
        "email": "info@amalkhamisadvo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_346",
      "advocacy_individual_356",
      "advocacy_individual_480",
      "advocacy_individual_481",
      "legal_consultancy_individual_248",
      "legal_consultancy_individual_249"
    ],
    "slug": "amal-khamis-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_189",
    "name": "AMANI ALKINDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/09/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_189",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148328997",
        "email": "info@alkindiadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_352",
      "legal_consultancy_individual_1233",
      "legal_consultancy_individual_1423"
    ],
    "slug": "amani-alkindi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_190",
    "name": "AMER AL MARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_190",
        "address": "Amer Sayed Al Marzooqi ,603 ,SAMA TOWER ,TRADE CENTER ,41727 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142500023",
        "email": "info@mlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_192",
      "legal_consultancy_individual_1103"
    ],
    "slug": "amer-al-marzooqi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_191",
    "name": "AMIRA SAQER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/06/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_191",
        "address": "B2207 ,لطيفة تاور ,بجانب فندق فوكو دبي‎ ,410889 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143447557",
        "email": "info@amirasaqeradvo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_362",
      "legal_consultancy_individual_215",
      "legal_consultancy_individual_1193"
    ],
    "slug": "amira-saqer-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_192",
    "name": "AMIRI ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/11/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_192",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142999926",
        "email": "amiriadvocates@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_200",
      "advocacy_individual_293"
    ],
    "slug": "amiri-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_193",
    "name": "AMMAR ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "01/02/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_193",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144298492",
        "email": "Ammaraalmulla@GMAIL.COM",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ammar-almulla-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_195",
    "name": "AMNA ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/06/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_195",
        "address": "amna alzaabi ,213 ,مبنى مكاتب عود ميثاء ,سيتي بنك ,16189 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145822422",
        "email": "info@amnalegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_368",
      "advocacy_individual_553",
      "legal_consultancy_individual_37",
      "legal_consultancy_individual_1929"
    ],
    "slug": "amna-alzaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_196",
    "name": "APEX JURIS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "06/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_196",
        "address": "TWENTY ,ALMASRAF TOWER ,DUBAI MUNICIPALITY ,3858 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222314",
        "email": "apxjuris@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "apex-juris-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_198",
    "name": "ARIF BUSHAQER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_198",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145770472",
        "email": "bushaqer4@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_385",
      "legal_consultancy_individual_1704",
      "legal_consultancy_individual_1705"
    ],
    "slug": "arif-bushaqer-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_199",
    "name": "ASHWAQ QAID ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/08/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_199",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148812191 / 971526343439",
        "email": "info@aqadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_386",
      "legal_consultancy_individual_2111",
      "legal_consultancy_individual_2112"
    ],
    "slug": "ashwaq-qaid-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_200",
    "name": "ASMA ALI ALMESSABI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_200",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143269559 / 971552095466",
        "email": "admin@asmaadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_389"
    ],
    "slug": "asma-ali-almessabi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_201",
    "name": "ASMAA ABULLA ALABDOULI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/10/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_201",
        "address": "Second Floor - Office B2 ,Al Khor Tower ,Makani No: 3027595041 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143322613 / 971527759923",
        "email": "asmaaalabdouliadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_392"
    ],
    "slug": "asmaa-abulla-alabdouli-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_202",
    "name": "ASMAA ALTAMIMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/12/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_202",
        "address": "",
        "emirate": "Dubai",
        "phone": "97100000000",
        "email": "info@lawyeraaltamimi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_393"
    ],
    "slug": "asmaa-altamimi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_203",
    "name": "AWAD ALARYANI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/06/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_203",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143444491 / 971508002092",
        "email": "awdfms@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_437",
      "legal_consultancy_individual_324"
    ],
    "slug": "awad-alaryani-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_204",
    "name": "AWADH ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/11/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_204",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971509449447",
        "email": "awadh.a.lflc@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_394"
    ],
    "slug": "awadh-almheiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_205",
    "name": "AWATIF MOHAMMAD SHOQI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_205",
        "address": "29 ,ذا اتش هوتيل ,فندق فيرمونت ,40073 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143254000",
        "email": "info@alrowaad.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_395",
      "advocacy_individual_987",
      "advocacy_individual_1491",
      "advocacy_individual_1492",
      "legal_consultancy_individual_386",
      "legal_consultancy_individual_978",
      "legal_consultancy_individual_1164",
      "legal_consultancy_individual_1165",
      "legal_consultancy_individual_1481",
      "legal_consultancy_individual_1482"
    ],
    "slug": "awatif-mohammad-shoqi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_206",
    "name": "AYESHA AL JAZIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_206",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "info@aljaziriadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_399"
    ],
    "slug": "ayesha-al-jaziri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_207",
    "name": "AYESHA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/02/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_207",
        "address": "Office 308 ,Owned by ACICO Gulf Real Estate LLC, Dubai branch ,Makani No: 3250094543 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142697998 / 971503567998",
        "email": "info@ayshamslaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_402",
      "legal_consultancy_individual_628",
      "legal_consultancy_individual_629"
    ],
    "slug": "ayesha-aldhaheri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_208",
    "name": "AZZA EBRAHIM HASAN ALMULLA ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "17/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_208",
        "address": "Azza Ebrahim Hasan Almulla ,6(602-603) ,Al Shoalla Building (Al Naboodah) ,deira city center ,12871 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142950010",
        "email": "dubai-secretary@dralmulla.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "azza-ebrahim-hasan-almulla-advocates-and-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_11",
    "name": "Abdalla AlZaabi Legal Consultants L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_11",
        "address": "Office No.WH2-04A-M-52 ,P2/Block A ,Saih Shuaib 3 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97140000000 / 971525525252",
        "email": "alzaabbi@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_0",
      "legal_consultancy_individual_1298",
      "legal_consultancy_individual_1299"
    ],
    "slug": "abdalla-alzaabi-legal-consultants-llc"
  },
  {
    "id": "legal_consultancy_firms_1",
    "name": "Acker Choquette Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/01/1997",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_1",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143550004 / 971506246248",
        "email": "canlaw@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_18",
      "legal_consultancy_individual_19",
      "legal_consultancy_individual_817"
    ],
    "slug": "acker-choquette-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_2",
    "name": "Addleshaw Goddard (Middle East) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "24/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_2",
        "address": "6 ,Office Nos. 603, 604 & 605, Level 6, Burj Daman ,Dubai International Financial Centre ,506555 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143506400 / 971504654755",
        "email": "r.hickman@aglaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "addleshaw-goddard-middle-east-llp"
  },
  {
    "id": "legal_consultancy_firms_3",
    "name": "Afridi & Angell-DED",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 67,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/01/1975",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_3",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_3",
      "legal_consultancy_individual_4",
      "legal_consultancy_individual_228",
      "legal_consultancy_individual_229",
      "legal_consultancy_individual_270",
      "legal_consultancy_individual_295",
      "legal_consultancy_individual_401",
      "legal_consultancy_individual_502",
      "legal_consultancy_individual_603",
      "legal_consultancy_individual_604",
      "legal_consultancy_individual_622",
      "legal_consultancy_individual_687",
      "legal_consultancy_individual_688",
      "legal_consultancy_individual_689",
      "legal_consultancy_individual_690",
      "legal_consultancy_individual_708",
      "legal_consultancy_individual_709",
      "legal_consultancy_individual_769",
      "legal_consultancy_individual_770",
      "legal_consultancy_individual_856",
      "legal_consultancy_individual_1031",
      "legal_consultancy_individual_1032",
      "legal_consultancy_individual_1039",
      "legal_consultancy_individual_1040",
      "legal_consultancy_individual_1384",
      "legal_consultancy_individual_1593",
      "legal_consultancy_individual_1633",
      "legal_consultancy_individual_1640",
      "legal_consultancy_individual_1641",
      "legal_consultancy_individual_1650",
      "legal_consultancy_individual_1651",
      "legal_consultancy_individual_1652",
      "legal_consultancy_individual_1725",
      "legal_consultancy_individual_1726",
      "legal_consultancy_individual_1738",
      "legal_consultancy_individual_1753",
      "legal_consultancy_individual_1754",
      "legal_consultancy_individual_2075",
      "legal_consultancy_individual_2324",
      "legal_consultancy_individual_2349",
      "legal_consultancy_individual_2350",
      "legal_consultancy_individual_2367",
      "legal_consultancy_individual_2457",
      "legal_consultancy_individual_2458",
      "legal_consultancy_individual_2462",
      "legal_consultancy_individual_2485",
      "legal_consultancy_individual_2486",
      "legal_consultancy_individual_2551",
      "legal_consultancy_individual_2552",
      "legal_consultancy_individual_2588",
      "legal_consultancy_individual_2589",
      "legal_consultancy_individual_2595",
      "legal_consultancy_individual_2596",
      "legal_consultancy_individual_2631",
      "legal_consultancy_individual_2632",
      "legal_consultancy_individual_2645",
      "legal_consultancy_individual_2646",
      "legal_consultancy_individual_2759",
      "legal_consultancy_individual_2760",
      "legal_consultancy_individual_2773",
      "legal_consultancy_individual_2815",
      "legal_consultancy_individual_2816",
      "legal_consultancy_individual_2927",
      "legal_consultancy_individual_2983",
      "legal_consultancy_individual_2984",
      "legal_consultancy_individual_3057",
      "legal_consultancy_individual_3058"
    ],
    "slug": "afridi-angell-ded"
  },
  {
    "id": "legal_consultancy_firms_4",
    "name": "Afridi & Angell-DIFC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/01/1975",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_4",
        "address": "- ,Index Tower ,Dubai International Financial Centre ,9371 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143303900 / 971561753537",
        "email": "christopher@afridi-angell.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "afridi-angell-difc"
  },
  {
    "id": "legal_consultancy_firms_6",
    "name": "Akin Gump Strauss Hauer & Feld LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 18,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/05/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_6",
        "address": "ICD Brookfield Place ,DIFC ,120109 ,",
        "emirate": "Dubai",
        "phone": "97143173000 / 971504465229",
        "email": "DubaiLAD@akingump.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1020",
      "legal_consultancy_individual_1021",
      "legal_consultancy_individual_1438",
      "legal_consultancy_individual_1594",
      "legal_consultancy_individual_1698",
      "legal_consultancy_individual_2275",
      "legal_consultancy_individual_2584",
      "legal_consultancy_individual_2663",
      "legal_consultancy_individual_2664",
      "legal_consultancy_individual_2880",
      "legal_consultancy_individual_2881",
      "legal_consultancy_individual_3062",
      "legal_consultancy_individual_3198",
      "legal_consultancy_individual_3199",
      "legal_consultancy_individual_422",
      "legal_consultancy_individual_423",
      "legal_consultancy_individual_499",
      "legal_consultancy_individual_500"
    ],
    "slug": "akin-gump-strauss-hauer-feld-llp"
  },
  {
    "id": "legal_consultancy_firms_17",
    "name": "Al Montasser Business Law Consultancy Centre",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/06/2003",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_17",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143467333 / 971505357973",
        "email": "info@emilawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1002"
    ],
    "slug": "al-montasser-business-law-consultancy-centre"
  },
  {
    "id": "legal_consultancy_firms_8",
    "name": "Al Noor Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "20/09/2003",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_8",
        "address": "MARYAM AHMAD BLDG ,Al Barha ,45777 ,",
        "emirate": "Dubai",
        "phone": "97143117401 / 971508537396",
        "email": "faiq@alchalaby.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-noor-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_10",
    "name": "Al Zubi & Partners Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "14/04/2001",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_10",
        "address": "Emirates Tower LLC ,Trade Centre 2 Dubai ,487915 ,",
        "emirate": "Dubai",
        "phone": "97145548182 / 971559921117",
        "email": "hqzubi@zubipartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "al-zubi-partners-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_21",
    "name": "Alameeri Legal Consultants L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/02/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_21",
        "address": "Opal Tower ,Dubai ,392087 ,",
        "emirate": "Dubai",
        "phone": "/ 971501152345",
        "email": "info@alameeri-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1180",
      "legal_consultancy_individual_1181"
    ],
    "slug": "alameeri-legal-consultants-llc"
  },
  {
    "id": "legal_consultancy_firms_22",
    "name": "Altieri Firm L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "23/03/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_22",
        "address": "The Binary by Omniyat ,Business Bay ,371473 ,",
        "emirate": "Dubai",
        "phone": "97156288020 / 971562880200",
        "email": "chad@gsilaw.global",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "altieri-firm-llc"
  },
  {
    "id": "legal_consultancy_firms_24",
    "name": "Anders Legal Consultancy LLC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "21/05/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_24",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143275888 / 971504506620",
        "email": "anders@anders.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "anders-legal-consultancy-llc"
  },
  {
    "id": "legal_consultancy_firms_26",
    "name": "Anjarwalla, Collins and Haidermota Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "01/08/2010",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_26",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144529091 / 971552805308",
        "email": "ashafi@ach-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "anjarwalla-collins-and-haidermota-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_28",
    "name": "Antoun Milan Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "30/10/2001",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_28",
        "address": "TWIN TOWERS -  ,AL RIGA ,42001 ,",
        "emirate": "Dubai",
        "phone": "97142281212 / 971504595431",
        "email": "milanlawfirm@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "antoun-milan-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_30",
    "name": "Ashish Mehta & Associates Legal Consultants LLC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/04/2000",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_30",
        "address": "Saeed Tower 2 ,Sheikh Zayed Road ,32045 ,",
        "emirate": "Dubai",
        "phone": "97143518989 / 971506466213",
        "email": "ashish.mehta@amalawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ashish-mehta-associates-legal-consultants-llc"
  },
  {
    "id": "legal_consultancy_firms_31",
    "name": "Ashurst LLP Legal Consultants Dubai Branch-DED",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/06/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_31",
        "address": "NA ,Park Lane Tower ,NA ,119974 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143652000 / 971504515630",
        "email": "david.charlier@ashurst.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_600"
    ],
    "slug": "ashurst-llp-legal-consultants-dubai-branch-ded"
  },
  {
    "id": "legal_consultancy_firms_32",
    "name": "Azhari Legal Consultancy",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "30/07/2004",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_32",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144473557 / 971506884811",
        "email": "ceo@azhari-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "azhari-legal-consultancy"
  },
  {
    "id": "advocacy_firms_210",
    "name": "B S A AHMED BIN HAZEEM & ASSOCIATES LLP - DIFC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 45,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_210",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143685555",
        "email": "maisa.maarouf@bsabh.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_435",
      "advocacy_individual_1385",
      "legal_consultancy_individual_174",
      "legal_consultancy_individual_176",
      "legal_consultancy_individual_177",
      "legal_consultancy_individual_532",
      "legal_consultancy_individual_533",
      "legal_consultancy_individual_593",
      "legal_consultancy_individual_758",
      "legal_consultancy_individual_775",
      "legal_consultancy_individual_821",
      "legal_consultancy_individual_822",
      "legal_consultancy_individual_1111",
      "legal_consultancy_individual_1156",
      "legal_consultancy_individual_1157",
      "legal_consultancy_individual_1166",
      "legal_consultancy_individual_1167",
      "legal_consultancy_individual_1395",
      "legal_consultancy_individual_1396",
      "legal_consultancy_individual_1432",
      "legal_consultancy_individual_1507",
      "legal_consultancy_individual_1508",
      "legal_consultancy_individual_1584",
      "legal_consultancy_individual_1770",
      "legal_consultancy_individual_1771",
      "legal_consultancy_individual_1789",
      "legal_consultancy_individual_1795",
      "legal_consultancy_individual_1858",
      "legal_consultancy_individual_1859",
      "legal_consultancy_individual_1928",
      "legal_consultancy_individual_2056",
      "legal_consultancy_individual_2057",
      "legal_consultancy_individual_2169",
      "legal_consultancy_individual_2170",
      "legal_consultancy_individual_2171",
      "legal_consultancy_individual_2172",
      "legal_consultancy_individual_2576",
      "legal_consultancy_individual_2577",
      "legal_consultancy_individual_2590",
      "legal_consultancy_individual_2672",
      "legal_consultancy_individual_2673",
      "legal_consultancy_individual_2691",
      "legal_consultancy_individual_2692",
      "legal_consultancy_individual_3068",
      "legal_consultancy_individual_3069"
    ],
    "slug": "b-s-a-ahmed-bin-hazeem-associates-llp-difc"
  },
  {
    "id": "advocacy_firms_211",
    "name": "BADER HAMAD ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/12/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_211",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142555111 / 971500000000",
        "email": "info@legalemirates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_415"
    ],
    "slug": "bader-hamad-alzaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_212",
    "name": "BAITULHIKMA LAWYERS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_212",
        "address": "الطابق 8 مكتب رقم 802-804 ,AL MASAOOD TOWE 2 ,الفطيم للسيارات  - ديرة  ,31909 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142946948",
        "email": "hadi.jomah@baitulhikma.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1401",
      "advocacy_individual_1402"
    ],
    "slug": "baitulhikma-lawyers"
  },
  {
    "id": "advocacy_firms_213",
    "name": "BAMEDHAF ASSOCIATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_213",
        "address": "M4 ,DAR AL SAFIYA BLDG ,مستشفى إن إم سي ,40403 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142294666",
        "email": "bamlegal@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_82",
      "advocacy_individual_83"
    ],
    "slug": "bamedhaf-associates"
  },
  {
    "id": "advocacy_firms_214",
    "name": "BASHAR ALMASAYBA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/07/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_214",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143266669 / 971505479696",
        "email": "almasayba@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_420",
      "legal_consultancy_individual_173"
    ],
    "slug": "bashar-almasayba-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_215",
    "name": "BIN EID ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "23/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_215",
        "address": "ABDULLKAREIM AHMED ABDULLA EID ,الطابق الثانى - مكتب رقم 014 ,مركز الممزر  ,مقابل القياده العامه لشرطة دبي - بجوار مكتب وزارة العمل والعمال القديم  ,89505 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142388850",
        "email": "bineidadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "bin-eid-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_217",
    "name": "BIN ISMAIL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_217",
        "address": "10 ,Rigga Al Bateen Plaza Building ,اعلي مطعم صدف الايراني  ,115791 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142666352",
        "email": "bnesmael@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "bin-ismail-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_218",
    "name": "BIN KHALFOON ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_218",
        "address": "الرابع ,ذا اتريوم سنتر ,محطة مترو الفهيدي ,33773 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143795050",
        "email": "lawyerbk@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_173",
      "advocacy_individual_174"
    ],
    "slug": "bin-khalfoon-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_219",
    "name": "BIN MESHAR & CO ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/09/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_219",
        "address": "4th Floor – offices 408 - 411 - 412 ,Business Village Building  - Block B ,Near Clock Tower ,49425 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143869999 / 971506446650",
        "email": "advocates@binmeshar.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_199",
      "legal_consultancy_individual_55",
      "legal_consultancy_individual_56",
      "legal_consultancy_individual_2340"
    ],
    "slug": "bin-meshar-co-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_220",
    "name": "BIN SEVAN ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 9,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_220",
        "address": "Firas Hassan Al Choufi ,701 ,The Prime Tower ,Makani No: 25836 86879 ,125305 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144357246",
        "email": "info@binsevanadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_170",
      "legal_consultancy_individual_1007",
      "legal_consultancy_individual_2363",
      "legal_consultancy_individual_2477",
      "legal_consultancy_individual_2483",
      "legal_consultancy_individual_2484",
      "legal_consultancy_individual_2582",
      "legal_consultancy_individual_2583",
      "legal_consultancy_individual_3216"
    ],
    "slug": "bin-sevan-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_221",
    "name": "BIN SOWAIDAN ADVOCATES & LEGAL CONSULTANTCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_221",
        "address": "4 ,ALHUDIBA AWARD COMPLEX BLOCK B ,UNION FLAG HOUSE ,50229 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143258888 / 971501009595",
        "email": "hr@binsowaidan.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_47",
      "advocacy_individual_48",
      "advocacy_individual_830",
      "advocacy_individual_851",
      "advocacy_individual_1339",
      "advocacy_individual_1340",
      "legal_consultancy_individual_344"
    ],
    "slug": "bin-sowaidan-advocates-legal-consultantcy"
  },
  {
    "id": "advocacy_firms_222",
    "name": "BUJESSAIM & AL MALIKI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_222",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142221758 / 971506984647",
        "email": "droit@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1206",
      "legal_consultancy_individual_1702"
    ],
    "slug": "bujessaim-al-maliki-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_223",
    "name": "BUSIT ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_223",
        "address": "OBAID SAQER OBAID BUSIT ,20 ,Grosvenor Business Tower -  ,Sheikha noora tower ,333341 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144472777",
        "email": "busit@busitlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1341",
      "advocacy_individual_1342",
      "legal_consultancy_individual_1545"
    ],
    "slug": "busit-advocates-and-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_34",
    "name": "Baker Botts LLP Legal Consultants Dubai Branch",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "24/01/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_34",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144363636 / 971505572900",
        "email": "hassan.elsayed@bakerbotts.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "baker-botts-llp-legal-consultants-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_36",
    "name": "Bayat Legal Services",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "13/10/1993",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_36",
        "address": "Al Moosa tower 2 ,Trade Center  ,32422 ,",
        "emirate": "Dubai",
        "phone": "97143554646 / 971527547777",
        "email": "sam.bayat@bayatgroup.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "bayat-legal-services"
  },
  {
    "id": "legal_consultancy_firms_38",
    "name": "Bin Bashir Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "27/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_38",
        "address": "",
        "emirate": "Dubai",
        "phone": "971504514531 / 971504514531",
        "email": "bashirso@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "bin-bashir-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_40",
    "name": "Bird & Bird (MEA) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/09/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_40",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143093222 / 971566651954",
        "email": "melissa.murray@twobirds.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1716"
    ],
    "slug": "bird-bird-mea-llp"
  },
  {
    "id": "legal_consultancy_firms_41",
    "name": "BonelliErede Middle East LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 22,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/10/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_41",
        "address": "NA ,Index tower ,NA ,506828 ,Dubai",
        "emirate": "Dubai",
        "phone": "97154228569 / 971525567076",
        "email": "silviaelba.sartori@belex.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_53",
      "legal_consultancy_individual_54",
      "legal_consultancy_individual_693",
      "legal_consultancy_individual_694",
      "legal_consultancy_individual_851",
      "legal_consultancy_individual_852",
      "legal_consultancy_individual_963",
      "legal_consultancy_individual_2345",
      "legal_consultancy_individual_2346",
      "legal_consultancy_individual_2515",
      "legal_consultancy_individual_2530",
      "legal_consultancy_individual_2531",
      "legal_consultancy_individual_2541",
      "legal_consultancy_individual_2542",
      "legal_consultancy_individual_2665",
      "legal_consultancy_individual_2666",
      "legal_consultancy_individual_2757",
      "legal_consultancy_individual_2758",
      "legal_consultancy_individual_2869",
      "legal_consultancy_individual_2870",
      "legal_consultancy_individual_3155",
      "legal_consultancy_individual_3156"
    ],
    "slug": "bonellierede-middle-east-llp"
  },
  {
    "id": "legal_consultancy_firms_42",
    "name": "Bracewell LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "21/12/1988",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_42",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143506800 / 971507244940",
        "email": "Chris.Williams@bracewelllaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "bracewell-llp"
  },
  {
    "id": "legal_consultancy_firms_44",
    "name": "CC Worldwide Limited",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "08/03/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_44",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145032600 / 971504577931",
        "email": "edmund.boyo@cliffordchance.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "cc-worldwide-limited"
  },
  {
    "id": "legal_consultancy_firms_48",
    "name": "CMS (UAE) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "04/12/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_48",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143742800 / 971506450677",
        "email": "jabbott21@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "cms-uae-llp"
  },
  {
    "id": "legal_consultancy_firms_52",
    "name": "CVML Limited",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 15,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "27/10/2009",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_52",
        "address": "South Tower, Emirates Financial Towers ,DIFC ,482025 ,",
        "emirate": "Dubai",
        "phone": "97145875333 / 971503444388",
        "email": "c.dersahakian@cvml.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1010",
      "legal_consultancy_individual_1011",
      "legal_consultancy_individual_1212",
      "legal_consultancy_individual_1213",
      "legal_consultancy_individual_1297",
      "legal_consultancy_individual_2183",
      "legal_consultancy_individual_2184",
      "legal_consultancy_individual_2409",
      "legal_consultancy_individual_2410",
      "legal_consultancy_individual_271",
      "legal_consultancy_individual_272",
      "legal_consultancy_individual_3066",
      "legal_consultancy_individual_3067",
      "legal_consultancy_individual_684",
      "legal_consultancy_individual_685"
    ],
    "slug": "cvml-limited"
  },
  {
    "id": "legal_consultancy_firms_46",
    "name": "Clifford Chance LLP-DIFC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/02/1975",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_46",
        "address": "ICD Brookfield Place  ,DIFC ,9380 ,",
        "emirate": "Dubai",
        "phone": "97145032600 / 971507086365",
        "email": "mo.al-shukairy@cliffordchance.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "clifford-chance-llp-difc"
  },
  {
    "id": "legal_consultancy_firms_50",
    "name": "Cohen & Gresser LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 40,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/03/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_50",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971585357048",
        "email": "JJonas@CohenGresser.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_375",
      "legal_consultancy_individual_404",
      "legal_consultancy_individual_405",
      "legal_consultancy_individual_454",
      "legal_consultancy_individual_455",
      "legal_consultancy_individual_632",
      "legal_consultancy_individual_633",
      "legal_consultancy_individual_746",
      "legal_consultancy_individual_747",
      "legal_consultancy_individual_947",
      "legal_consultancy_individual_948",
      "legal_consultancy_individual_1041",
      "legal_consultancy_individual_1042",
      "legal_consultancy_individual_1148",
      "legal_consultancy_individual_1149",
      "legal_consultancy_individual_1293",
      "legal_consultancy_individual_1294",
      "legal_consultancy_individual_1327",
      "legal_consultancy_individual_1329",
      "legal_consultancy_individual_1330",
      "legal_consultancy_individual_1417",
      "legal_consultancy_individual_1418",
      "legal_consultancy_individual_1419",
      "legal_consultancy_individual_1420",
      "legal_consultancy_individual_1424",
      "legal_consultancy_individual_1425",
      "legal_consultancy_individual_1445",
      "legal_consultancy_individual_1446",
      "legal_consultancy_individual_1495",
      "legal_consultancy_individual_1496",
      "legal_consultancy_individual_1637",
      "legal_consultancy_individual_1822",
      "legal_consultancy_individual_1823",
      "legal_consultancy_individual_2151",
      "legal_consultancy_individual_2273",
      "legal_consultancy_individual_2385",
      "legal_consultancy_individual_2594",
      "legal_consultancy_individual_2731",
      "legal_consultancy_individual_2908",
      "legal_consultancy_individual_2909"
    ],
    "slug": "cohen-gresser-llp"
  },
  {
    "id": "legal_consultancy_firms_51",
    "name": "Covington & Burling LLP (Middle East)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/04/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_51",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142472100 / 971509224336",
        "email": "bhaley@cov.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "covington-burling-llp-middle-east"
  },
  {
    "id": "advocacy_firms_224",
    "name": "DAINA HAMADE ATTORNYES AT LAW",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_224",
        "address": "Diana Mohamed Hamade ,A.301.S-7 ,Multaqa Avenue 1 ,Mirdif ,10223 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142733029",
        "email": "info@dianahamade.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "daina-hamade-attornyes-at-law"
  },
  {
    "id": "advocacy_firms_225",
    "name": "DALMOOK MOHAMMED DALMOOK ( ADVOCATE & LEGAL CONSULTANCY )",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_225",
        "address": "dalmook mohamed bin dalmook ,التاسع - مكتب 901 ,الشركة الوطنية للتأمينات العامة NGI ,مقابل سيتي سنتر ديرة بجوار سندس سويتس مريديان وفلورا كريك هوتيل ,3467 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142989222 / 971506455800",
        "email": "information@dalmook.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_424",
      "advocacy_individual_425",
      "advocacy_individual_890",
      "advocacy_individual_891",
      "legal_consultancy_individual_1969",
      "legal_consultancy_individual_1970"
    ],
    "slug": "dalmook-mohammed-dalmook-advocate-legal-consultancy"
  },
  {
    "id": "advocacy_firms_226",
    "name": "DAR AL ADALAH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_226",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143355577",
        "email": "daraladalah1991@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_10",
      "advocacy_individual_11",
      "advocacy_individual_844",
      "advocacy_individual_845",
      "legal_consultancy_individual_999",
      "legal_consultancy_individual_1000",
      "legal_consultancy_individual_1227",
      "legal_consultancy_individual_1228",
      "legal_consultancy_individual_2680",
      "legal_consultancy_individual_2681",
      "legal_consultancy_individual_3094",
      "legal_consultancy_individual_3095"
    ],
    "slug": "dar-al-adalah-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_227",
    "name": "DAR AL BALAGH ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_227",
        "address": "1404 ,توين  تاورز  ,بجانب فندق ريدسون بلو  ,40227 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222407",
        "email": "info@daralbalaghadvocate.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_920",
      "legal_consultancy_individual_2682"
    ],
    "slug": "dar-al-balagh-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_228",
    "name": "DAR AL BAYAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_228",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142212494",
        "email": "bayanlaw@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_220",
      "legal_consultancy_individual_1696",
      "legal_consultancy_individual_1697",
      "legal_consultancy_individual_3106",
      "legal_consultancy_individual_3107"
    ],
    "slug": "dar-al-bayan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_229",
    "name": "DAR AL HEKMAH LAWYERS & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_229",
        "address": "الثامن مكتب 815 ,بزنس افينو  ,خلف وكالة نيسان  ,57134 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145463588",
        "email": "hisham@daralhekma.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dar-al-hekmah-lawyers-legal-consultancy"
  },
  {
    "id": "advocacy_firms_230",
    "name": "DAR AL HUQOOQ LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_230",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142211313",
        "email": "info@daralhuqooq.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_896",
      "legal_consultancy_individual_1790"
    ],
    "slug": "dar-al-huqooq-legal-consultants"
  },
  {
    "id": "advocacy_firms_231",
    "name": "DEAIFIS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_231",
        "address": "8 ,Burlington Tower ,SAFA park ,46886 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143425552 / 971509025904",
        "email": "info@deaifis.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2988",
      "legal_consultancy_individual_2989"
    ],
    "slug": "deaifis-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_58",
    "name": "DLA Piper Middle East LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 112,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/10/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_58",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144386100 / 971552211904",
        "email": "peter.somekh@dlapiper.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_74",
      "legal_consultancy_individual_80",
      "legal_consultancy_individual_81",
      "legal_consultancy_individual_85",
      "legal_consultancy_individual_86",
      "legal_consultancy_individual_113",
      "legal_consultancy_individual_162",
      "legal_consultancy_individual_163",
      "legal_consultancy_individual_258",
      "legal_consultancy_individual_259",
      "legal_consultancy_individual_303",
      "legal_consultancy_individual_304",
      "legal_consultancy_individual_342",
      "legal_consultancy_individual_343",
      "legal_consultancy_individual_357",
      "legal_consultancy_individual_415",
      "legal_consultancy_individual_416",
      "legal_consultancy_individual_417",
      "legal_consultancy_individual_418",
      "legal_consultancy_individual_419",
      "legal_consultancy_individual_495",
      "legal_consultancy_individual_959",
      "legal_consultancy_individual_964",
      "legal_consultancy_individual_965",
      "legal_consultancy_individual_994",
      "legal_consultancy_individual_995",
      "legal_consultancy_individual_1025",
      "legal_consultancy_individual_1026",
      "legal_consultancy_individual_1053",
      "legal_consultancy_individual_1054",
      "legal_consultancy_individual_1081",
      "legal_consultancy_individual_1150",
      "legal_consultancy_individual_1151",
      "legal_consultancy_individual_1154",
      "legal_consultancy_individual_1155",
      "legal_consultancy_individual_1250",
      "legal_consultancy_individual_1251",
      "legal_consultancy_individual_1429",
      "legal_consultancy_individual_1449",
      "legal_consultancy_individual_1450",
      "legal_consultancy_individual_1477",
      "legal_consultancy_individual_1478",
      "legal_consultancy_individual_1590",
      "legal_consultancy_individual_1591",
      "legal_consultancy_individual_1775",
      "legal_consultancy_individual_1792",
      "legal_consultancy_individual_1898",
      "legal_consultancy_individual_1999",
      "legal_consultancy_individual_2070",
      "legal_consultancy_individual_2071",
      "legal_consultancy_individual_2196",
      "legal_consultancy_individual_2197",
      "legal_consultancy_individual_2207",
      "legal_consultancy_individual_2208",
      "legal_consultancy_individual_2224",
      "legal_consultancy_individual_2225",
      "legal_consultancy_individual_2304",
      "legal_consultancy_individual_2305",
      "legal_consultancy_individual_2306",
      "legal_consultancy_individual_2307",
      "legal_consultancy_individual_2308",
      "legal_consultancy_individual_2309",
      "legal_consultancy_individual_2310",
      "legal_consultancy_individual_2311",
      "legal_consultancy_individual_2312",
      "legal_consultancy_individual_2313",
      "legal_consultancy_individual_2314",
      "legal_consultancy_individual_2315",
      "legal_consultancy_individual_2316",
      "legal_consultancy_individual_2317",
      "legal_consultancy_individual_2318",
      "legal_consultancy_individual_2319",
      "legal_consultancy_individual_2320",
      "legal_consultancy_individual_2321",
      "legal_consultancy_individual_2322",
      "legal_consultancy_individual_2323",
      "legal_consultancy_individual_2331",
      "legal_consultancy_individual_2386",
      "legal_consultancy_individual_2393",
      "legal_consultancy_individual_2394",
      "legal_consultancy_individual_2421",
      "legal_consultancy_individual_2422",
      "legal_consultancy_individual_2489",
      "legal_consultancy_individual_2490",
      "legal_consultancy_individual_2493",
      "legal_consultancy_individual_2494",
      "legal_consultancy_individual_2516",
      "legal_consultancy_individual_2517",
      "legal_consultancy_individual_2553",
      "legal_consultancy_individual_2554",
      "legal_consultancy_individual_2562",
      "legal_consultancy_individual_2563",
      "legal_consultancy_individual_2564",
      "legal_consultancy_individual_2565",
      "legal_consultancy_individual_2586",
      "legal_consultancy_individual_2587",
      "legal_consultancy_individual_2617",
      "legal_consultancy_individual_2618",
      "legal_consultancy_individual_2732",
      "legal_consultancy_individual_2733",
      "legal_consultancy_individual_2786",
      "legal_consultancy_individual_2787",
      "legal_consultancy_individual_2895",
      "legal_consultancy_individual_2896",
      "legal_consultancy_individual_2949",
      "legal_consultancy_individual_2950",
      "legal_consultancy_individual_3022",
      "legal_consultancy_individual_3023",
      "legal_consultancy_individual_3053",
      "legal_consultancy_individual_3054",
      "legal_consultancy_individual_3143",
      "legal_consultancy_individual_3144"
    ],
    "slug": "dla-piper-middle-east-llp"
  },
  {
    "id": "advocacy_firms_232",
    "name": "DR ADIL ALMEMARI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/11/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_232",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142438663",
        "email": "bosabbahmed@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_508"
    ],
    "slug": "dr-adil-almemari-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_233",
    "name": "DR AL SABBHAN LEGAL GROUP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_233",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143474007",
        "email": "info@alsabhanlegalgroup.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_146",
      "advocacy_individual_147",
      "advocacy_individual_1166",
      "advocacy_individual_1167",
      "legal_consultancy_individual_2109",
      "legal_consultancy_individual_2198",
      "legal_consultancy_individual_2199"
    ],
    "slug": "dr-al-sabbhan-legal-group"
  },
  {
    "id": "advocacy_firms_234",
    "name": "DR AMIRA AL BASTAKI ADVOCATES AND LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/10/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_234",
        "address": "11 ,ميلينيوم بلازا  ,بجوار محطة ابراج الأمارات  ,410961 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142954626",
        "email": "info@advoamira.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_361",
      "legal_consultancy_individual_1023",
      "legal_consultancy_individual_1024",
      "legal_consultancy_individual_2138"
    ],
    "slug": "dr-amira-al-bastaki-advocates-and-legal-consultant"
  },
  {
    "id": "advocacy_firms_235",
    "name": "DR GHAITH ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_235",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143411355 / 971505527552",
        "email": "advocates@drghaith.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dr-ghaith-alsuwaidi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_236",
    "name": "DR HAMAD ALUSTATH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/05/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_236",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142959844 / 971501411515",
        "email": "info@alustathlawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_589",
      "advocacy_individual_590"
    ],
    "slug": "dr-hamad-alustath-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_237",
    "name": "DR JAMAL AL MARRI ADVOCATES & LEGAL SERVICES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_237",
        "address": "1st floor office no.122 ,khalfan Business Center ,khalfan Business Center ,124289 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143806882",
        "email": "info@drjamaladvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dr-jamal-al-marri-advocates-legal-services"
  },
  {
    "id": "advocacy_firms_238",
    "name": "DR JAMAL ALNUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/04/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_238",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142722998",
        "email": "jalnuaimi.adv@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_438",
      "advocacy_individual_439",
      "legal_consultancy_individual_1526"
    ],
    "slug": "dr-jamal-alnuaimi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_239",
    "name": "DR KHALED ALI ALHADHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/07/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_239",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971506158015",
        "email": "lawyer.uae@live.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_774",
      "advocacy_individual_775"
    ],
    "slug": "dr-khaled-ali-alhadhrami-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_240",
    "name": "DR MOHAMED ALHAMMADI ADVOCATES & LEGAL CONSULTANTS OFFICE",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_240",
        "address": "Mohamed Alhammadi ,FLOOR 16 OFFICE B1605 ,LATIFA TOWER ,CLOSE TO CROWN PLAZA HOTEL ,76550 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143298866",
        "email": "admin@dralhammadilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_738",
      "advocacy_individual_991",
      "advocacy_individual_992",
      "legal_consultancy_individual_823",
      "legal_consultancy_individual_824",
      "legal_consultancy_individual_1883",
      "legal_consultancy_individual_3113"
    ],
    "slug": "dr-mohamed-alhammadi-advocates-legal-consultants-office"
  },
  {
    "id": "advocacy_firms_241",
    "name": "DR MOHAMED ALMUR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_241",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143944088 / 971547800401",
        "email": "info@almurlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1963",
      "legal_consultancy_individual_1964",
      "legal_consultancy_individual_2081",
      "legal_consultancy_individual_2082"
    ],
    "slug": "dr-mohamed-almur-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_242",
    "name": "DR SARHAN ALMUAINI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/03/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_242",
        "address": "Sarhan Hassan Mohamed Hassan Almuaini ,Office 1002, Level 10 ,THE OBEROI CENTRE ,Business Bay Metro Station ,1169 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142324000",
        "email": "info@drsarhanlawyer.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_33",
      "advocacy_individual_34",
      "advocacy_individual_485",
      "advocacy_individual_951",
      "advocacy_individual_952",
      "legal_consultancy_individual_252",
      "legal_consultancy_individual_253"
    ],
    "slug": "dr-sarhan-almuaini-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_243",
    "name": "DR ZUBAIDA JASIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/12/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_243",
        "address": "3rd Floor - Office No. 301 ,Wasel Business Building ,Makani No: 3242894178 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145460005 / 971552666381",
        "email": "Dr.khaled1234@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_447",
      "advocacy_individual_1201",
      "advocacy_individual_1202"
    ],
    "slug": "dr-zubaida-jasim-almaazmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_244",
    "name": "DR. AHMED ALRAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/06/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_244",
        "address": "Ahmed Saleh Abulla Khamis ALramsi ,1305 ,Fairmont Dubai ,Burj Khalifa ,77857 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142720066",
        "email": "info@alramsyadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_244",
      "legal_consultancy_individual_1219",
      "legal_consultancy_individual_1683"
    ],
    "slug": "dr-ahmed-alramsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_245",
    "name": "DR. IBRAHIM MAHMOOD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/08/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_245",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145897555 / 971045897555",
        "email": "Humidi01@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dr-ibrahim-mahmood-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_246",
    "name": "DR. MOHAMMED HASSAN ALRAEESI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/04/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_246",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145281450 / 971504465545",
        "email": "alraisim@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dr-mohammed-hassan-alraeesi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_247",
    "name": "DR. RIASA ABDULRAHMAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/12/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_247",
        "address": "DR. RAISA ABDULRAHMAN SAEED AHMED ,19 ,برج المدينة 2 ,أمام متحف المستقبل بدبي ,24847 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143581800 / 971527588525",
        "email": "info@drraisaadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1226",
      "advocacy_individual_1227"
    ],
    "slug": "dr-riasa-abdulrahman-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_248",
    "name": "DUBAI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_248",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142830088 / 971505951775",
        "email": "dubai_lc@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_369",
      "advocacy_individual_370",
      "legal_consultancy_individual_208",
      "legal_consultancy_individual_209",
      "legal_consultancy_individual_332",
      "legal_consultancy_individual_333"
    ],
    "slug": "dubai-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_61",
    "name": "DWF (Middle East) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "23/09/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_61",
        "address": "Al Fattan Currency House - Tower 1  ,Dubai International Financial Center  ,507104 ,",
        "emirate": "Dubai",
        "phone": "97143978565 / 971504587822",
        "email": "Raafat.hares@dwf.law",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dwf-middle-east-llp"
  },
  {
    "id": "legal_consultancy_firms_54",
    "name": "Davidson & Co Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "23/10/2008",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_54",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143438897 / 971507753952",
        "email": "jdavidson@davidson-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "davidson-co-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_56",
    "name": "Dentons & Co Dubai Branch-DED",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/12/1998",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_56",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144020800 / 971566830829",
        "email": "dean.ryburn@dentons.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "dentons-co-dubai-branch-ded"
  },
  {
    "id": "legal_consultancy_firms_59",
    "name": "Donald Harry Bunker Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "06/05/2010",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_59",
        "address": "Business Village Building A ,Port Saeed ,42717 ,",
        "emirate": "Dubai",
        "phone": "97142229747 / 971506546369",
        "email": "iveall@dhbassociates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "donald-harry-bunker-legal-consultants"
  },
  {
    "id": "advocacy_firms_249",
    "name": "EBRAHIM ALI AL MOUSA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/12/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_249",
        "address": "الخامس ,مونتانا ,هوم سنتر ,28834 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143963739",
        "email": "mousaadv@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_449",
      "legal_consultancy_individual_45",
      "legal_consultancy_individual_46",
      "legal_consultancy_individual_2357",
      "legal_consultancy_individual_2358"
    ],
    "slug": "ebrahim-ali-al-mousa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_250",
    "name": "EBRAHIM ALTENAIJI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_250",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142276655",
        "email": "altenaiji.advocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ebrahim-altenaiji-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_251",
    "name": "EBRAHIM MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/02/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_251",
        "address": "الطابق الثاني عشر - مكتب رقم 1203 ,برج سيتاديل ,مقابل فندق جي دبليو ماريوت ,91427 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143629899",
        "email": "md@imlawyeruae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_451",
      "advocacy_individual_452"
    ],
    "slug": "ebrahim-moosa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_252",
    "name": "EISA SALEM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/11/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_252",
        "address": "Eissa Salem ,911 ,ALFATTAN PLAZA ,مقابل مطار دبي، مبنى الوصول 1 ,26141 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143484809 / 971502226366",
        "email": "info.admin@eslawyers.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_458",
      "advocacy_individual_459",
      "advocacy_individual_650",
      "advocacy_individual_651"
    ],
    "slug": "eisa-salem-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_253",
    "name": "EISA SALIM ALQAYDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_253",
        "address": "Office No. 102 ,Mohammed Bu Farousha Building ,Makani No: 3240794064 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143304403 / 971509991543",
        "email": "alqaydi@esqadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_460"
    ],
    "slug": "eisa-salim-alqaydi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_254",
    "name": "EISA TAHER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "14/01/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_254",
        "address": "Eisa Taher Sultan  ,الميزانين  ,State 1  ,مركز بخيت ,238801 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148868508 / 971504772370",
        "email": "essataher@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "eisa-taher-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_256",
    "name": "EMAN AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_256",
        "address": "eman hassn  ,37 ,latifa tower ,dubai islamic bank ,384980 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142953088 / 971567779905",
        "email": "eman.advocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "eman-al-ali-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_257",
    "name": "EMAN ALRIFAI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "12/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_257",
        "address": "الطابق 11 - مكتب رقم (1105 ، 1106)  ,برج السلام  ,منطقة المركز التجاري العالمي 1 ,211911 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143366769 / 971503636617",
        "email": "info@erlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1278",
      "advocacy_individual_430",
      "advocacy_individual_431",
      "legal_consultancy_individual_182",
      "legal_consultancy_individual_2022",
      "legal_consultancy_individual_2023",
      "legal_consultancy_individual_2667",
      "legal_consultancy_individual_2810"
    ],
    "slug": "eman-alrifai-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_259",
    "name": "EMIRATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_259",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143304343",
        "email": "hamad@emiratesadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_38",
      "advocacy_individual_372",
      "advocacy_individual_591",
      "advocacy_individual_592",
      "advocacy_individual_1380",
      "advocacy_individual_1381"
    ],
    "slug": "emirates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_260",
    "name": "EMIRATES ADVOCATES & LEGAL CONSULTANTS - DCCA BRANCH",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/09/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_260",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143304343 / 971504198080",
        "email": "deena@emiratesadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "emirates-advocates-legal-consultants-dcca-branch"
  },
  {
    "id": "advocacy_firms_261",
    "name": "ENGY NABEEL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/10/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_261",
        "address": "engy nabeel ,609 ,Business Avenue Building ,خلف معرض نيسان للسيارات ,114332 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142666983 / 971505049385",
        "email": "mtgdubai@mtglegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_472",
      "advocacy_individual_969",
      "advocacy_individual_970"
    ],
    "slug": "engy-nabeel-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_63",
    "name": "EPAM Legal LLC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 15,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_63",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971527856097",
        "email": "roman_zhavner@epamlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_624",
      "legal_consultancy_individual_638",
      "legal_consultancy_individual_639",
      "legal_consultancy_individual_841",
      "legal_consultancy_individual_1335",
      "legal_consultancy_individual_1336",
      "legal_consultancy_individual_1816",
      "legal_consultancy_individual_1817",
      "legal_consultancy_individual_1862",
      "legal_consultancy_individual_1863",
      "legal_consultancy_individual_2527",
      "legal_consultancy_individual_3090",
      "legal_consultancy_individual_3091",
      "legal_consultancy_individual_3141",
      "legal_consultancy_individual_3142"
    ],
    "slug": "epam-legal-llc"
  },
  {
    "id": "advocacy_firms_262",
    "name": "ESAM ALZAROONI ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "15/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_262",
        "address": "",
        "emirate": "Dubai",
        "phone": "97100000000 / 971504766660",
        "email": "info@eza.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "esam-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_64",
    "name": "Eversheds Sutherland (International LLP) Dubai Branch",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_64",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143897000 / 971506553198",
        "email": "nasseralikhasawneh@eversheds-sutherland.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2274",
      "legal_consultancy_individual_2405",
      "legal_consultancy_individual_2406",
      "legal_consultancy_individual_2607"
    ],
    "slug": "eversheds-sutherland-international-llp-dubai-branch"
  },
  {
    "id": "advocacy_firms_264",
    "name": "FAHAD ABDULLA DAEN ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/06/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_264",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145476776 / 971971454767",
        "email": "fahadalshebli.uae@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "fahad-abdulla-daen-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_265",
    "name": "FAHAD ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/08/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_265",
        "address": "fahad alhosani ,Office No. 1006 ,ASPECT TOWER ,Near Burj Khalifa ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971551111723",
        "email": "info@fahadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_350",
      "advocacy_individual_486"
    ],
    "slug": "fahad-alhosani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_266",
    "name": "FAHAD BIN TAMIM ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/03/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_266",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143380333",
        "email": "info@fahadbintamim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_482",
      "advocacy_individual_1142",
      "advocacy_individual_1143",
      "legal_consultancy_individual_1982",
      "legal_consultancy_individual_1983"
    ],
    "slug": "fahad-bin-tamim-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_267",
    "name": "FAHAD SAEED ALZEYOUDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/12/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_267",
        "address": "الخطوط الاردنية ,بيزنس افينو ,الرستماني  ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145468245 / 971505003153",
        "email": "AJ@alzeyoudiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_487",
      "legal_consultancy_individual_10",
      "legal_consultancy_individual_11"
    ],
    "slug": "fahad-saeed-alzeyoudi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_268",
    "name": "FAISAL ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/08/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_268",
        "address": "103 ,DUBAI SUPREME COURT COMPLEX ,DUBAI COURT ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143038303 / 971504999947",
        "email": "dr.faisal@lawfaisal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "faisal-alhefeiti-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_269",
    "name": "FAISAL ALNSOUR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/11/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_269",
        "address": "Office No. 049 - 1603 ,Al Moosa Tower 1 ,Makani No: 26486900052 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143445789 / 971503571571",
        "email": "legal@faisalalnsouradvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_492"
    ],
    "slug": "faisal-alnsour-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_270",
    "name": "FAISAL ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/04/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_270",
        "address": "301 ,Clover Bay Tower ,Burj Khalifa ,414077 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145135166",
        "email": "info@faisalalzarooni.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_493"
    ],
    "slug": "faisal-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_271",
    "name": "FAISAL SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/07/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_271",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145132619 / 971543630593",
        "email": "info@alfaisal.law",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_501",
      "advocacy_individual_1152",
      "advocacy_individual_1153"
    ],
    "slug": "faisal-salem-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_272",
    "name": "FAREED ALHASSAN ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_272",
        "address": "FAREED FAIROUZ MOHD ALI ALHASSAN ,الميزانين - مكتب رقم M03 ,جولدن بيزنس تاور ,خلف معرض نيسان الرستماني ,455067 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143266117",
        "email": "Fs4591190fs@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_507"
    ],
    "slug": "fareed-alhassan-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_273",
    "name": "FATEM SAEED MOHAMED BIN YAROUF ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/03/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_273",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144455555 / 971503499791",
        "email": "fatmaamansoori@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "fatem-saeed-mohamed-bin-yarouf-almansoori-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_274",
    "name": "FATEMA ALMHEIRI ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/01/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_274",
        "address": "Mohamed Nagy ,First floor  ,Clover Bay ,Business bay ,108 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143366404",
        "email": "fatimaalmehri5@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_518",
      "advocacy_individual_519",
      "legal_consultancy_individual_180",
      "legal_consultancy_individual_181"
    ],
    "slug": "fatema-almheiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_275",
    "name": "FATEMA HASAN ALSHEHHI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_275",
        "address": "الثالث  ,برج جيت  48  ,مخرج ميترو برج خليفه / دبي مول  ,181111 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145143423 / 971971451434",
        "email": "info.justice@fhsadvo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_189",
      "advocacy_individual_255",
      "advocacy_individual_256",
      "advocacy_individual_514",
      "legal_consultancy_individual_323",
      "legal_consultancy_individual_1854",
      "legal_consultancy_individual_1855"
    ],
    "slug": "fatema-hasan-alshehhi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_276",
    "name": "FATIMA ABDELAZIZ ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/08/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_276",
        "address": "FATIMA ABDULAZIZ  ,الطابق السابع ,برج المنال  ,مقابل متحف المستقبل  ,861 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143555566",
        "email": "info@fazlegal.net",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_3104",
      "legal_consultancy_individual_3105"
    ],
    "slug": "fatima-abdelaziz-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_277",
    "name": "FATIMA HUSSEIN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/02/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_277",
        "address": "OB-101-141 ,Majid Al Futtaim - City Centre Deira ,Makani No: 3204893785 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97140000000 / 971506946464",
        "email": "Admin@fha.law",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_527"
    ],
    "slug": "fatima-hussein-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_278",
    "name": "FATIMA MOHAMMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_278",
        "address": "Fatima Mohammed Youseef Saddiq ,Floor 2, Office 215 ,Sultan Business Center ,Lamcy Plaza  ,114713 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145703330 / 971500000000",
        "email": "info@mnlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1943",
      "legal_consultancy_individual_1944",
      "legal_consultancy_individual_2230",
      "legal_consultancy_individual_2231"
    ],
    "slug": "fatima-mohammed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_279",
    "name": "FATMA AL MOOSA ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_279",
        "address": "Adv Fatma Moosa Ali ,30 ,IRIS Bay Tower ,Business Bay ,33727 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143328182",
        "email": "mahir@fatmaalmoosa.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_516",
      "advocacy_individual_517"
    ],
    "slug": "fatma-al-moosa-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_280",
    "name": "FATMA ALMUTAWA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/10/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_280",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145579711",
        "email": "info@mqadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_279",
      "legal_consultancy_individual_980",
      "legal_consultancy_individual_981",
      "legal_consultancy_individual_1734",
      "legal_consultancy_individual_2080",
      "legal_consultancy_individual_2967",
      "legal_consultancy_individual_2968"
    ],
    "slug": "fatma-almutawa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_282",
    "name": "FATTIHA GOURARI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/06/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_282",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142394000",
        "email": "info@fatihagourari.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_520"
    ],
    "slug": "fattiha-gourari-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_283",
    "name": "FAWZIA MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_283",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "fawzia.mohd.2009@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_554",
      "advocacy_individual_555",
      "legal_consultancy_individual_254",
      "legal_consultancy_individual_255"
    ],
    "slug": "fawzia-mohammad-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_284",
    "name": "FOUZEYA AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/06/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_284",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143283749",
        "email": "info@famlc.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_559"
    ],
    "slug": "fouzeya-al-mulla-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_65",
    "name": "Falah Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/02/1996",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_65",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142242514 / 971504533640",
        "email": "falahleg@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_51",
      "legal_consultancy_individual_52"
    ],
    "slug": "falah-legal-consultants"
  },
  {
    "id": "advocacy_firms_281",
    "name": "Fatmah Al Ali Advocates & Legal Consultancy",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/06/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_281",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145539905",
        "email": "info@ama-alali.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_550",
      "advocacy_individual_1453",
      "legal_consultancy_individual_325"
    ],
    "slug": "fatmah-al-ali-advocates-legal-consultancy"
  },
  {
    "id": "legal_consultancy_firms_66",
    "name": "Fenwick Elliott LLP (DMCC Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/04/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_66",
        "address": "Office 1A ,Silver Tower ,DMCC Al Mas Tower ,283149 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144542355 / 971564092949",
        "email": "pstone@fenwickelliott.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1069",
      "legal_consultancy_individual_1070",
      "legal_consultancy_individual_2378",
      "legal_consultancy_individual_2379",
      "legal_consultancy_individual_2604",
      "legal_consultancy_individual_2813",
      "legal_consultancy_individual_2814"
    ],
    "slug": "fenwick-elliott-llp-dmcc-branch"
  },
  {
    "id": "legal_consultancy_firms_67",
    "name": "Fichte & Co Legal Consultancy",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 16,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/10/2004",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_67",
        "address": "23 ,Rolex Tower ,Trade Center Second ,116637 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144357577 / 971502101003",
        "email": "jasamin.fichte@fichtelegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_277",
      "legal_consultancy_individual_278",
      "legal_consultancy_individual_682",
      "legal_consultancy_individual_683",
      "legal_consultancy_individual_1096",
      "legal_consultancy_individual_1097",
      "legal_consultancy_individual_1357",
      "legal_consultancy_individual_1358",
      "legal_consultancy_individual_1749",
      "legal_consultancy_individual_1750",
      "legal_consultancy_individual_1891",
      "legal_consultancy_individual_2232",
      "legal_consultancy_individual_2233",
      "legal_consultancy_individual_2511",
      "legal_consultancy_individual_2512",
      "legal_consultancy_individual_2836"
    ],
    "slug": "fichte-co-legal-consultancy"
  },
  {
    "id": "legal_consultancy_firms_68",
    "name": "Freshfields LLP DIFC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/05/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_68",
        "address": "0 ,ICD Brookfield Place Level 13 ,Trade Centre ,506569 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "freshfields-llp-difc"
  },
  {
    "id": "legal_consultancy_firms_70",
    "name": "Freshfields LLP- Dubai Branch DET",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 37,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/05/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_70",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145099100 / 971501006965",
        "email": "menahr@freshfields.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_82",
      "legal_consultancy_individual_83",
      "legal_consultancy_individual_336",
      "legal_consultancy_individual_351",
      "legal_consultancy_individual_408",
      "legal_consultancy_individual_409",
      "legal_consultancy_individual_424",
      "legal_consultancy_individual_425",
      "legal_consultancy_individual_434",
      "legal_consultancy_individual_435",
      "legal_consultancy_individual_439",
      "legal_consultancy_individual_440",
      "legal_consultancy_individual_441",
      "legal_consultancy_individual_442",
      "legal_consultancy_individual_443",
      "legal_consultancy_individual_444",
      "legal_consultancy_individual_445",
      "legal_consultancy_individual_446",
      "legal_consultancy_individual_782",
      "legal_consultancy_individual_783",
      "legal_consultancy_individual_924",
      "legal_consultancy_individual_925",
      "legal_consultancy_individual_1313",
      "legal_consultancy_individual_1369",
      "legal_consultancy_individual_1409",
      "legal_consultancy_individual_1506",
      "legal_consultancy_individual_1585",
      "legal_consultancy_individual_1631",
      "legal_consultancy_individual_2186",
      "legal_consultancy_individual_2187",
      "legal_consultancy_individual_2470",
      "legal_consultancy_individual_2471",
      "legal_consultancy_individual_2720",
      "legal_consultancy_individual_2812",
      "legal_consultancy_individual_3019",
      "legal_consultancy_individual_3076",
      "legal_consultancy_individual_3077"
    ],
    "slug": "freshfields-llp-dubai-branch-det"
  },
  {
    "id": "advocacy_firms_285",
    "name": "GALADARI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_285",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143937700",
        "email": "info@galadarilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "galadari-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_287",
    "name": "GALAL HUSSEIN LEGAL CONSULTANCIES AND ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/02/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_287",
        "address": "GALAL ELDIN HUSSEIN SALEH DIAB ,الطابق السادس ,مكاتب ,معرض هوندا الفطيم للسيارات - ديره ,115506 ,Dubai",
        "emirate": "Dubai",
        "phone": "97197150655",
        "email": "galal5152@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_560",
      "advocacy_individual_561"
    ],
    "slug": "galal-hussein-legal-consultancies-and-advocates"
  },
  {
    "id": "advocacy_firms_288",
    "name": "GHARIB ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/09/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_288",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142208816",
        "email": "g.alshamsiadvocate@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_565",
      "advocacy_individual_566"
    ],
    "slug": "gharib-alshamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_289",
    "name": "GLOBAL ADVOCACY & LEGAL COUNSEL",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 27,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_289",
        "address": "21 ,Rolex Tower ,Emirates Grand Hotel ,94334 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143277772 / 97145584900",
        "email": "info@globaladvocates.net",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_68",
      "advocacy_individual_316",
      "advocacy_individual_328",
      "advocacy_individual_404",
      "advocacy_individual_749",
      "legal_consultancy_individual_59",
      "legal_consultancy_individual_60",
      "legal_consultancy_individual_221",
      "legal_consultancy_individual_222",
      "legal_consultancy_individual_990",
      "legal_consultancy_individual_1022",
      "legal_consultancy_individual_1084",
      "legal_consultancy_individual_1085",
      "legal_consultancy_individual_1987",
      "legal_consultancy_individual_2054",
      "legal_consultancy_individual_2055",
      "legal_consultancy_individual_2093",
      "legal_consultancy_individual_2094",
      "legal_consultancy_individual_2125",
      "legal_consultancy_individual_2126",
      "legal_consultancy_individual_2139",
      "legal_consultancy_individual_2220",
      "legal_consultancy_individual_2221",
      "legal_consultancy_individual_2877",
      "legal_consultancy_individual_2878",
      "legal_consultancy_individual_3203",
      "legal_consultancy_individual_3204"
    ],
    "slug": "global-advocacy-legal-counsel"
  },
  {
    "id": "advocacy_firms_290",
    "name": "GLORY INTERNATIONAL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_290",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142628001",
        "email": "gloryadvocate@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1304"
    ],
    "slug": "glory-international-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_291",
    "name": "GULF CONSULTANT ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_291",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142830009",
        "email": "abakgulfconsultant@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "gulf-consultant-advocates-legal-consultancy"
  },
  {
    "id": "legal_consultancy_firms_71",
    "name": "Gibson Dunn & Crutcher LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 18,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/09/2007",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_71",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143184600 / 971504468184",
        "email": "melaraby@gibsondunn.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_650",
      "legal_consultancy_individual_651",
      "legal_consultancy_individual_883",
      "legal_consultancy_individual_1107",
      "legal_consultancy_individual_1108",
      "legal_consultancy_individual_1134",
      "legal_consultancy_individual_1135",
      "legal_consultancy_individual_1198",
      "legal_consultancy_individual_1199",
      "legal_consultancy_individual_1323",
      "legal_consultancy_individual_1324",
      "legal_consultancy_individual_1566",
      "legal_consultancy_individual_1567",
      "legal_consultancy_individual_2089",
      "legal_consultancy_individual_2090",
      "legal_consultancy_individual_2629",
      "legal_consultancy_individual_2703",
      "legal_consultancy_individual_2704"
    ],
    "slug": "gibson-dunn-crutcher-llp"
  },
  {
    "id": "legal_consultancy_firms_72",
    "name": "Gowling WLG (UK) LLP (Dubai Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 13,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/06/2007",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_72",
        "address": "Level 17, ICD Brookfield Place ,DIFC ,506503 ,",
        "emirate": "Dubai",
        "phone": "97144375100 / 971588271196",
        "email": "libby.edwards-smith@gowlingwlg.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_75",
      "legal_consultancy_individual_503",
      "legal_consultancy_individual_853",
      "legal_consultancy_individual_854",
      "legal_consultancy_individual_1005",
      "legal_consultancy_individual_1114",
      "legal_consultancy_individual_1115",
      "legal_consultancy_individual_1433",
      "legal_consultancy_individual_1434",
      "legal_consultancy_individual_1448",
      "legal_consultancy_individual_1759",
      "legal_consultancy_individual_2417",
      "legal_consultancy_individual_2418"
    ],
    "slug": "gowling-wlg-uk-llp-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_73",
    "name": "Greenberg Traurig Limited",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "02/06/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_73",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145953601 / 971508728645",
        "email": "Steven.Bainbridge@gtlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "greenberg-traurig-limited"
  },
  {
    "id": "advocacy_firms_293",
    "name": "HABIB ALHOSANI LAWYERS & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "30/03/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_293",
        "address": "الثالث مكتب 304 ,برج سما ,المركز التجاري  ,116623 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142723388",
        "email": "info@habibllc.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "habib-alhosani-lawyers-legal-consultants"
  },
  {
    "id": "advocacy_firms_295",
    "name": "HADEF & PARTNERS L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 60,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "29/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_295",
        "address": "Level 5 ,Emaar Square Building 3 ,Burj Khalifa ,37172 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144292999",
        "email": "e.araza@hadefpartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1031",
      "advocacy_individual_1032",
      "advocacy_individual_1168",
      "advocacy_individual_1176",
      "advocacy_individual_1177",
      "advocacy_individual_1431",
      "advocacy_individual_1432",
      "advocacy_individual_152",
      "advocacy_individual_504",
      "advocacy_individual_505",
      "advocacy_individual_570",
      "advocacy_individual_967",
      "advocacy_individual_968",
      "legal_consultancy_individual_1059",
      "legal_consultancy_individual_1060",
      "legal_consultancy_individual_1231",
      "legal_consultancy_individual_1232",
      "legal_consultancy_individual_126",
      "legal_consultancy_individual_127",
      "legal_consultancy_individual_1457",
      "legal_consultancy_individual_1483",
      "legal_consultancy_individual_1484",
      "legal_consultancy_individual_1543",
      "legal_consultancy_individual_1544",
      "legal_consultancy_individual_1556",
      "legal_consultancy_individual_1557",
      "legal_consultancy_individual_1800",
      "legal_consultancy_individual_1856",
      "legal_consultancy_individual_1857",
      "legal_consultancy_individual_20",
      "legal_consultancy_individual_2052",
      "legal_consultancy_individual_2053",
      "legal_consultancy_individual_21",
      "legal_consultancy_individual_2384",
      "legal_consultancy_individual_2492",
      "legal_consultancy_individual_2557",
      "legal_consultancy_individual_260",
      "legal_consultancy_individual_261",
      "legal_consultancy_individual_2655",
      "legal_consultancy_individual_2656",
      "legal_consultancy_individual_2739",
      "legal_consultancy_individual_2941",
      "legal_consultancy_individual_2942",
      "legal_consultancy_individual_2951",
      "legal_consultancy_individual_2952",
      "legal_consultancy_individual_3078",
      "legal_consultancy_individual_312",
      "legal_consultancy_individual_313",
      "legal_consultancy_individual_377",
      "legal_consultancy_individual_49",
      "legal_consultancy_individual_50",
      "legal_consultancy_individual_534",
      "legal_consultancy_individual_548",
      "legal_consultancy_individual_568",
      "legal_consultancy_individual_569",
      "legal_consultancy_individual_674",
      "legal_consultancy_individual_675",
      "legal_consultancy_individual_724",
      "legal_consultancy_individual_725",
      "legal_consultancy_individual_825"
    ],
    "slug": "hadef-partners-llc"
  },
  {
    "id": "advocacy_firms_297",
    "name": "HADEYA HAMAD ADVOCACY AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/07/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_297",
        "address": "ADEL ALSAID  ,203 ,BAY SQUARE-02 ,BAY SQUARE  ,37105 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143555253 / 971507562138",
        "email": "hhlegal@hhlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_571",
      "legal_consultancy_individual_93"
    ],
    "slug": "hadeya-hamad-advocacy-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_298",
    "name": "HAIDER BIN HAIDER ADVOCATES AND LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_298",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142770003",
        "email": "info@hbhadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_531",
      "advocacy_individual_532",
      "advocacy_individual_572",
      "legal_consultancy_individual_2222",
      "legal_consultancy_individual_2223",
      "legal_consultancy_individual_2351",
      "legal_consultancy_individual_2352"
    ],
    "slug": "haider-bin-haider-advocates-and-legal-consultant"
  },
  {
    "id": "advocacy_firms_299",
    "name": "HAITHAM SALAH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/02/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_299",
        "address": "M ,al garhoud busniss center ,dubai international airport ,451878 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143964926 / 971503470066",
        "email": "lawyer-haitham@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "haitham-salah-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_300",
    "name": "HALEEMA ALMARZOOQI & PARTNERS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_300",
        "address": "haleema almarzooqi ,3 ,building 7A ,D3 ,9569 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143621113",
        "email": "haleema.almarzooqi@dhalaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_521"
    ],
    "slug": "haleema-almarzooqi-partners-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_301",
    "name": "HAMAD AL SAYEGH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/02/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_301",
        "address": "Second Floor - Office No. 224 ,Business Center ,Makani No: 3274893760 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145671576 / 971529969969",
        "email": "info@hamadalsayegh.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_584",
      "legal_consultancy_individual_1689"
    ],
    "slug": "hamad-al-sayegh-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_302",
    "name": "HAMAD ALESSA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/03/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_302",
        "address": "13 ,المنارة ,الخليج التجاري  ,455755 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144106480",
        "email": "alessalawfirm@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "hamad-alessa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_303",
    "name": "HAMAD ALZAABI & MUNA BIN GHALAITA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/01/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_303",
        "address": "Office 413 - Block B ,Hamdan Bin Rashid Al Maktoum Foundation for Medical Science ,Makani No: 2598892707 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142571323 / 971554377771",
        "email": "info@alzaabi-binghalaita.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_596",
      "advocacy_individual_1071",
      "legal_consultancy_individual_1525"
    ],
    "slug": "hamad-alzaabi-muna-bin-ghalaita-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_304",
    "name": "HAMDA MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/10/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_304",
        "address": "جائزة الشيخ حمدان ,مبانى الحضيبة للجوائز - البلوك ب - الطابق السادس ,متحف الضيافة ,26596 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143889770",
        "email": "hamdamakkiadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_597"
    ],
    "slug": "hamda-makki-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_305",
    "name": "HAMDAN AL HARMI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_305",
        "address": "Hamdan Abdullah Abdulrahman Ali Alharmi ,2 office 211 ,MSM 1 ,Auto Land Motors ,6064 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142999559",
        "email": "hamdan@harmilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_598",
      "advocacy_individual_599",
      "legal_consultancy_individual_578",
      "legal_consultancy_individual_609",
      "legal_consultancy_individual_610",
      "legal_consultancy_individual_2154",
      "legal_consultancy_individual_3030",
      "legal_consultancy_individual_3031"
    ],
    "slug": "hamdan-al-harmi-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_306",
    "name": "HAMDAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/01/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_306",
        "address": "MOSTAFA MAHMOUD  ,1304 ,AL MOOSA TOWER 1 ,First Trade Center ,25635 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142254438",
        "email": "info@hkadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_86",
      "advocacy_individual_87",
      "advocacy_individual_961",
      "advocacy_individual_962",
      "advocacy_individual_1388",
      "legal_consultancy_individual_242",
      "legal_consultancy_individual_243",
      "legal_consultancy_individual_908"
    ],
    "slug": "hamdan-alkaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_307",
    "name": "HAMDAN ALSHAMSI LAWYER & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 16,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_307",
        "address": "HAMDAN ALSHAMSI ,الطابق الرابع مكتب 401, 406,407 ,بي سكوير 01 ,مجمع دبي سكوير ,116564 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143469262",
        "email": "courts@has.law",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_602",
      "advocacy_individual_603",
      "advocacy_individual_1436",
      "advocacy_individual_1437",
      "legal_consultancy_individual_98",
      "legal_consultancy_individual_115",
      "legal_consultancy_individual_116",
      "legal_consultancy_individual_130",
      "legal_consultancy_individual_958",
      "legal_consultancy_individual_1937",
      "legal_consultancy_individual_1938",
      "legal_consultancy_individual_2001",
      "legal_consultancy_individual_2460",
      "legal_consultancy_individual_2591",
      "legal_consultancy_individual_2953",
      "legal_consultancy_individual_2954"
    ],
    "slug": "hamdan-alshamsi-lawyer-legal-consultants"
  },
  {
    "id": "advocacy_firms_308",
    "name": "HAMDAN RASHOUD ALZEYOUDI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/09/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_308",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148845339 / 971505303737",
        "email": "office@law-hrz.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_80"
    ],
    "slug": "hamdan-rashoud-alzeyoudi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_309",
    "name": "HAMDAN SULAIMAN SALIM ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/12/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_309",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142566628 / 971508908030",
        "email": "info@halmaazmilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_604",
      "legal_consultancy_individual_1978",
      "legal_consultancy_individual_1979"
    ],
    "slug": "hamdan-sulaiman-salim-almaazmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_310",
    "name": "HANAN SALEM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_310",
        "address": "104 ,سان شاين 1  ,شقق جرين هاوس الفندقية ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142280666 / 97142280666",
        "email": "Hanansalem.advocate@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_611",
      "advocacy_individual_1064"
    ],
    "slug": "hanan-salem-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_311",
    "name": "HANI AL JASMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_311",
        "address": "HANI RAJAB MOOSA ABDULLA ALJASMI ,M ,LIBERTY ,SHARJAH BANK ,123887 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142957744",
        "email": "info@aljasmilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_446",
      "advocacy_individual_614",
      "advocacy_individual_615",
      "legal_consultancy_individual_2674",
      "legal_consultancy_individual_2675"
    ],
    "slug": "hani-al-jasmi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_312",
    "name": "HASAN ALRAYYAMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/03/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_312",
        "address": "HASSAN ALI MATAR ALRIYAMI ,24 ,GRASVENOR BUSINESS TOWER ,NEEDS SUPERMARKET ,215880 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144534188",
        "email": "courts@alriyamiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_377",
      "advocacy_individual_417",
      "advocacy_individual_418",
      "advocacy_individual_421",
      "advocacy_individual_422",
      "advocacy_individual_634",
      "advocacy_individual_635",
      "advocacy_individual_1335",
      "advocacy_individual_1336",
      "legal_consultancy_individual_152",
      "legal_consultancy_individual_153",
      "legal_consultancy_individual_1563"
    ],
    "slug": "hasan-alrayyami-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_313",
    "name": "HASHEM ALHASHMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_313",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971562331154",
        "email": "info@hashem-alhashmi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "hashem-alhashmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_314",
    "name": "HASHIM GROUP ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_314",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143555600",
        "email": "hashimgroup786@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_194"
    ],
    "slug": "hashim-group-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_315",
    "name": "HASHIM SALEM SAIF SALEM ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_315",
        "address": "الطابق التاسع ,الفتان بلازا ,مطار دبي الدولي ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145689958 / 971508742777",
        "email": "hashim.salem@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_624",
      "advocacy_individual_625"
    ],
    "slug": "hashim-salem-saif-salem-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_316",
    "name": "HASSAN AL ABDOOLI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_316",
        "address": "Hitham Bassam ,1 ,R549 ,بنك مصر ,99094 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142355517",
        "email": "hassanalabdooli@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_628",
      "advocacy_individual_629",
      "legal_consultancy_individual_1214",
      "legal_consultancy_individual_2985"
    ],
    "slug": "hassan-al-abdooli-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_317",
    "name": "HASSAN AL ALI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/05/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_317",
        "address": "الطابق الثامن ,بزنس أفنيو ,خلف وكالة نيسان ,444775 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142501414",
        "email": "info@halalilaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_626",
      "advocacy_individual_627",
      "legal_consultancy_individual_1178",
      "legal_consultancy_individual_2133",
      "legal_consultancy_individual_2134",
      "legal_consultancy_individual_2817",
      "legal_consultancy_individual_2818"
    ],
    "slug": "hassan-al-ali-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_318",
    "name": "HASSAN ASHOOR AL MULLA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_318",
        "address": "11 مكتب رقم 1104 ,وصل بيزنش سنترال ,خلف سيتي سنتر ديره ,23404 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142865503 / 971502705678",
        "email": "info-dxb@almulla-advocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_636",
      "legal_consultancy_individual_932",
      "legal_consultancy_individual_2234",
      "legal_consultancy_individual_2235"
    ],
    "slug": "hassan-ashoor-al-mulla-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_319",
    "name": "HASSAN HUMAID AL SUWAIDI ADVOCATES AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_319",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142500251",
        "email": "hassan.suwaidi@hhslawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_637",
      "legal_consultancy_individual_1190",
      "legal_consultancy_individual_1191",
      "legal_consultancy_individual_1918"
    ],
    "slug": "hassan-humaid-al-suwaidi-advocates-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_320",
    "name": "HASSAN TAMIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/01/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_320",
        "address": "Hassan Mohammad Hassan Tamim ,الطابق السادس 614 ,اعمار بزنس بارك - 4  ,Zabeel house the greens - hotel  ,18122 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142999972",
        "email": "info@htlawyers.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_642",
      "advocacy_individual_643"
    ],
    "slug": "hassan-tamim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_321",
    "name": "HEBA AHLI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/01/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_321",
        "address": "Heba Ahli ,6th Floor  ,Prime Business Building  ,Khansour Community Park ,414142 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143358885 / 971505509997",
        "email": "info@mitchelpartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1016",
      "legal_consultancy_individual_1017"
    ],
    "slug": "heba-ahli-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_322",
    "name": "HEND ALKTEBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/11/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_322",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143968700",
        "email": "admin@haklegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_356"
    ],
    "slug": "hend-alktebi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_323",
    "name": "HEND BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/06/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_323",
        "address": "Hend Humaid Khalifa Bin Hendi Alaleeli  ,2/201 ,ALMIHIRI BLAZA - Al Khabisi , Hyundai Show ROOM  ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143999691 / 971000000000",
        "email": "hend.alaleeli@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_658",
      "advocacy_individual_659"
    ],
    "slug": "hend-bin-hendi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_324",
    "name": "HESSA AL JABERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/01/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_324",
        "address": "201 ,Bou Haliba Building  ,Opposite of Al Bakhit Centre ,181116 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142507711",
        "email": "h.aljaberiadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_664"
    ],
    "slug": "hessa-al-jaberi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_326",
    "name": "HESSA ALATTAY ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/10/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_326",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143688984",
        "email": "legalsolutions@alattay.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_663",
      "legal_consultancy_individual_3118"
    ],
    "slug": "hessa-alattay-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_327",
    "name": "HESSA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_327",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143339002 / 971558818724",
        "email": "info@nhalhammadi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_665",
      "advocacy_individual_666",
      "legal_consultancy_individual_1974",
      "legal_consultancy_individual_1975"
    ],
    "slug": "hessa-alhammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_328",
    "name": "HESSA HUMAID AL SHARA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/01/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_328",
        "address": "10 Floor - Office No. 10001 ,Latifa Tower ,Makani No: 9063026848 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142522995 / 971505897795",
        "email": "a.legal.uae@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_667",
      "advocacy_individual_1400"
    ],
    "slug": "hessa-humaid-al-shara-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_329",
    "name": "HIBA MAANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/01/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_329",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142986558",
        "email": "mak@maklegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2113",
      "legal_consultancy_individual_2114"
    ],
    "slug": "hiba-maani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_330",
    "name": "HIKMAT FAYAD AND ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_330",
        "address": "الخامس  ,البرج الأخضر  ,خلف فندق موسكو  ,5630 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142222888",
        "email": "fayadlaw@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_669",
      "legal_consultancy_individual_1894",
      "legal_consultancy_individual_1895",
      "legal_consultancy_individual_2271"
    ],
    "slug": "hikmat-fayad-and-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_331",
    "name": "HILAL & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "29/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_331",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142955388 / 971507739863",
        "email": "arhilal@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1425",
      "advocacy_individual_1426",
      "advocacy_individual_474",
      "advocacy_individual_988"
    ],
    "slug": "hilal-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_333",
    "name": "HIND ALI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/10/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_333",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143999565",
        "email": "law.uae@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "hind-ali-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_334",
    "name": "HORIZONS & CO - LAW FIRM",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "25/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_334",
        "address": "O-4801, O-4901 ,Burj al Salam Office Tower ,H Hotel ,111801 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143544444",
        "email": "administration@horizlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "horizons-co-law-firm"
  },
  {
    "id": "advocacy_firms_336",
    "name": "HOYAM ALZAROUNI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/10/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_336",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143116556 / 971000000000",
        "email": "info@hazlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "hoyam-alzarouni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_337",
    "name": "HUDA ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/05/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_337",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142551142 / 971502226062",
        "email": "Huda@halhammadi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_680",
      "advocacy_individual_681",
      "advocacy_individual_682",
      "advocacy_individual_683",
      "advocacy_individual_684",
      "advocacy_individual_685",
      "advocacy_individual_686",
      "advocacy_individual_687"
    ],
    "slug": "huda-alhammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_338",
    "name": "HUDA ALMAAZMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/06/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_338",
        "address": "الطابق الحادي عشر ,بناية الحواي ,متحف المستقبل ,183335 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142888874 / 971551740400",
        "email": "h.almazmi89@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "huda-almaazmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_339",
    "name": "HUDA YAQOOB ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_339",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145293307",
        "email": "info@hyadvocate.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_201",
      "legal_consultancy_individual_899",
      "legal_consultancy_individual_900",
      "legal_consultancy_individual_1220"
    ],
    "slug": "huda-yaqoob-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_340",
    "name": "HUMAID ALANSARI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/01/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_340",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143585135 / 971503564426",
        "email": "info@alansarilaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2041",
      "legal_consultancy_individual_2042"
    ],
    "slug": "humaid-alansari-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_341",
    "name": "HUMAID DARWISH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_341",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143324114",
        "email": "humaidhd@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_689"
    ],
    "slug": "humaid-darwish-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_342",
    "name": "HUMAID YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/02/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_342",
        "address": "M19 ,بناية مركز القرهود للأعمال ,مستشفى القرهود التخصصي  ,445499 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142999949",
        "email": "info@hsadvo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "humaid-yousuf-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_343",
    "name": "HUSAIN HASAN MOHAMED AL ALI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/08/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_343",
        "address": "Fourth Floor - Office No. 411 ,Oud Metha Office Building ,Makani No: 3093891125 ,49909 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971507559971",
        "email": "husain.alali@alaliadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_694",
      "advocacy_individual_695"
    ],
    "slug": "husain-hasan-mohamed-al-ali-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_344",
    "name": "HUSSA ALI ALQUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/04/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_344",
        "address": "HUSSA ALI ALQUBAISI ,FLOOR 31 OFFICE 3103 ,BURLINGTON TOWER ,DUBAI ISLAMIC BANK ,15002 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142427805",
        "email": "info@haqlegalconsultants.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_384"
    ],
    "slug": "hussa-ali-alqubaisi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_345",
    "name": "HUSSAIN ALJAHAZI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_345",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142678800 / 971050646353",
        "email": "info@hussainaljahazilawyer.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_704",
      "advocacy_individual_705"
    ],
    "slug": "hussain-aljahazi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_346",
    "name": "HUSSAIN LOOTAH & PARTNERS - ATTORNEYS & COUNSELLORS AT LAW",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_346",
        "address": "الطابق الثامن  ,برج الجرج 1 ,دائرة الاراضي و الاملاك  ,9117 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143320004",
        "email": "info@hlootahlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_698",
      "advocacy_individual_699",
      "advocacy_individual_860",
      "legal_consultancy_individual_592",
      "legal_consultancy_individual_1961",
      "legal_consultancy_individual_2016",
      "legal_consultancy_individual_2148",
      "legal_consultancy_individual_2149"
    ],
    "slug": "hussain-lootah-partners-attorneys-counsellors-at-law"
  },
  {
    "id": "advocacy_firms_347",
    "name": "HUSSAIN MIRZA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_347",
        "address": "Office No. 1310 ,Saheel 2 Building ,Al Nahda 1 – Saheel 2 Building ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145856322",
        "email": "husain.almahdi@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_702",
      "advocacy_individual_703"
    ],
    "slug": "hussain-mirza-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_348",
    "name": "HUSSAIN MOHAMED ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/01/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_348",
        "address": "Hussain Mohamed AL Hosani ,Office 314 ,Bussnis Avenue ,AL Roustomani ,7094 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143322338 / 971568842488",
        "email": "info@hmalegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "hussain-mohamed-alhosani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_292",
    "name": "Habib Al Mulla & Partners ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 41,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_292",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144230000 / 971552009022",
        "email": "UAE-CourtClerks@habibalmulla.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_127",
      "advocacy_individual_263",
      "advocacy_individual_324",
      "advocacy_individual_360",
      "advocacy_individual_466",
      "advocacy_individual_467",
      "advocacy_individual_568",
      "advocacy_individual_569",
      "legal_consultancy_individual_133",
      "legal_consultancy_individual_328",
      "legal_consultancy_individual_329",
      "legal_consultancy_individual_388",
      "legal_consultancy_individual_389",
      "legal_consultancy_individual_558",
      "legal_consultancy_individual_594",
      "legal_consultancy_individual_595",
      "legal_consultancy_individual_772",
      "legal_consultancy_individual_773",
      "legal_consultancy_individual_778",
      "legal_consultancy_individual_779",
      "legal_consultancy_individual_953",
      "legal_consultancy_individual_954",
      "legal_consultancy_individual_1057",
      "legal_consultancy_individual_1058",
      "legal_consultancy_individual_1472",
      "legal_consultancy_individual_1473",
      "legal_consultancy_individual_1487",
      "legal_consultancy_individual_1488",
      "legal_consultancy_individual_1548",
      "legal_consultancy_individual_1549",
      "legal_consultancy_individual_1815",
      "legal_consultancy_individual_1899",
      "legal_consultancy_individual_1900",
      "legal_consultancy_individual_1993",
      "legal_consultancy_individual_1994",
      "legal_consultancy_individual_2011",
      "legal_consultancy_individual_2012",
      "legal_consultancy_individual_2106",
      "legal_consultancy_individual_2403",
      "legal_consultancy_individual_2404",
      "legal_consultancy_individual_3112"
    ],
    "slug": "habib-al-mulla-partners-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_75",
    "name": "Herbert Smith Freehills Kramer LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 30,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/10/2006",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_75",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144286300 / 971506256686",
        "email": "stuart.paterson@hsf.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_95",
      "legal_consultancy_individual_280",
      "legal_consultancy_individual_281",
      "legal_consultancy_individual_392",
      "legal_consultancy_individual_393",
      "legal_consultancy_individual_449",
      "legal_consultancy_individual_691",
      "legal_consultancy_individual_692",
      "legal_consultancy_individual_774",
      "legal_consultancy_individual_811",
      "legal_consultancy_individual_812",
      "legal_consultancy_individual_1355",
      "legal_consultancy_individual_1356",
      "legal_consultancy_individual_1391",
      "legal_consultancy_individual_1455",
      "legal_consultancy_individual_1755",
      "legal_consultancy_individual_2268",
      "legal_consultancy_individual_2425",
      "legal_consultancy_individual_2426",
      "legal_consultancy_individual_2441",
      "legal_consultancy_individual_2734",
      "legal_consultancy_individual_2735",
      "legal_consultancy_individual_2788",
      "legal_consultancy_individual_2789",
      "legal_consultancy_individual_2929",
      "legal_consultancy_individual_2930",
      "legal_consultancy_individual_2979",
      "legal_consultancy_individual_2980",
      "legal_consultancy_individual_3187",
      "legal_consultancy_individual_3188"
    ],
    "slug": "herbert-smith-freehills-kramer-llp"
  },
  {
    "id": "advocacy_firms_325",
    "name": "Hessa Al Shehhi ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/04/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_325",
        "address": "HAMAD ABDULLA ABDULRAHMAN ALRAHMA ALHAMMADI ,14TH FLOOR - 1403 ,PARK PLACE TOWER ,WORLD TRADE CENTER ,114295 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144227465 / 971555507070",
        "email": "hessa.alshehhi@primecase.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_668",
      "legal_consultancy_individual_1397",
      "legal_consultancy_individual_1919",
      "legal_consultancy_individual_1920",
      "legal_consultancy_individual_2035",
      "legal_consultancy_individual_2036",
      "legal_consultancy_individual_2705",
      "legal_consultancy_individual_2706"
    ],
    "slug": "hessa-al-shehhi-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_76",
    "name": "Hoda Barakat Legal Consultancy",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/08/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_76",
        "address": "The H Hotel ,334249 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143050858 / 971506454751",
        "email": "hoda@hblegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1215",
      "legal_consultancy_individual_1216"
    ],
    "slug": "hoda-barakat-legal-consultancy"
  },
  {
    "id": "legal_consultancy_firms_77",
    "name": "Hogan Lovells Middle East LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/11/2006",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_77",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143779377 / 971505528593",
        "email": "rahail.ali@hoganlovells.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1289",
      "legal_consultancy_individual_1296",
      "legal_consultancy_individual_2472",
      "legal_consultancy_individual_2473",
      "legal_consultancy_individual_2501"
    ],
    "slug": "hogan-lovells-middle-east-llp"
  },
  {
    "id": "legal_consultancy_firms_78",
    "name": "Holman Fenwick Willan Middle East LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "11/07/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_78",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144230555 / 971504788443",
        "email": "yah@hfw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "holman-fenwick-willan-middle-east-llp"
  },
  {
    "id": "legal_consultancy_firms_80",
    "name": "Hourani & Partners Legal Consultancy FZCO",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 42,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/08/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_80",
        "address": "One Central, The Offices 5 ,Dubai World Trade Centre ,554660 ,",
        "emirate": "Dubai",
        "phone": "97142052030 / 971506566494",
        "email": "chourani@houranipartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_428",
      "legal_consultancy_individual_429",
      "legal_consultancy_individual_506",
      "legal_consultancy_individual_507",
      "legal_consultancy_individual_521",
      "legal_consultancy_individual_522",
      "legal_consultancy_individual_642",
      "legal_consultancy_individual_643",
      "legal_consultancy_individual_830",
      "legal_consultancy_individual_1252",
      "legal_consultancy_individual_1253",
      "legal_consultancy_individual_1339",
      "legal_consultancy_individual_1340",
      "legal_consultancy_individual_1460",
      "legal_consultancy_individual_1586",
      "legal_consultancy_individual_1587",
      "legal_consultancy_individual_1648",
      "legal_consultancy_individual_1735",
      "legal_consultancy_individual_1736",
      "legal_consultancy_individual_1739",
      "legal_consultancy_individual_1740",
      "legal_consultancy_individual_1828",
      "legal_consultancy_individual_1829",
      "legal_consultancy_individual_1886",
      "legal_consultancy_individual_2205",
      "legal_consultancy_individual_2206",
      "legal_consultancy_individual_2623",
      "legal_consultancy_individual_2624",
      "legal_consultancy_individual_2633",
      "legal_consultancy_individual_2634",
      "legal_consultancy_individual_2865",
      "legal_consultancy_individual_2866",
      "legal_consultancy_individual_2981",
      "legal_consultancy_individual_2982",
      "legal_consultancy_individual_3004",
      "legal_consultancy_individual_3032",
      "legal_consultancy_individual_3033",
      "legal_consultancy_individual_3040",
      "legal_consultancy_individual_3041",
      "legal_consultancy_individual_3100",
      "legal_consultancy_individual_3151",
      "legal_consultancy_individual_3152"
    ],
    "slug": "hourani-partners-legal-consultancy-fzco"
  },
  {
    "id": "legal_consultancy_firms_81",
    "name": "Hugh Fraser International Legal Consultancy",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/06/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_81",
        "address": "Level 41, Emirates Towers ,Sheykh Zayed Road, World Trade Center, DIFC ,31303 ,",
        "emirate": "Dubai",
        "phone": "97143827717 / 971585956361",
        "email": "hugh.fraser@hfi-consulting.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1781",
      "legal_consultancy_individual_1782"
    ],
    "slug": "hugh-fraser-international-legal-consultancy"
  },
  {
    "id": "legal_consultancy_firms_82",
    "name": "Hunton Andrews Kurth Ltd",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "18/06/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_82",
        "address": "1 ,The Gate, East. ,The Gate District ,118273 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144019160 / 971506575038",
        "email": "ptiller@huntonak.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "hunton-andrews-kurth-ltd"
  },
  {
    "id": "advocacy_firms_349",
    "name": "IBRAHIM AL QASSIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_349",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142224441",
        "email": "info@ialqassim.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_7",
      "advocacy_individual_1007",
      "advocacy_individual_1008"
    ],
    "slug": "ibrahim-al-qassim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_350",
    "name": "IBRAHIM ALBANNA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/04/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_350",
        "address": "الطابق الرابع ,الصقر للاعمال ,محطة مترو ابراج الامارات  ,67476 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143444210",
        "email": "assistant@albannaadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_714",
      "legal_consultancy_individual_2935",
      "legal_consultancy_individual_2936"
    ],
    "slug": "ibrahim-albanna-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_351",
    "name": "IBRAHIM ALHAMMADI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_351",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143334404",
        "email": "info@ihadvo.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_709"
    ],
    "slug": "ibrahim-alhammadi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_352",
    "name": "IBRAHIM ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/07/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_352",
        "address": "15th Floor _ Office No. 1504 ,SOBHA SAPPHIRE ,Makani No: 2612485764 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145570789 / 971521800001",
        "email": "Info@iserkal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_706",
      "advocacy_individual_707",
      "legal_consultancy_individual_204",
      "legal_consultancy_individual_1931",
      "legal_consultancy_individual_1932",
      "legal_consultancy_individual_2370",
      "legal_consultancy_individual_2371"
    ],
    "slug": "ibrahim-alserkal-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_353",
    "name": "IBRAHIM HADDAD ADVOCATES AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/05/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_353",
        "address": "IBRAHIM ,الاول 107 ,مبني العويس المطار ,بنايه بيزنس افينو ,41334 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142566888",
        "email": "info@ihadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_712",
      "advocacy_individual_713",
      "legal_consultancy_individual_540"
    ],
    "slug": "ibrahim-haddad-advocates-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_354",
    "name": "IBRAHIM KHOURI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_354",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143266677 / 971506234989",
        "email": "md@khourilawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_708",
      "legal_consultancy_individual_205",
      "legal_consultancy_individual_206",
      "legal_consultancy_individual_1440",
      "legal_consultancy_individual_1441"
    ],
    "slug": "ibrahim-khouri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_355",
    "name": "INTERNATIONAL CONSULTANT LAW OFFICE",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/04/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_355",
        "address": "Saleh Ahmed Yousif Saleh Alobeidli ,2nd ,DUBAI SUPREME COURT COMPLEX ,Dubai Courts ,333842 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143546762",
        "email": "Laila@iclo.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_562",
      "advocacy_individual_1288",
      "advocacy_individual_1289",
      "legal_consultancy_individual_1505"
    ],
    "slug": "international-consultant-law-office"
  },
  {
    "id": "advocacy_firms_356",
    "name": "INTERNATIONAL COUNSELS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 9,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/04/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_356",
        "address": "4 - 449 ,Emarat Atrium ,Gulf News ,413533 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143211966",
        "email": "icalc@internationalcounsels.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_839",
      "advocacy_individual_840",
      "advocacy_individual_928",
      "advocacy_individual_929",
      "legal_consultancy_individual_1239",
      "legal_consultancy_individual_1240",
      "legal_consultancy_individual_1247",
      "legal_consultancy_individual_3130",
      "legal_consultancy_individual_3131"
    ],
    "slug": "international-counsels-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_357",
    "name": "ISMAIL ALSAFFAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/02/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_357",
        "address": "ISMAIL HASSAN EBRAHIM ALSAFFAR ,الطابق الثامن - مكتب 801 AFR ,الصقر للاعمال ,يوجد اسفل البناية مطعم وينديز ,25752 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143276805",
        "email": "info@alsaffar-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_721",
      "advocacy_individual_722",
      "legal_consultancy_individual_40",
      "legal_consultancy_individual_213",
      "legal_consultancy_individual_214",
      "legal_consultancy_individual_1713",
      "legal_consultancy_individual_3196"
    ],
    "slug": "ismail-alsaffar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_358",
    "name": "ISMAIL ALZAROONI ADVOCACY AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/10/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_358",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143433443 / 971509494490",
        "email": "ismail@izlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ismail-alzarooni-advocacy-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_359",
    "name": "ISMAIL HASSAN ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/07/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_359",
        "address": "ISMAIL HASSAN ALI MOHAMMAD ALJAABI ,102 ,PORT SAEED BUILDING ,EPPCO ,22703 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142395958",
        "email": "ismail.hassanlegal@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ismail-hassan-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_360",
    "name": "ISMAIL IBRAHIM ALHOSANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/04/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_360",
        "address": "ISMAIL IBRAHIM ALHOSANI ,الثالث ,القرهود ستار ,سالم لفحص اللياقة ,76113 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144498077 / 971508133077",
        "email": "advocateismailalhosani@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "ismail-ibrahim-alhosani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_361",
    "name": "ISSA & ABI YOUNES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/02/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_361",
        "address": "ROULA MAALOUF ,5- UNIT 514 ,LIBERTY HOUSE ,RITZ HOTEL DIFC ,506949 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148359858",
        "email": "issa@iaalo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1500",
      "advocacy_individual_1501"
    ],
    "slug": "issa-abi-younes-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_362",
    "name": "JAAFAR ALWAN & AL JAZIRI & ASSOCIATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 20,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_362",
        "address": "Hussain Ali Al Jaziri ,11 ,City Tower 2 ,Crown Plaza hotel Sheikh Zayed Road ,4253 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142626777 / 971529087670",
        "email": "courts@jaflaws.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_419",
      "advocacy_individual_423",
      "advocacy_individual_700",
      "advocacy_individual_701",
      "advocacy_individual_878",
      "advocacy_individual_879",
      "advocacy_individual_1429",
      "legal_consultancy_individual_91",
      "legal_consultancy_individual_92",
      "legal_consultancy_individual_387",
      "legal_consultancy_individual_554",
      "legal_consultancy_individual_555",
      "legal_consultancy_individual_944",
      "legal_consultancy_individual_1130",
      "legal_consultancy_individual_1131",
      "legal_consultancy_individual_1485",
      "legal_consultancy_individual_1486",
      "legal_consultancy_individual_1676",
      "legal_consultancy_individual_2066",
      "legal_consultancy_individual_2067"
    ],
    "slug": "jaafar-alwan-al-jaziri-associates"
  },
  {
    "id": "advocacy_firms_363",
    "name": "JABIR RASHID AL SALAMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/03/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_363",
        "address": "jabir rashid alsalami ,b3607 ,latifa tower ,crowne plaza hotel - dubai ,3117 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143599997",
        "email": "jabir@jabiralsalami.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_240",
      "advocacy_individual_241",
      "advocacy_individual_895"
    ],
    "slug": "jabir-rashid-al-salami-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_364",
    "name": "JAMAL ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_364",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144919339 / 971000000000",
        "email": "info@advo.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "jamal-alshamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_365",
    "name": "JAMAL ALSHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/04/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_365",
        "address": "Jamal Hamad Obaid Alshehhi ,7 ,CENTURY 21 BLDG ,مركز حمر عين - مركز القبائل ,11977 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143376360 / 971556980980",
        "email": "info@alshehilaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_729",
      "advocacy_individual_730"
    ],
    "slug": "jamal-alshehhi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_366",
    "name": "JAMILA ALMEHIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/08/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_366",
        "address": "JAMILA SAEED ,طابق الميزانين مكتب رقم M18 ,برج بيزنيس أفينيو ,معرض شركة نيسان للسيارات ,23677 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148866123 / 971528003000",
        "email": "jamila.almheiriadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "jamila-almehiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_367",
    "name": "JAMILA ALZAHRANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_367",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145681225",
        "email": "info@jalzahrani.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_735",
      "advocacy_individual_736"
    ],
    "slug": "jamila-alzahrani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_368",
    "name": "JASEM AL BLOUSHI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/08/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_368",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145780666",
        "email": "courts@jasem-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_737"
    ],
    "slug": "jasem-al-bloushi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_369",
    "name": "JASIM ALHADDAD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/08/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_369",
        "address": "الثاني عشر مكتب 1201 ,مبنى امباير هايتس البرج B ,بنك رأس الخيمة ,00000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142611689 / 971561234514",
        "email": "info@nja.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_743",
      "advocacy_individual_744",
      "advocacy_individual_1065",
      "legal_consultancy_individual_2190",
      "legal_consultancy_individual_2191"
    ],
    "slug": "jasim-alhaddad-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_370",
    "name": "JASIM ALMAEENI ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/06/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_370",
        "address": "Floor 7 ,Sama Tower  ,Dubai World Trade Centre ,120059 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142954626 / 971506311169",
        "email": "info@jmadvocatesuae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_745",
      "advocacy_individual_746"
    ],
    "slug": "jasim-almaeeni-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_371",
    "name": "JASIM ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_371",
        "address": "KEFAH ALZAABI ,3005 ,برج لطيفه  ,ابراج لطيفه  ,97597 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142522260",
        "email": "info@jazlawyers.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_136",
      "legal_consultancy_individual_1922"
    ],
    "slug": "jasim-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_372",
    "name": "JASSIM AL SUWAIDI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_372",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143530018",
        "email": "info@alsuwaidiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_662",
      "advocacy_individual_748",
      "advocacy_individual_1089",
      "advocacy_individual_1090"
    ],
    "slug": "jassim-al-suwaidi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_373",
    "name": "JUMA ALNAQBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "28/04/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_373",
        "address": "Juma Alnaqbi  ,1105 ,IRIS BAY ,Burj Khalifa  ,11161 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142999006 / 971504908111",
        "email": "jumaalnaqbi.dxb@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_754"
    ],
    "slug": "juma-alnaqbi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_374",
    "name": "JUMA KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/05/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_374",
        "address": "Juma Khalifa  ,Block A office A304 ,Saraya avenue  ,GGCO metro station  ,430055 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142229449 / 971508857744",
        "email": "Gov@jkuaeadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_803"
    ],
    "slug": "juma-khalifa-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_84",
    "name": "James Berry & Associates Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "26/06/1989",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_84",
        "address": "1 ,API World Tower ,258.37 square meters ,52294 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143317552 / 971504524322",
        "email": "berry@jamesberrylaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "james-berry-associates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_86",
    "name": "K & L Gates LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "29/04/2009",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_86",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144272700 / 971545824605",
        "email": "tony.griffiths@klgates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "k-l-gates-llp"
  },
  {
    "id": "advocacy_firms_375",
    "name": "KANAAN ADVOCATES& LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_375",
        "address": "Samir Kanaan ,Office 502 Floor 5 ,Bay Square Building 11 ,South Ridge Apartments ,101 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142775444",
        "email": "info@kanlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1329",
      "advocacy_individual_1330",
      "legal_consultancy_individual_1113"
    ],
    "slug": "kanaan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_376",
    "name": "KASHWANI LAW FIRM",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 11,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "12/12/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_376",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143528887",
        "email": "info@kashwanilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_183",
      "advocacy_individual_184",
      "advocacy_individual_390",
      "advocacy_individual_630",
      "advocacy_individual_631",
      "advocacy_individual_717",
      "advocacy_individual_718",
      "legal_consultancy_individual_1542",
      "legal_consultancy_individual_2619",
      "legal_consultancy_individual_2620",
      "legal_consultancy_individual_516"
    ],
    "slug": "kashwani-law-firm"
  },
  {
    "id": "legal_consultancy_firms_88",
    "name": "KBH Limited",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "01/07/2006",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_88",
        "address": "Emirates Financial Towers (South) ,DIFC ,506546 ,",
        "emirate": "Dubai",
        "phone": "97147096700 / 971505573843",
        "email": "dk@kbh.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "kbh-limited"
  },
  {
    "id": "advocacy_firms_378",
    "name": "KHADIJA ALKHANBOULI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_378",
        "address": "khadija sulaiman obaid alkhanboli ,18 ,opal tawer ,burj khalifa ,31431 ,Dubai",
        "emirate": "Dubai",
        "phone": "97153966699",
        "email": "lawyer.khadija.alkhanbouli@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_768"
    ],
    "slug": "khadija-alkhanbouli-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_379",
    "name": "KHADIJAH SOHAIL LAWYERS & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/04/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_379",
        "address": "khadijah sohail hassan asaadi ,طابق الميزانيين  ,ايميجت  ,مترو الخليج التجاري  ,41342 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143438885",
        "email": "info@asaadi.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_503",
      "advocacy_individual_769",
      "legal_consultancy_individual_3159",
      "legal_consultancy_individual_3160"
    ],
    "slug": "khadijah-sohail-lawyers-legal-consultants"
  },
  {
    "id": "advocacy_firms_380",
    "name": "KHAIFA ALKHATRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_380",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "info@khalifaadv.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_223",
      "advocacy_individual_224",
      "advocacy_individual_805"
    ],
    "slug": "khaifa-alkhatri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_381",
    "name": "KHAIRALLAH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_381",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144270845",
        "email": "info@khairallahlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "khairallah-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_382",
    "name": "KHALED ALMARRI & PARTNERS& LEGAL CONSULTATIONS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/04/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_382",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142659440",
        "email": "info@klaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_322",
      "advocacy_individual_907",
      "advocacy_individual_908",
      "legal_consultancy_individual_815",
      "legal_consultancy_individual_816",
      "legal_consultancy_individual_1572",
      "legal_consultancy_individual_1573"
    ],
    "slug": "khaled-almarri-partners-legal-consultations"
  },
  {
    "id": "advocacy_firms_383",
    "name": "KHALFAN ALKAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/03/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_383",
        "address": "الطابق الثامن ,بزنس افنيو ,فندق الخوري سكاي جاردن  ,126510 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142572778",
        "email": "zakia@houseofj.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_124",
      "advocacy_individual_125",
      "advocacy_individual_780",
      "advocacy_individual_781"
    ],
    "slug": "khalfan-alkaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_384",
    "name": "KHALID ABDALLA ALTAMIMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 17,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "20/05/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_384",
        "address": "الطابق 7 مكتب رقم 070A ,برج رولكس  ,محطة مترو المركز المالي  ,66300 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143444029",
        "email": "ekp.khalidaltmimi@ekplegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_16",
      "legal_consultancy_individual_17",
      "legal_consultancy_individual_196",
      "legal_consultancy_individual_2382",
      "legal_consultancy_individual_2383",
      "legal_consultancy_individual_2469",
      "legal_consultancy_individual_2973",
      "legal_consultancy_individual_2974",
      "legal_consultancy_individual_2995",
      "legal_consultancy_individual_2996",
      "legal_consultancy_individual_354",
      "legal_consultancy_individual_355",
      "legal_consultancy_individual_562",
      "legal_consultancy_individual_563",
      "legal_consultancy_individual_676",
      "legal_consultancy_individual_677",
      "legal_consultancy_individual_68"
    ],
    "slug": "khalid-abdalla-altamimi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_386",
    "name": "KHALID ALSAROOKH ADVOCATES AND LEGAL CONSUTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/05/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_386",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143304477 / 97143304477",
        "email": "admin@os-legal.net",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_800",
      "advocacy_individual_801"
    ],
    "slug": "khalid-alsarookh-advocates-and-legal-consutancy"
  },
  {
    "id": "advocacy_firms_387",
    "name": "KHALID ALSUWAIDI LAWYERS LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/07/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_387",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142429499 / 97142429499",
        "email": "k.alsuwaidi@kmsadvocate.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_799"
    ],
    "slug": "khalid-alsuwaidi-lawyers-legal-consultants"
  },
  {
    "id": "advocacy_firms_388",
    "name": "KHALID ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/08/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_388",
        "address": "304 ,Ithraa Building ,Emirates Aviation Academy Street / In front of Al Garhoud Mosque ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148323133",
        "email": "khalidalzaabiadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_794",
      "legal_consultancy_individual_134",
      "legal_consultancy_individual_135"
    ],
    "slug": "khalid-alzaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_389",
    "name": "KHALID ALZAROONI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/03/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_389",
        "address": "الرابع /412 ,مركز سلطان للأعمال  ,لامسى بلازا  ,97916 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144533568 / 971502744454",
        "email": "khalid.alzarooniadvocate@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_790"
    ],
    "slug": "khalid-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_390",
    "name": "KHALID BIN MOHAMMAD ALQASEMI ATTORNEY & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_390",
        "address": "6 ,latifa tower ,near crown plaza hotel  ,102999 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143799979",
        "email": "lawkmq@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_169",
      "advocacy_individual_170",
      "legal_consultancy_individual_581",
      "legal_consultancy_individual_892",
      "legal_consultancy_individual_986",
      "legal_consultancy_individual_2933",
      "legal_consultancy_individual_2934"
    ],
    "slug": "khalid-bin-mohammad-alqasemi-attorney-legal-consultants"
  },
  {
    "id": "advocacy_firms_391",
    "name": "KHALID HATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/06/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_391",
        "address": "KHALID KHALIFA MOHD SAIF HATHBOOR ,OFFICE 1001 ,NOUF TOWER ,BUSINESS VILLAGA ,300643 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142230257 / 971567057052",
        "email": "info@khhlawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "khalid-hathboor-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_392",
    "name": "KHALID KALANDAR ALMAAZMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_392",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142942616",
        "email": "info@ilofficeuae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_792",
      "legal_consultancy_individual_535",
      "legal_consultancy_individual_536",
      "legal_consultancy_individual_2200",
      "legal_consultancy_individual_2502",
      "legal_consultancy_individual_2503",
      "legal_consultancy_individual_3193",
      "legal_consultancy_individual_3194"
    ],
    "slug": "khalid-kalandar-almaazmi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_393",
    "name": "KHALIFA AL MAFTOOL ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_393",
        "address": "next level restaurant  , centurion star - block B - office 806 & 807 ,behind day to day - opposite deira city center ,237766 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142622002",
        "email": "info@almaftool-advocate.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_806",
      "legal_consultancy_individual_145",
      "legal_consultancy_individual_1960",
      "legal_consultancy_individual_1980",
      "legal_consultancy_individual_1981"
    ],
    "slug": "khalifa-al-maftool-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_394",
    "name": "KHALIFA ALSADA ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "05/11/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_394",
        "address": "الطابق الثالث ,بناية مكاتب عود ميثاء ,سيتي بانك ,78853 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142220585 / 971506555166",
        "email": "info@kasadv.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "khalifa-alsada-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_396",
    "name": "KHALIFA BIN OMAIR ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/08/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_396",
        "address": "4 ,Century 21 building ,al kabayel discount centre ,340781 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142417888 / 971562693277",
        "email": "dubai@khbinomair.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_118",
      "advocacy_individual_119",
      "advocacy_individual_410",
      "advocacy_individual_812",
      "advocacy_individual_1160",
      "advocacy_individual_1161",
      "legal_consultancy_individual_589",
      "legal_consultancy_individual_590"
    ],
    "slug": "khalifa-bin-omair-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_397",
    "name": "KHALIL BIN SAIF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/11/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_397",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142955545",
        "email": "dr.khalil.saif@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "khalil-bin-saif-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_398",
    "name": "KHAWLA AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_398",
        "address": "Office No. 601 ,Business Avenue Building ,Behind Nissan Showroom, Makani No: 3248594620 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142369992 / 971503199393",
        "email": "info@almheiriadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1528",
      "legal_consultancy_individual_1529"
    ],
    "slug": "khawla-al-mheiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_399",
    "name": "KHAWLA SAEED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/12/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_399",
        "address": "Khawla Saeed Mohammed Salem ,414 ,DBCS BUILDING ,محكمة الاحوال الشخصية ,73879 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143530354 / 971503787848",
        "email": "info@ksadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_820",
      "legal_consultancy_individual_874",
      "legal_consultancy_individual_875",
      "legal_consultancy_individual_3126",
      "legal_consultancy_individual_3127"
    ],
    "slug": "khawla-saeed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_400",
    "name": "KHULOUD SAEED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/01/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_400",
        "address": "Mohamed Ibrahim amer ,25 ,Iris bay ,Business bay ,3939 ,Dubai",
        "emirate": "Dubai",
        "phone": "97125520551",
        "email": "admin@khuloudsaeed.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_827",
      "legal_consultancy_individual_198",
      "legal_consultancy_individual_2031"
    ],
    "slug": "khuloud-saeed-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_90",
    "name": "Kennedys Dubai LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/04/2006",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_90",
        "address": "Building 5 ,Dubai World Trade Centre ,212620 ,",
        "emirate": "Dubai",
        "phone": "97143503600 / 971563631562",
        "email": "p.ellingham@kennedys-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_406",
      "legal_consultancy_individual_753",
      "legal_consultancy_individual_754",
      "legal_consultancy_individual_1474",
      "legal_consultancy_individual_2212",
      "legal_consultancy_individual_3044",
      "legal_consultancy_individual_3045"
    ],
    "slug": "kennedys-dubai-llp"
  },
  {
    "id": "legal_consultancy_firms_91",
    "name": "Kobre & Kim (GCC) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_91",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144543900 / 971569199020",
        "email": "paul.hughes@kobrekim.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_912",
      "legal_consultancy_individual_913",
      "legal_consultancy_individual_2161",
      "legal_consultancy_individual_2162",
      "legal_consultancy_individual_2746"
    ],
    "slug": "kobre-kim-gcc-llp"
  },
  {
    "id": "legal_consultancy_firms_92",
    "name": "Kochhar & Co Inc Legal Consultants (Dubai Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/05/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_92",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142776075 / 971588324788",
        "email": "avichal@kochhardubai.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_530",
      "legal_consultancy_individual_531",
      "legal_consultancy_individual_661",
      "legal_consultancy_individual_662",
      "legal_consultancy_individual_1349",
      "legal_consultancy_individual_1350",
      "legal_consultancy_individual_1967",
      "legal_consultancy_individual_2213",
      "legal_consultancy_individual_2602",
      "legal_consultancy_individual_2603",
      "legal_consultancy_individual_2771",
      "legal_consultancy_individual_2772"
    ],
    "slug": "kochhar-co-inc-legal-consultants-dubai-branch"
  },
  {
    "id": "advocacy_firms_401",
    "name": "LAW FIRM INTERNATIONAL ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_401",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142959506",
        "email": "contactus@lawfirmint.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1678",
      "legal_consultancy_individual_1679"
    ],
    "slug": "law-firm-international-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_402",
    "name": "LAW OFFICE AHMED JASEM ABDULLA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/06/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_402",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142957785",
        "email": "alrashed-advocates@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "law-office-ahmed-jasem-abdulla-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_403",
    "name": "LAW OFFICE OF MAHMOUD AL HAWAI ATTORNEYS &CONSULTANTS AT LAW",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 10,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_403",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142868681",
        "email": "hawailaw@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_139",
      "advocacy_individual_632",
      "advocacy_individual_633",
      "advocacy_individual_711",
      "advocacy_individual_842",
      "advocacy_individual_843",
      "legal_consultancy_individual_1225",
      "legal_consultancy_individual_1226",
      "legal_consultancy_individual_1905",
      "legal_consultancy_individual_1906"
    ],
    "slug": "law-office-of-mahmoud-al-hawai-attorneys-consultants-at-law"
  },
  {
    "id": "advocacy_firms_404",
    "name": "LIBERALS LAWYERS LEGAL CONSULTANTS AND LAWYERS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_404",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143213302",
        "email": "lawfirm@liberallawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1180",
      "legal_consultancy_individual_1257"
    ],
    "slug": "liberals-lawyers-legal-consultants-and-lawyers"
  },
  {
    "id": "advocacy_firms_405",
    "name": "LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_405",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142957333",
        "email": "info@lootah-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_56",
      "advocacy_individual_488",
      "advocacy_individual_489"
    ],
    "slug": "lootah-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_406",
    "name": "LOUBNA WALIED MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/11/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_406",
        "address": "",
        "emirate": "Dubai",
        "phone": "97100000000 / 971544444720",
        "email": "info@lwlawyers.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_833"
    ],
    "slug": "loubna-walied-mohamed-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_96",
    "name": "LPA (Middle East) LTD",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/04/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_96",
        "address": "Central Park Towers ,507120 ,",
        "emirate": "Dubai",
        "phone": "97143200940 / 971502397176",
        "email": "lsahbani@lpalaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_496",
      "legal_consultancy_individual_497",
      "legal_consultancy_individual_1186",
      "legal_consultancy_individual_1187",
      "legal_consultancy_individual_1597",
      "legal_consultancy_individual_1598"
    ],
    "slug": "lpa-middle-east-ltd"
  },
  {
    "id": "advocacy_firms_407",
    "name": "LUBNA MOOSA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/03/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_407",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145799599 / 971457995992",
        "email": "info@lmlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_453",
      "advocacy_individual_834",
      "legal_consultancy_individual_43",
      "legal_consultancy_individual_44",
      "legal_consultancy_individual_2058",
      "legal_consultancy_individual_2059"
    ],
    "slug": "lubna-moosa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_408",
    "name": "LUTFI & COMPANY ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/12/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_408",
        "address": "1201 ,برج تريو اي بي اي اوفيس  ,فندق نوافتيل ,8812 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144222555",
        "email": "lutfilaw2020@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_348",
      "advocacy_individual_1320",
      "legal_consultancy_individual_167",
      "legal_consultancy_individual_2899",
      "legal_consultancy_individual_2900",
      "legal_consultancy_individual_3217",
      "legal_consultancy_individual_3218"
    ],
    "slug": "lutfi-company-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_93",
    "name": "Latham & Watkins LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 21,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/02/2008",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_93",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506698 ,Dubai",
        "emirate": "Dubai",
        "phone": "97147046300 / 971507900661",
        "email": "nada.mourad@lw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_141",
      "legal_consultancy_individual_447",
      "legal_consultancy_individual_587",
      "legal_consultancy_individual_588",
      "legal_consultancy_individual_714",
      "legal_consultancy_individual_715",
      "legal_consultancy_individual_786",
      "legal_consultancy_individual_787",
      "legal_consultancy_individual_955",
      "legal_consultancy_individual_974",
      "legal_consultancy_individual_975",
      "legal_consultancy_individual_1632",
      "legal_consultancy_individual_2146",
      "legal_consultancy_individual_2147",
      "legal_consultancy_individual_2339",
      "legal_consultancy_individual_2546",
      "legal_consultancy_individual_2728",
      "legal_consultancy_individual_2729",
      "legal_consultancy_individual_2907",
      "legal_consultancy_individual_2991",
      "legal_consultancy_individual_2992"
    ],
    "slug": "latham-watkins-llp"
  },
  {
    "id": "legal_consultancy_firms_94",
    "name": "LinkLaters LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "22/02/2006",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_94",
        "address": "ICD Brookfield Place ,DIFC ,506516 ,",
        "emirate": "Dubai",
        "phone": "97143695800 / 971505526206",
        "email": "scott.campbell@linklaters.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "linklaters-llp"
  },
  {
    "id": "advocacy_firms_409",
    "name": "MAAMOUN AL KHOULI & ASSOCIATES ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_409",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143368833",
        "email": "alkhouli@alkhoulilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_327",
      "legal_consultancy_individual_1245",
      "legal_consultancy_individual_1576",
      "legal_consultancy_individual_1577"
    ],
    "slug": "maamoun-al-khouli-associates-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_410",
    "name": "MAHA ALFAHIM LAWYER & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/07/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_410",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142805852 / 971528500681",
        "email": "info@alfahimadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_837",
      "advocacy_individual_838"
    ],
    "slug": "maha-alfahim-lawyer-legal-consultants"
  },
  {
    "id": "advocacy_firms_411",
    "name": "MAHA BIN HENDI LAW FIRM",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/02/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_411",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142405888",
        "email": "m.binhendi@mbhlawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_877"
    ],
    "slug": "maha-bin-hendi-law-firm"
  },
  {
    "id": "advocacy_firms_412",
    "name": "MAHMOOD BIN JABER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/06/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_412",
        "address": "",
        "emirate": "Dubai",
        "phone": "97140000000 / 971504404084",
        "email": "info@mjlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mahmood-bin-jaber-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_413",
    "name": "MAHMOOD HUSSAIN ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/09/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_413",
        "address": "sohail jassem pararin ,34 ,Central Park Tower ,Dubai Mall ,233066 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144228410",
        "email": "info@mahmoodhussain.net",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_841",
      "advocacy_individual_1183",
      "advocacy_individual_1321",
      "advocacy_individual_1322",
      "legal_consultancy_individual_1751",
      "legal_consultancy_individual_3201"
    ],
    "slug": "mahmood-hussain-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_414",
    "name": "MAI ALFALASI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/07/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_414",
        "address": "MAI ALFALASI ADVOCATES AND LEGAL CONSULTANCY ,RECEPTION ,GREEN TOWER ,UNITED ARAB BANK ,93279 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142230666 / 97142230666",
        "email": "info@maaflegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_848",
      "advocacy_individual_849",
      "legal_consultancy_individual_1304"
    ],
    "slug": "mai-alfalasi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_415",
    "name": "MAITHA DALMOOK ADVOCATES AND LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_415",
        "address": "الطابق العاشر .. Tenth floor ,برج الحواي .. AL HAWAI TOWER  ,محطة مترو المركز المالي .. Financial Centre Metro Station  ,444091 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143393880 / 971554003333",
        "email": "info@maithadalmook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_854",
      "advocacy_individual_855",
      "legal_consultancy_individual_1958",
      "legal_consultancy_individual_1959"
    ],
    "slug": "maitha-dalmook-advocates-and-legal-consultancy"
  },
  {
    "id": "advocacy_firms_416",
    "name": "MAJED BINWEQAISH & SHOAIB ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/11/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_416",
        "address": "Office F13 ,Business Center - CAPITAL UNITED ,Makani No: 3274893760 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971528588888",
        "email": "shoaib@mswlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1395"
    ],
    "slug": "majed-binweqaish-shoaib-alawadhi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_417",
    "name": "MAJID ALJASSIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/01/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_417",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142212112",
        "email": "info@mjlaw.co",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_202",
      "legal_consultancy_individual_203"
    ],
    "slug": "majid-aljassim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_418",
    "name": "MAJID ALSKAIKH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/10/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_418",
        "address": "11 ,بناية صبحة ايفوري 2 ,ماما شيلتر أوتيل ,9598 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143880171 / 971565359809",
        "email": "malawyer@malawyer.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_375",
      "advocacy_individual_376",
      "legal_consultancy_individual_979",
      "legal_consultancy_individual_1693"
    ],
    "slug": "majid-alskaikh-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_419",
    "name": "MAJID HAMAD AL KALBANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/03/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_419",
        "address": "BLOCK B - OFFICE NO. 208 ,BUSHAQER Building ,Makani No: 3289393656 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142217010 / 971504993366",
        "email": "majidlawyer726@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_861",
      "advocacy_individual_935",
      "advocacy_individual_936",
      "legal_consultancy_individual_350"
    ],
    "slug": "majid-hamad-al-kalbani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_420",
    "name": "MAKKI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/12/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_420",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142209370",
        "email": "tmjs1951_advocatelaw@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1440",
      "advocacy_individual_1441"
    ],
    "slug": "makki-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_421",
    "name": "MANAWAHA HASHIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/10/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_421",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142621293",
        "email": "manawaha369advocates@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_870"
    ],
    "slug": "manawaha-hashim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_422",
    "name": "MANEA ALMHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/04/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_422",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142500007",
        "email": "info@maadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "manea-almheiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_423",
    "name": "MANSOOR LOTAAH ADVOCATES &LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/08/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_423",
        "address": "mansoor lootah ,مطعم شيلز ,صالح بن لاحج , مطعم شيلز  ,95151 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142833337 / 971559596445",
        "email": "info@mansoorlootahadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_84",
      "advocacy_individual_85",
      "advocacy_individual_455",
      "legal_consultancy_individual_539",
      "legal_consultancy_individual_1907",
      "legal_consultancy_individual_1908",
      "legal_consultancy_individual_2110"
    ],
    "slug": "mansoor-lotaah-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_424",
    "name": "MARIAM AHMED SALEM ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/07/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_424",
        "address": "talal  ,2TH FLOOR ,AL ETIHAD BUILDING  ,DEIRA CITY CENTRE ,1111 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142236999 / 97142236999",
        "email": "mariamahmedadvocate@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_882",
      "advocacy_individual_883",
      "advocacy_individual_1435"
    ],
    "slug": "mariam-ahmed-salem-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_425",
    "name": "MARIAM AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_425",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142554421",
        "email": "mariam.alshamsi@triumphco.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mariam-al-shamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_426",
    "name": "MARIAM IBRAHIM ALAMERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_426",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "info@mariamalameri.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_888"
    ],
    "slug": "mariam-ibrahim-alameri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_427",
    "name": "MARIAM OBAID ALBLOOSHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/02/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_427",
        "address": "Second Floor - Office No. 208 ,Al Wasl Tower - City Walk - Sheikha Raisa Khalifa Bin Saeed Al Maktoum Building ,Makani No:  2550888537 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97150707114 / 971507071144",
        "email": "mem.aaa.lawyer@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mariam-obaid-alblooshi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_429",
    "name": "MARWA ALRIYAMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_429",
        "address": "marwa hamad saeed Musallam alriyami ,12 ,concord tower ,media city ,1500377 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144473110",
        "email": "Marwa_alriyami@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_899"
    ],
    "slug": "marwa-alriyami-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_428",
    "name": "MARWA Al SUWAIDI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/09/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_428",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143991619 / 971566355726",
        "email": "info@marwaadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_897",
      "advocacy_individual_898"
    ],
    "slug": "marwa-al-suwaidi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_430",
    "name": "MARWA SULIMAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/03/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_430",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971501077776",
        "email": "mimalsham@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_901",
      "advocacy_individual_902"
    ],
    "slug": "marwa-suliman-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_431",
    "name": "MARYAM ABDULLAH ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/08/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_431",
        "address": "الطابق الاول  ,بناية مشاريع قرقاش - مكتب رقم 102  ,وكاله مرسيدس  ,393947 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143799917",
        "email": "info@amt-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_905",
      "advocacy_individual_906",
      "legal_consultancy_individual_244",
      "legal_consultancy_individual_245",
      "legal_consultancy_individual_966",
      "legal_consultancy_individual_3209"
    ],
    "slug": "maryam-abdullah-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_432",
    "name": "MARYAM ALYASSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/09/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_432",
        "address": "Maryam Essa Mohammad Abdulaziz Alyassi ,M06  ,THE ARCADE  ,ALGARHOUD METRO STATION  ,283023 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143852835 / 971543314762",
        "email": "info@alyassiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1028"
    ],
    "slug": "maryam-alyassi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_433",
    "name": "MARYAM HAYYAZ & WEJDAN BUSHAHAB ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/12/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_433",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143422244 / 97143422244",
        "email": "info@maryamwejdan.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_335",
      "advocacy_individual_336",
      "advocacy_individual_1461",
      "advocacy_individual_1462"
    ],
    "slug": "maryam-hayyaz-wejdan-bushahab-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_434",
    "name": "MARYAM SAIF KHATEM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/05/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_434",
        "address": "Office No. M26 ,Al Garhoud Business Centre ,Al Garhoud Business Centre ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142520160 / 971000000000",
        "email": "info@msklaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_919"
    ],
    "slug": "maryam-saif-khatem-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_435",
    "name": "MAYED ALMARASHDA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/08/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_435",
        "address": "MAYED  AL MRASHIDA  ,طيران ايران  ,برج السالمية  الطابق 8 مكتب رقم 804 ,الربج الاخضر  ,354999 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142225955 / 971552298952",
        "email": "info@mayedadv.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1205"
    ],
    "slug": "mayed-almarashda-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_436",
    "name": "MEG LEGAL SERVICES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_436",
        "address": "NABIH AHMED BADER ,Level M Office 203   , The Dubai Mall Fountain Views ,Social District Fountain Views,  Burak Restaurant ,182859 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142384655",
        "email": "nbader@eptalex.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1490"
    ],
    "slug": "meg-legal-services"
  },
  {
    "id": "advocacy_firms_437",
    "name": "MELEIH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_437",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142999720",
        "email": "meleihadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_756",
      "legal_consultancy_individual_1677"
    ],
    "slug": "meleih-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_438",
    "name": "MOAZA AL KHADAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/10/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_438",
        "address": "مطعم زعتر وزيت  ,اسبكت تاور  ,فندق تاج  ,118212 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144433013 / 97144433013",
        "email": "moaza.alkhadar.alc@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1067",
      "advocacy_individual_1068",
      "legal_consultancy_individual_2218",
      "legal_consultancy_individual_2219",
      "legal_consultancy_individual_2580",
      "legal_consultancy_individual_2581",
      "legal_consultancy_individual_2709"
    ],
    "slug": "moaza-al-khadar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_439",
    "name": "MOHAMAD IBRAHIM SALMEEN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/09/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_439",
        "address": "MOHAMAD SALMEEN ,304 ,بيزنس افنيو ,مطار دبي ,119474 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143300346",
        "email": "info@mis.lawyer",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_933",
      "advocacy_individual_934"
    ],
    "slug": "mohamad-ibrahim-salmeen-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_440",
    "name": "MOHAMED ABDULILAH ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "09/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_440",
        "address": "الطابق الثاني ,امارات اتريوم ,مبني الامارات للبترول ,2311 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145823288 / 971552222311",
        "email": "info@lmh.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_941",
      "advocacy_individual_942"
    ],
    "slug": "mohamed-abdulilah-alhamed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_441",
    "name": "MOHAMED ABDULLA & YOUSUF ALHAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_441",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143702000 / 971504844414",
        "email": "advoy.m@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_767",
      "advocacy_individual_1015",
      "advocacy_individual_1016"
    ],
    "slug": "mohamed-abdulla-yousuf-alhammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_442",
    "name": "MOHAMED ABDULLA ALMARZOOQI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/05/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_442",
        "address": "Second Floor - Office No. 44 ,SUNSET Mall ,Makani No: 2129186503 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971558989828",
        "email": "L.ALMARZOOQI1110@GMAIL.COM",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_939",
      "advocacy_individual_940"
    ],
    "slug": "mohamed-abdulla-almarzooqi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_443",
    "name": "MOHAMED ABDULLA LAWYERS AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 11,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_443",
        "address": "samer tohme ,4th- office 433 ,Emarat Atrium ,Dubai Canal ,79436 ,Dubai",
        "emirate": "Dubai",
        "phone": "97126722500",
        "email": "info@dxblawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_121",
      "advocacy_individual_551",
      "advocacy_individual_552",
      "legal_consultancy_individual_667",
      "legal_consultancy_individual_1639",
      "legal_consultancy_individual_2439",
      "legal_consultancy_individual_2440",
      "legal_consultancy_individual_2714",
      "legal_consultancy_individual_2715",
      "legal_consultancy_individual_2722",
      "legal_consultancy_individual_2723"
    ],
    "slug": "mohamed-abdulla-lawyers-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_444",
    "name": "MOHAMED AL GHEFLI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/01/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_444",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142945678",
        "email": "maadvdubai@maadv.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_975",
      "legal_consultancy_individual_865",
      "legal_consultancy_individual_866"
    ],
    "slug": "mohamed-al-ghefli-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_445",
    "name": "MOHAMED AL HAJERI ADVOCATES & LEGAL CONSULTANTS  & NOTARY PUBLIC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/06/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_445",
        "address": "000000000 ,4 ,الريم  ,بلدية دبي  ,14593 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142276777",
        "email": "info@tglawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohamed-al-hajeri-advocates-legal-consultants-notary-public"
  },
  {
    "id": "advocacy_firms_446",
    "name": "MOHAMED AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "15/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_446",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142566800",
        "email": "fatema@alhammadiadvocate.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_971",
      "advocacy_individual_972",
      "legal_consultancy_individual_1221",
      "legal_consultancy_individual_1222"
    ],
    "slug": "mohamed-al-hammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_447",
    "name": "MOHAMED ALAZAZI LAWYERS & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/05/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_447",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143997700 / 971503707978",
        "email": "info@alazazi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1458",
      "legal_consultancy_individual_1268",
      "legal_consultancy_individual_1269"
    ],
    "slug": "mohamed-alazazi-lawyers-legal-consultancy"
  },
  {
    "id": "advocacy_firms_448",
    "name": "MOHAMED ALHATHBOOR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/09/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_448",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143799916 / 971556407627",
        "email": "ask@mahlawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_382"
    ],
    "slug": "mohamed-alhathboor-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_449",
    "name": "MOHAMED ALHEMEIRI LAWYERS AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_449",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145911811 / 971506137373",
        "email": "info@advoalhadhrami.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_788"
    ],
    "slug": "mohamed-alhemeiri-lawyers-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_450",
    "name": "MOHAMED ALI ALHAMMADI ADVOCATES & LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 11,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/08/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_450",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143300009 / 971501215000",
        "email": "mohamed@maa.law",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_141",
      "advocacy_individual_1011",
      "advocacy_individual_1012",
      "advocacy_individual_1228",
      "advocacy_individual_1229",
      "legal_consultancy_individual_1100",
      "legal_consultancy_individual_1101",
      "legal_consultancy_individual_3098",
      "legal_consultancy_individual_3099",
      "legal_consultancy_individual_3169",
      "legal_consultancy_individual_3170"
    ],
    "slug": "mohamed-ali-alhammadi-advocates-legal-consultant"
  },
  {
    "id": "advocacy_firms_451",
    "name": "MOHAMED ALKHEYAILI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/11/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_451",
        "address": "Mohamed Ali Saeed Humaid Al Kheyaili  ,Seventh Floor  ,Al Masaood Tower 2 ,Al Tadawi Medical Centre  ,88314 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142989662",
        "email": "info@mkladvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1192"
    ],
    "slug": "mohamed-alkheyaili-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_452",
    "name": "MOHAMED ALMARZOOQI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/08/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_452",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142253131 / 971503534441",
        "email": "info@ml-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_977",
      "legal_consultancy_individual_193"
    ],
    "slug": "mohamed-almarzooqi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_453",
    "name": "MOHAMED ALSAWAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/12/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_453",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143359122",
        "email": "alsawan64@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1057",
      "advocacy_individual_1058"
    ],
    "slug": "mohamed-alsawan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_454",
    "name": "MOHAMED ALSERKAL ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/03/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_454",
        "address": "Mohamed Thamer Yaqub Yousef Alserkal ,الطابق الثاني ,اعمار سكوير - بناء رقم 4 ,برج خليفة ,57409 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142622217 / 97142622217",
        "email": "mohamed@alserkallawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_36",
      "legal_consultancy_individual_1169",
      "legal_consultancy_individual_1217",
      "legal_consultancy_individual_1218",
      "legal_consultancy_individual_2683",
      "legal_consultancy_individual_2684",
      "legal_consultancy_individual_3110",
      "legal_consultancy_individual_3111"
    ],
    "slug": "mohamed-alserkal-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_455",
    "name": "MOHAMED ALSHAIKH ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_455",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142424288 / 971588961163",
        "email": "info@malshaikhadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_943",
      "advocacy_individual_944"
    ],
    "slug": "mohamed-alshaikh-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_456",
    "name": "MOHAMED ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/09/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_456",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142957399",
        "email": "advo.uae1@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohamed-alsuwaidi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_457",
    "name": "MOHAMED BINQANZOUL ALKETBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "04/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_457",
        "address": "MOHAMED RASHID ALKETBI ,G ,AIRPORT BUILDING ,مصرف أبو ظبي الإسلامي ,13094 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143332709",
        "email": "binqanzoul.ae@outlook.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohamed-binqanzoul-alketbi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_459",
    "name": "MOHAMMAD ALLINJAWI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_459",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143333386 / 971549916936",
        "email": "info@mtaadv.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_341",
      "legal_consultancy_individual_132",
      "legal_consultancy_individual_894",
      "legal_consultancy_individual_2009",
      "legal_consultancy_individual_2010",
      "legal_consultancy_individual_2326"
    ],
    "slug": "mohammad-allinjawi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_460",
    "name": "MOHAMMAD ALMEIHRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/08/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_460",
        "address": "Mohammad Al Mheiri ,الاول ,امارات اتريم  ,شارع الشيخ زايد ,37979 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143333405",
        "email": "info@al-mheiri.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_320",
      "advocacy_individual_1121",
      "advocacy_individual_1122",
      "legal_consultancy_individual_1184",
      "legal_consultancy_individual_1185"
    ],
    "slug": "mohammad-almeihri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_461",
    "name": "MOHAMMAD ALNAJJAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/05/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_461",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145642777 / 971508551535",
        "email": "legal@alnajjarlawyer.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_759",
      "advocacy_individual_999"
    ],
    "slug": "mohammad-alnajjar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_462",
    "name": "MOHAMMAD ALSAADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_462",
        "address": "210 ,OPAL TOWER ,BURJ KHALIFA ,96044 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143889993",
        "email": "admin@alsaadi-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_815",
      "advocacy_individual_1001",
      "advocacy_individual_1002",
      "legal_consultancy_individual_907"
    ],
    "slug": "mohammad-alsaadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_463",
    "name": "MOHAMMAD MASOUD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/08/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_463",
        "address": "13 ,INTERNATIONAL BUSINESS TOWER ,Next to The First Collection Business Bay Hotel ,6917 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143421661 / 971527070780",
        "email": "mohammad@masoudlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_997",
      "advocacy_individual_998",
      "advocacy_individual_1004",
      "advocacy_individual_1005"
    ],
    "slug": "mohammad-masoud-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_464",
    "name": "MOHAMMAD SHEHAB ALFARSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/06/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_464",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143256020 / 971504400073",
        "email": "info@sw-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_107",
      "legal_consultancy_individual_108",
      "legal_consultancy_individual_318",
      "legal_consultancy_individual_319",
      "legal_consultancy_individual_1925",
      "legal_consultancy_individual_1926"
    ],
    "slug": "mohammad-shehab-alfarsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_465",
    "name": "MOHAMMED ABDULLA ALBREIKE ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/03/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_465",
        "address": "MOHAMMED ABDULLA MOHSIN ABDURAHIM ALBREIKI ,406 ,ويست بيري ,برج خليفة ,220219 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145574529",
        "email": "d@albraikiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2069"
    ],
    "slug": "mohammed-abdulla-albreike-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_466",
    "name": "MOHAMMED AHMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "28/01/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_466",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143588887",
        "email": "e.lawyersd@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohammed-ahmed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_468",
    "name": "MOHAMMED AL HASHIMI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/04/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_468",
        "address": "MOHAMMED MURTADA ALHASHMI ,3 ,LATIFA TOWER  ,CROWN PLAZA ,231400 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143521131",
        "email": "info@mhadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_8",
      "advocacy_individual_1223",
      "legal_consultancy_individual_1915",
      "legal_consultancy_individual_1916",
      "legal_consultancy_individual_2538",
      "legal_consultancy_individual_3108",
      "legal_consultancy_individual_3109"
    ],
    "slug": "mohammed-al-hashimi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_469",
    "name": "MOHAMMED ALKUMAITI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/07/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_469",
        "address": "Office 210 ,Al-Fajr Complex ,Makani No: 2999793136 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142297799 / 971505504550",
        "email": "info@mkumaiti.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohammed-alkumaiti-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_470",
    "name": "MOHAMMED BANI HASHEM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/07/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_470",
        "address": "1007 ,برج لطيفة ,بجوار فندق كراون بلازل ,94873 ,Abu Dhabi",
        "emirate": "Dubai",
        "phone": "97142951555 / 971567573911",
        "email": "info@mbhadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_678",
      "advocacy_individual_679",
      "advocacy_individual_1408",
      "advocacy_individual_1409",
      "legal_consultancy_individual_1892",
      "legal_consultancy_individual_1893"
    ],
    "slug": "mohammed-bani-hashem-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_471",
    "name": "MOHAMMED BEKHIT ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/01/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_471",
        "address": "406 ,رقة البطين  ,بجوار فندق كونكورد  ,92414 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142666331",
        "email": "almeshref2019@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1995",
      "legal_consultancy_individual_3210"
    ],
    "slug": "mohammed-bekhit-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_472",
    "name": "MOHAMMED BIN SUWAIDAN ALMEQBAALI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/04/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_472",
        "address": "MOHAMMED SALEM ,11th floor, Office No. 1105 ,LAKE CENTRAL ,BURJ KHALIFA ,87087 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142411333",
        "email": "ga@hegazylaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohammed-bin-suwaidan-almeqbaali-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_473",
    "name": "MOHAMMED NEKHIRA ALDHAHERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/05/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_473",
        "address": "MOHAMMED NEKHAIRA ALDHAHERI ADVOCATES AND LEGAL CONSULTANT ,16 ,IRIS BAY ,ZOOM ,28177 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143323231 / 97143323231",
        "email": "Info@binnakhira.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohammed-nekhira-aldhaheri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_474",
    "name": "MOHAMMED SAEED ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/04/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_474",
        "address": "mohammed saeed salem alshamsi ,الاول ,مبنى خالد شعبان   ,دوار الساعه ,16916 ,Dubai",
        "emirate": "Dubai",
        "phone": "",
        "email": "info@lawyer-uae.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1997",
      "legal_consultancy_individual_1998"
    ],
    "slug": "mohammed-saeed-alshamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_475",
    "name": "MOHAMMED YOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_475",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971500000000",
        "email": "morshedy.legal@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1053",
      "advocacy_individual_1054"
    ],
    "slug": "mohammed-yousuf-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_476",
    "name": "MONTHER AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/12/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_476",
        "address": "MONTHER MOHAMWD ALHAMMADI ,API TOWER ,API WORLD TOWER ,CONRAD HOTEL ,300806 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142508555 / 971000000000",
        "email": "montheruae@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "monther-al-hammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_477",
    "name": "MOUSA ALAMRI ADVOCATES & LEGEL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_477",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142237666",
        "email": "info@musaalamri.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1061",
      "advocacy_individual_1062",
      "legal_consultancy_individual_1988",
      "legal_consultancy_individual_1989"
    ],
    "slug": "mousa-alamri-advocates-legel-consultants"
  },
  {
    "id": "advocacy_firms_478",
    "name": "MOZA ALJABRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/11/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_478",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142999434 / 971563666333",
        "email": "info@moaza-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_931",
      "advocacy_individual_932"
    ],
    "slug": "moza-aljabri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_479",
    "name": "MUNA AL ANSARI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_479",
        "address": "الأول 107 ,ناصر الساير ,فندق أسيانا ,27252 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142699255",
        "email": "mona1@lawyer.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_34"
    ],
    "slug": "muna-al-ansari-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_480",
    "name": "MUNA ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/10/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_480",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143553062 / 971506316315",
        "email": "moc@lawyermuna.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2119",
      "legal_consultancy_individual_2120"
    ],
    "slug": "muna-almazrouei-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_481",
    "name": "MUNA ALMULLA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_481",
        "address": "الطابق الرابع ,مركز الرقة للأعمال ,قرب مصرف الإمارات الإسلامي ,187103 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142384840",
        "email": "legalco@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_5",
      "legal_consultancy_individual_6"
    ],
    "slug": "muna-almulla-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_482",
    "name": "MUNA ALSABBAGH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/01/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_482",
        "address": "Muna Ahmed Abdul-aziz Al-Sabbagh ,الطابق الخامس ,الزمردة ,مختبر دبي المركزي ,115578 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142283414",
        "email": "info@alwifaqlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_138",
      "legal_consultancy_individual_139",
      "legal_consultancy_individual_889"
    ],
    "slug": "muna-alsabbagh-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_483",
    "name": "MUNA ALSHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/01/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_483",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143553023",
        "email": "info@munaalshamsi30.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1073",
      "advocacy_individual_1074",
      "legal_consultancy_individual_210"
    ],
    "slug": "muna-alshamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_484",
    "name": "MUSAAB ALI AL NAQBI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_484",
        "address": "13 ,Le Solarium Tower ,Arabian Gate ,185430 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145805135 / 971558703836",
        "email": "info@alnaqbilaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_511",
      "advocacy_individual_512",
      "advocacy_individual_1085",
      "advocacy_individual_1086",
      "advocacy_individual_1378",
      "legal_consultancy_individual_1258"
    ],
    "slug": "musaab-ali-al-naqbi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_485",
    "name": "MUSALLAM ALMAHHRAMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/08/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_485",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144560410 / 971551096724",
        "email": "info1@a-lawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1087",
      "advocacy_individual_1088",
      "legal_consultancy_individual_896",
      "legal_consultancy_individual_897"
    ],
    "slug": "musallam-almahhrami-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_97",
    "name": "Mandviwalla & Zafar Limited Liability Partnership",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "10/12/2006",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_97",
        "address": "AG House- Building Num 581 ,Al Muteena, Dubai ,11169 ,",
        "emirate": "Dubai",
        "phone": "97143257977 / 971507086100",
        "email": "sheeza@mandviwallaandzafar.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mandviwalla-zafar-limited-liability-partnership"
  },
  {
    "id": "legal_consultancy_firms_98",
    "name": "Manuel Calzada Legal Consultancy FZ LLC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/09/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_98",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971543665504",
        "email": "MC@ManuelCalzadaLegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "manuel-calzada-legal-consultancy-fz-llc"
  },
  {
    "id": "legal_consultancy_firms_99",
    "name": "Maples & Calder (Dubai) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/05/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_99",
        "address": "Level 14 ,Burj Daman ,Four Seasons Hotel ,119980 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143604070 / 971502450485",
        "email": "Philip.ireland@maples.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "maples-calder-dubai-llp"
  },
  {
    "id": "legal_consultancy_firms_101",
    "name": "Mayer Brown LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "18/04/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_101",
        "address": "Index Tower ,DIFC ,507115 ,",
        "emirate": "Dubai",
        "phone": "97143757160 / 971523490280",
        "email": "tthraya@mayerbrown.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mayer-brown-llp"
  },
  {
    "id": "legal_consultancy_firms_103",
    "name": "Meysan Lawyers and Legal Consultants WLL",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/06/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_103",
        "address": "",
        "emirate": "Dubai",
        "phone": "97100000000 / 971529999965",
        "email": "beljeaan@meysan.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_572",
      "legal_consultancy_individual_573",
      "legal_consultancy_individual_2986"
    ],
    "slug": "meysan-lawyers-and-legal-consultants-wll"
  },
  {
    "id": "legal_consultancy_firms_104",
    "name": "Mohammad Alsaboosi Legal Advice",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/06/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_104",
        "address": "BIN DASMAL BUILDING ,Al Goze ,00000 ,",
        "emirate": "Dubai",
        "phone": "/ 971557959999",
        "email": "mahmmadalsaboosi@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2037",
      "legal_consultancy_individual_2038"
    ],
    "slug": "mohammad-alsaboosi-legal-advice"
  },
  {
    "id": "legal_consultancy_firms_105",
    "name": "Mohammed Raei Alboom Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "28/02/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_105",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971555527527",
        "email": "m.raialboomadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "mohammed-raei-alboom-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_107",
    "name": "Morgan, Lewis & Bockius LLP (dubai Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 26,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/07/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_107",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143121800 / 971566017967",
        "email": "alishia.sullivan@morganlewis.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_273",
      "legal_consultancy_individual_274",
      "legal_consultancy_individual_275",
      "legal_consultancy_individual_276",
      "legal_consultancy_individual_338",
      "legal_consultancy_individual_339",
      "legal_consultancy_individual_402",
      "legal_consultancy_individual_403",
      "legal_consultancy_individual_426",
      "legal_consultancy_individual_427",
      "legal_consultancy_individual_992",
      "legal_consultancy_individual_993",
      "legal_consultancy_individual_1403",
      "legal_consultancy_individual_1404",
      "legal_consultancy_individual_1570",
      "legal_consultancy_individual_1571",
      "legal_consultancy_individual_2532",
      "legal_consultancy_individual_2749",
      "legal_consultancy_individual_2750",
      "legal_consultancy_individual_2751",
      "legal_consultancy_individual_2897",
      "legal_consultancy_individual_2898",
      "legal_consultancy_individual_3114",
      "legal_consultancy_individual_3115",
      "legal_consultancy_individual_3173",
      "legal_consultancy_individual_3174"
    ],
    "slug": "morgan-lewis-bockius-llp-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_108",
    "name": "Motei & Associates L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/08/2002",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_108",
        "address": "Unit 801, 8th Floor ,Damac Executive Heights ,Time Oak Hotel ,112888 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144355959 / 971551049797",
        "email": "a.motei@motei.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2547"
    ],
    "slug": "motei-associates-llc"
  },
  {
    "id": "advocacy_firms_486",
    "name": "NADIA ABDOLRAZAGH ADVOCACY & LEGAL CONSULTATIONS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/12/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_486",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142999934",
        "email": "info@nadiaadvocacy.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1093",
      "advocacy_individual_1094"
    ],
    "slug": "nadia-abdolrazagh-advocacy-legal-consultations"
  },
  {
    "id": "advocacy_firms_487",
    "name": "NADIA ALYOUSUF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/12/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_487",
        "address": "FIRST ,KIA FLAG SHIP ,KIA CAR SHOWROOM ,2031 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143444210 / 971505522350",
        "email": "official@nylegalfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "nadia-alyousuf-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_488",
    "name": "NADIA MOHAMMED ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "06/03/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_488",
        "address": "first floor ,Al Ferdous 4 ,Park and Shop ,12018 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143930222 / 971505122999",
        "email": "info@amanidarwishlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1095",
      "advocacy_individual_1096",
      "legal_consultancy_individual_1104",
      "legal_consultancy_individual_3116",
      "legal_consultancy_individual_3117"
    ],
    "slug": "nadia-mohammed-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_489",
    "name": "NADYA AHMED HASAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "25/03/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_489",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143387678 / 971503938886",
        "email": "INFO@ADVOCATESDXB.AE",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "nadya-ahmed-hasan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_491",
    "name": "NASER ABDULLA ALMUHARRAMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/02/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_491",
        "address": "Naser almuharrami ,التاسع  ,SAMA TOWER ,مطعم تشيلو  ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144581795 / 971507388622",
        "email": "info@lawdxb.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1107",
      "advocacy_individual_1108",
      "legal_consultancy_individual_1265",
      "legal_consultancy_individual_1703"
    ],
    "slug": "naser-abdulla-almuharrami-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_492",
    "name": "NASSER AL JAROODI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/10/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_492",
        "address": "Nasser Yousuf Mohammed Aljaroodi ,الطابق الثاني - مكتب رقم 2015A ,مركز مزايا للتسوق  ,بالقرب من محطة مترو برج خليفة - دبي مول - مخرج رقم 2 ,5958 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143699915 / 971561339712",
        "email": "info@aljaroodiadv.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2074"
    ],
    "slug": "nasser-al-jaroodi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_493",
    "name": "NASSER AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 7,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "23/01/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_493",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142507778 / 971506421661",
        "email": "feedback@alshamsilawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_660",
      "advocacy_individual_661",
      "advocacy_individual_1109",
      "advocacy_individual_1110",
      "legal_consultancy_individual_314",
      "legal_consultancy_individual_315",
      "legal_consultancy_individual_1274"
    ],
    "slug": "nasser-al-shamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_494",
    "name": "NASSER ALAWAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/11/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_494",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143793798 / 971504407878",
        "email": "n.alawar@alawarlaw.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1119",
      "advocacy_individual_1120",
      "legal_consultancy_individual_2845",
      "legal_consultancy_individual_2846"
    ],
    "slug": "nasser-alawar-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_495",
    "name": "NASSER ALKHAMIS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_495",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145548499",
        "email": "legal@nyk.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_400",
      "advocacy_individual_1125",
      "advocacy_individual_1126"
    ],
    "slug": "nasser-alkhamis-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_496",
    "name": "NASSER MALALLA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 9,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "06/05/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_496",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148321212",
        "email": "nasser@nmlawyers.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_544",
      "legal_consultancy_individual_1142",
      "legal_consultancy_individual_1143",
      "legal_consultancy_individual_1939",
      "legal_consultancy_individual_1940",
      "legal_consultancy_individual_2123",
      "legal_consultancy_individual_2124",
      "legal_consultancy_individual_89",
      "legal_consultancy_individual_90"
    ],
    "slug": "nasser-malalla-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_498",
    "name": "NATIONAL GROUP ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_498",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143366173",
        "email": "info@uaenationalgroup.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "national-group-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_499",
    "name": "NAWAL AL MERBATI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/09/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_499",
        "address": "NAWAL AL MERBATI ,2, 208 ,RAK Bank Building ,RAK Bank ,99272 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142233775 / 971564454162",
        "email": "nawal.almurbati@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1129",
      "advocacy_individual_1130"
    ],
    "slug": "nawal-al-merbati-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_500",
    "name": "NAWAL ALHOSANI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/09/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_500",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145148832 / 971502061303",
        "email": "dxbcourts@nhadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "nawal-alhosani-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_502",
    "name": "NAWAL SALEM SAEED ADVOCATES &LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "27/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_502",
        "address": "Nawal Salem Saeed Salem ,508 ,S. I. T Tower ,SILICON OASIS ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145582139 / 971555425608",
        "email": "courts@nslawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_816",
      "legal_consultancy_individual_1712",
      "legal_consultancy_individual_2192",
      "legal_consultancy_individual_2193"
    ],
    "slug": "nawal-salem-saeed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_503",
    "name": "NISMA ALJANAHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/11/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_503",
        "address": "Majed Naim ,5 ,Aspect Tower ,Bay Avenue Mall ,554868 ,Dubai",
        "emirate": "Dubai",
        "phone": "97147701106 / 971557665402",
        "email": "communicate@janahilegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "nisma-aljanahi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_505",
    "name": "NOOF ALABDULLA ADVOCATES & LEGAL CONSULTANTS L.L.C",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_505",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143889955",
        "email": "m.alhanafi@nooflaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_331",
      "legal_consultancy_individual_862",
      "legal_consultancy_individual_1715"
    ],
    "slug": "noof-alabdulla-advocates-legal-consultants-llc"
  },
  {
    "id": "advocacy_firms_506",
    "name": "NOORA AHMAD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/12/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_506",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142222282",
        "email": "N.moosaa@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_340",
      "advocacy_individual_1136",
      "advocacy_individual_1137"
    ],
    "slug": "noora-ahmad-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_507",
    "name": "NOORHAN ABDULLATIF ALZAABI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "29/08/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_507",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148761744 / 971971487617",
        "email": "info@noorhanlawyer.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "noorhan-abdullatif-alzaabi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_509",
    "name": "NOURA ALAMIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "16/07/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_509",
        "address": "الطابق الثالث  ,SMJ1 ,مطعم حتوته مصرية  ,554531 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143443388 / 971524193537",
        "email": "info@nialawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "noura-alamiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_511",
    "name": "NOURA ALMAAZMI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "14/06/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_511",
        "address": "Noura Mohamed Abdelrahman Almaazmi ,17 ,The Oberoi Center ,Burlington Tower ,414224 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143215777",
        "email": "case@almaazmilawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "noura-almaazmi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_513",
    "name": "NUJOOD BIN HAIDER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "19/08/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_513",
        "address": "1 ,MOBH Building 2 ,GGICO Metro Station ,3555 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142821191 / 971552222519",
        "email": "nujoodlegal@mobhgroup.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "nujood-bin-haider-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_109",
    "name": "Najjar & Associates Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "31/08/2002",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_109",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143244662 / 971506518966",
        "email": "najarlaw@eim.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "najjar-associates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_111",
    "name": "Norton Rose Fulbright (Middle East) LLP Dubai Branch",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/09/2003",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_111",
        "address": "0 ,ICD Brookfield Place ,Za'abeel 2 ,103747 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "norton-rose-fulbright-middle-east-llp-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_112",
    "name": "Norton Rose Fullbright (Middle East) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 44,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "20/09/2003",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_112",
        "address": "ICD Brookfield Place ,Za'abeel 2 ,103747 ,",
        "emirate": "Dubai",
        "phone": "97143696300 / 971506008159",
        "email": "mohammed.paracha@nortonrosefulbright.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_104",
      "legal_consultancy_individual_105",
      "legal_consultancy_individual_106",
      "legal_consultancy_individual_291",
      "legal_consultancy_individual_613",
      "legal_consultancy_individual_710",
      "legal_consultancy_individual_711",
      "legal_consultancy_individual_1018",
      "legal_consultancy_individual_1120",
      "legal_consultancy_individual_1121",
      "legal_consultancy_individual_1132",
      "legal_consultancy_individual_1133",
      "legal_consultancy_individual_1202",
      "legal_consultancy_individual_1203",
      "legal_consultancy_individual_1315",
      "legal_consultancy_individual_1376",
      "legal_consultancy_individual_1393",
      "legal_consultancy_individual_1394",
      "legal_consultancy_individual_1426",
      "legal_consultancy_individual_1427",
      "legal_consultancy_individual_1476",
      "legal_consultancy_individual_1489",
      "legal_consultancy_individual_1700",
      "legal_consultancy_individual_1818",
      "legal_consultancy_individual_1819",
      "legal_consultancy_individual_2269",
      "legal_consultancy_individual_2336",
      "legal_consultancy_individual_2392",
      "legal_consultancy_individual_2443",
      "legal_consultancy_individual_2444",
      "legal_consultancy_individual_2568",
      "legal_consultancy_individual_2569",
      "legal_consultancy_individual_2806",
      "legal_consultancy_individual_2807",
      "legal_consultancy_individual_2821",
      "legal_consultancy_individual_2859",
      "legal_consultancy_individual_2860",
      "legal_consultancy_individual_2875",
      "legal_consultancy_individual_2876",
      "legal_consultancy_individual_2926",
      "legal_consultancy_individual_3168",
      "legal_consultancy_individual_3179",
      "legal_consultancy_individual_3180",
      "legal_consultancy_individual_3227"
    ],
    "slug": "norton-rose-fullbright-middle-east-llp"
  },
  {
    "id": "advocacy_firms_515",
    "name": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/03/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_515",
        "address": "OBAID AL SHAMSI ADVOCATES & LEGAL CONSULTANTS ,لا يوجد ,AL GARHOUD BUSINESS CENTER ,AL GARHOUD BUSINESS CENTER ,1903 ,Dubai",
        "emirate": "Dubai",
        "phone": "97129555545",
        "email": "info@oaslawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1159",
      "advocacy_individual_1187",
      "legal_consultancy_individual_385",
      "legal_consultancy_individual_523"
    ],
    "slug": "obaid-al-shamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_516",
    "name": "OBAID ALMAAZMI LAWYER AND LEGAL CONSULTANT",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/05/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_516",
        "address": "Obaid Ishaq Ismail Al-Maazmi ,الطابق 21 ,ذا اكستشينج تاور  ,فندق جي دبليو ماريوت ماركي ,238365 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143584737",
        "email": "obaidotp@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_491",
      "advocacy_individual_672",
      "advocacy_individual_673",
      "advocacy_individual_825",
      "advocacy_individual_826",
      "advocacy_individual_1477"
    ],
    "slug": "obaid-almaazmi-lawyer-and-legal-consultant"
  },
  {
    "id": "advocacy_firms_517",
    "name": "OBAID BINGADEEM AL SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "07/04/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_517",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142772442",
        "email": "info@obs-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "obaid-bingadeem-al-suwaidi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_518",
    "name": "OMAR KHALIFA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "11/01/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_518",
        "address": "901-902 ,برج السلام ,فندق جراند شيراتون ,2741291443 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145877794 / 971586606660",
        "email": "obh@obhlawyers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_353",
      "advocacy_individual_396",
      "advocacy_individual_892",
      "advocacy_individual_1174",
      "advocacy_individual_1175",
      "legal_consultancy_individual_2000",
      "legal_consultancy_individual_2355",
      "legal_consultancy_individual_2356"
    ],
    "slug": "omar-khalifa-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_519",
    "name": "OMAR RASHID AL GHAFRI LAWYER AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/01/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_519",
        "address": "",
        "emirate": "Dubai",
        "phone": "97165333314 / 971569381334",
        "email": "info@alghafri.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1178"
    ],
    "slug": "omar-rashid-al-ghafri-lawyer-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_520",
    "name": "OMAR SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_520",
        "address": "OMAR MOHAMMED SHARIF ,1 ,THE VILLGE ,JUMAIURAH MOUSQE ,341 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143336699 / 971508899153",
        "email": "oslawyer007@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "omar-sharif-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_521",
    "name": "OMRAN ALRAWI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "16/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_521",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142327722",
        "email": "adv.alrawi@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "omran-alrawi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_523",
    "name": "OSAMA ALSALMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "18/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_523",
        "address": "Osama Alsalmi ,5 ,Makateb building  ,Tasheel ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148187210",
        "email": "info@alsalmilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "osama-alsalmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_525",
    "name": "OUTSIDE DUBAI FIRM",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_525",
        "address": "",
        "emirate": "Dubai",
        "phone": "",
        "email": "",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "outside-dubai-firm"
  },
  {
    "id": "legal_consultancy_firms_113",
    "name": "Obeid Law Firm & Partners-Dubai Branch",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "17/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_113",
        "address": "",
        "emirate": "Dubai",
        "phone": "97140000000 / 971564600544",
        "email": "nayla@obeidpartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_3213",
      "legal_consultancy_individual_3214",
      "legal_consultancy_individual_3215",
      "legal_consultancy_individual_3221",
      "legal_consultancy_individual_3222"
    ],
    "slug": "obeid-law-firm-partners-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_114",
    "name": "Ogier (DIFC) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 5,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/08/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_114",
        "address": "Unit No. S1003, Level 10 ,Emirates Financial Towers ,Dubai International Financial Centre ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144501900 / 971566072398",
        "email": "david.welford@ogier.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_792",
      "legal_consultancy_individual_793",
      "legal_consultancy_individual_839",
      "legal_consultancy_individual_3049",
      "legal_consultancy_individual_3050"
    ],
    "slug": "ogier-difc-llp"
  },
  {
    "id": "advocacy_firms_535",
    "name": "PRESTIGE ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "08/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_535",
        "address": "Dr. Ali Ismail Aljarman ,Roof Floor - Offices R03 & R04 ,MSM 1 Building ,Al Saffa First ,62639 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144393733",
        "email": "info@prestigeadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "prestige-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_115",
    "name": "Pinsent Masons  LLP (DWTCA Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2008",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_115",
        "address": "THE OFFICES 1 ,DWTC ,115580 ,",
        "emirate": "Dubai",
        "phone": "97143739700 / 971501148248",
        "email": "nitesh.pradhan@pinsentmasons.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "pinsent-masons-llp-dwtca-branch"
  },
  {
    "id": "legal_consultancy_firms_116",
    "name": "Pinsent Masons LLP - Dubai Branch",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 17,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2008",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_116",
        "address": "- ,THE OFFICES 1 ,DWTC ,115580 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143739700 / 971562196031",
        "email": "catherine.workman@pinsentmasons.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_671",
      "legal_consultancy_individual_755",
      "legal_consultancy_individual_756",
      "legal_consultancy_individual_962",
      "legal_consultancy_individual_1090",
      "legal_consultancy_individual_1091",
      "legal_consultancy_individual_1368",
      "legal_consultancy_individual_1646",
      "legal_consultancy_individual_1647",
      "legal_consultancy_individual_1656",
      "legal_consultancy_individual_1764",
      "legal_consultancy_individual_1844",
      "legal_consultancy_individual_1845",
      "legal_consultancy_individual_1984",
      "legal_consultancy_individual_1985",
      "legal_consultancy_individual_2049",
      "legal_consultancy_individual_2730"
    ],
    "slug": "pinsent-masons-llp-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_117",
    "name": "Pro LCF1 (DESC)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "29/09/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_117",
        "address": "",
        "emirate": "Dubai",
        "phone": "97140000000 / 971508360023",
        "email": "annadurai@legal.dubai.gov.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "pro-lcf1-desc"
  },
  {
    "id": "advocacy_firms_537",
    "name": "QUMASHA ALI MOHAMMAD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/10/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_537",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145650550",
        "email": "uae.courts@qamadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_546",
      "advocacy_individual_1190",
      "legal_consultancy_individual_128",
      "legal_consultancy_individual_129"
    ],
    "slug": "qumasha-ali-mohammad-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_119",
    "name": "Quinn Emanuel Urquhart & Sullivan UK LLP- Dubai Branch",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "12/03/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_119",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971507758307",
        "email": "joannestrain@quinnemanuel.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "quinn-emanuel-urquhart-sullivan-uk-llp-dubai-branch"
  },
  {
    "id": "advocacy_firms_538",
    "name": "RAJA AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/09/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_538",
        "address": "Mezzanine - Office M19 ,Business Avenue ,Makani No: 3248594620 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142855669 / 971554722231",
        "email": "lawyerrajaa2002@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1195",
      "advocacy_individual_1196"
    ],
    "slug": "raja-al-saleh-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_539",
    "name": "RASHED ABDULLA ALHEFEITI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "20/10/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_539",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145686887 / 971566651137",
        "email": "info@case-laws.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rashed-abdulla-alhefeiti-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_541",
    "name": "RASHED AL SHEHHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/04/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_541",
        "address": "السادس - مكتب 604 ,الوصل بيزنس سنتر - مبنى رقم R549 ,بنك مصر ,2079 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143961112",
        "email": "reception@rslawfirm.org",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1208",
      "advocacy_individual_1209"
    ],
    "slug": "rashed-al-shehhi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_542",
    "name": "RASHED Al SUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "17/09/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_542",
        "address": "Rashed Abdulrahman Mohammed abdullah Alsuwaidi ,الطابق الخامس 504 ,كورت تاور  ,الخليج التجاري ,35836 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145723403 / 971557679696",
        "email": "info@ralsuwaidi.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rashed-al-suwaidi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_544",
    "name": "RASHED LOOTAH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "23/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_544",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142713893",
        "email": "info@rashedlootah.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rashed-lootah-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_546",
    "name": "RASHID ABBAS ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "02/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_546",
        "address": "Office No. 802 ,Al Ghanim Building 3 ,Makani No: 3092994922 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97140000000 / 971501031116",
        "email": "rashidabbasadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rashid-abbas-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_548",
    "name": "RASHID AL KAITOOB ADVOCATES & LEGAL COSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/10/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_548",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143595552",
        "email": "rashid.alkaitoob@rk-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rashid-al-kaitoob-advocates-legal-cosultants"
  },
  {
    "id": "advocacy_firms_549",
    "name": "RASHID DEEMAS ALSUWAIDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "18/11/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_549",
        "address": "Office No. 908 ,Owned by ACICO Gulf Real Estate Building ,Makani No: 3250094543 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143377688 / 971502883999",
        "email": "info@rds-law.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_821",
      "advocacy_individual_822",
      "advocacy_individual_1212",
      "advocacy_individual_1213"
    ],
    "slug": "rashid-deemas-alsuwaidi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_550",
    "name": "RASHID KHALIL OBAID ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "07/06/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_550",
        "address": "Office No. 201 ,FRONDS BUILDING ,Makani No: 3273193073 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000",
        "email": "ro.legalconsultation@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rashid-khalil-obaid-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_552",
    "name": "RAYA AL AMERI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "12/11/2019",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_552",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145786050 / 971509711102",
        "email": "info@emirates.law",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "raya-al-ameri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_554",
    "name": "REEM SALEH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "16/09/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_554",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142949937",
        "email": "info@rslawyers.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "reem-saleh-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_121",
    "name": "RIAA Barker Gillette (Middle East) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "23/07/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_121",
        "address": "Level 07, Gate Village Building 10 ,Dubai International Financial Centre ,507014 ,",
        "emirate": "Dubai",
        "phone": "97144019410 / 971504557972",
        "email": "hasan.rizvi@riaabg.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "riaa-barker-gillette-middle-east-llp"
  },
  {
    "id": "advocacy_firms_556",
    "name": "RUDHA ALATTAR ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "18/05/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_556",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142776979",
        "email": "info@raadvocates.co",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rudha-alattar-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_123",
    "name": "Roedl & Partner (Dubai Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/06/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_123",
        "address": "Boulevard Plaza Tower 2 ,Burj Khalifa ,23297 ,",
        "emirate": "Dubai",
        "phone": "97142950020 / 971526443550",
        "email": "nicola.lohrey@roedl.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_368"
    ],
    "slug": "roedl-partner-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_124",
    "name": "Rouse & Co International Limited (Dubai Branch)",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 6,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/03/2002",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_124",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143098000 / 971552210883",
        "email": "belturk@rouse.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1367",
      "legal_consultancy_individual_1564",
      "legal_consultancy_individual_1565",
      "legal_consultancy_individual_2173",
      "legal_consultancy_individual_2174",
      "legal_consultancy_individual_2752"
    ],
    "slug": "rouse-co-international-limited-dubai-branch"
  },
  {
    "id": "legal_consultancy_firms_125",
    "name": "Rycx Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "17/12/1997",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_125",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143467303 / 971506565383",
        "email": "rycx@rycx-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "rycx-legal-consultants"
  },
  {
    "id": "advocacy_firms_558",
    "name": "SAAD AL HAMMADI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 8,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/11/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_558",
        "address": "SAAD AL HAMMADI ,مدخل البرج ,ويست بيري ,برج خليفه ,41747 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142405222",
        "email": "info@saadpartners.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1234",
      "advocacy_individual_1235",
      "legal_consultancy_individual_1266",
      "legal_consultancy_individual_2019",
      "legal_consultancy_individual_2847",
      "legal_consultancy_individual_2848",
      "legal_consultancy_individual_3128",
      "legal_consultancy_individual_3129"
    ],
    "slug": "saad-al-hammadi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_559",
    "name": "SABEEL SALEM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/03/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_559",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142369992",
        "email": "info@sabeeladvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "sabeel-salem-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_560",
    "name": "SAEED AL DAHMANI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "03/10/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_560",
        "address": "Office No. 216 ,Al Wasl Building ,Opposite Dubai Mall Metro Station; Makani No: 8853725508 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145708388",
        "email": "sa.legaladvo@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1250",
      "legal_consultancy_individual_1968"
    ],
    "slug": "saeed-al-dahmani-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_561",
    "name": "SAEED AL GHAILANI ADVOCATE & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/06/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_561",
        "address": "- ,- ,- ,00 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142502203",
        "email": "saed_ghailani@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saeed-al-ghailani-advocate-legal-consultancy"
  },
  {
    "id": "advocacy_firms_562",
    "name": "SAEED AL MHEIRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 1,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "16/10/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_562",
        "address": "Saeed almheiri  ,1907 ,Churchill tower 1 ,Bur Khalifa  ,37979 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143944183 / 971504544002",
        "email": "advocates@saeed-almheiri.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1244"
    ],
    "slug": "saeed-al-mheiri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_563",
    "name": "SAEED ALAWADHI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "24/05/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_563",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143430934",
        "email": "salegal.ae@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saeed-alawadhi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_565",
    "name": "SAEED ALGHAFRI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "03/10/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_565",
        "address": "saeed ,310 & 311 ,business avenue ,منطقه بور سعيد التجاريه ,19410 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148868812",
        "email": "info@saeedalghafri.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saeed-alghafri-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_567",
    "name": "SAEED ALI TAHER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "05/01/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_567",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145686887 / 971000000000",
        "email": "info@satlawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saeed-ali-taher-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_569",
    "name": "SAEED ALSHARMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "27/02/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_569",
        "address": "الطابق الرابع 415 ,بزنس افنيو 515 ,ستي سنتر ديرة ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148345000 / 971506996499",
        "email": "INFO@ALSHARMILAW.COM",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saeed-alsharmi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_571",
    "name": "SAEED BIN GHULAITA ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "27/08/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_571",
        "address": "saeed thani ben ghulaita ,الطابق الاول علوي رقم المكتب 109  ,التجاري ام الشيف  ,مطعم سلطان سراي ,398 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143333309 / 971502660044",
        "email": "saeedalmuhairi@yahoo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saeed-bin-ghulaita-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_573",
    "name": "SAHAR ADNAN ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "12/04/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_573",
        "address": "الدور 19 ,كونراد هوتيل ,كونراد هوتيل ,29799 ,Dubai",
        "emirate": "Dubai",
        "phone": "",
        "email": "info.saharadvocates@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "sahar-adnan-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_575",
    "name": "SAIF SULTAN ALMEHRZI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/02/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_575",
        "address": "Office No. 211 ,Al Wasl Building ,Makani No: 2479487549 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142733476 / 97142733476",
        "email": "abo_sultan_s@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saif-sultan-almehrzi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_577",
    "name": "SALEH AL SALEH ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/09/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_577",
        "address": "",
        "emirate": "Dubai",
        "phone": "97140000000 / 971504554699",
        "email": "salehalsalehadvo@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saleh-al-saleh-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_579",
    "name": "SALEM ALHARTHI ADVOCATES AND & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "02/06/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_579",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143699967",
        "email": "advo@dsh-legal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_762",
      "advocacy_individual_763"
    ],
    "slug": "salem-alharthi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_580",
    "name": "SALEM ALKUBAISI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "11/01/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_580",
        "address": "1-114 ,سيتى باى للاعمال ,مقابل المستشفى الكندى ,93075 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143853266 / 971506131373",
        "email": "salemalkubaisidubai@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "salem-alkubaisi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_582",
    "name": "SALHA ALBASTI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "14/12/2014",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_582",
        "address": "5 ,tasheel bldg ,nasr club ,116749 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143970701",
        "email": "salha@albastiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1262",
      "advocacy_individual_1263",
      "advocacy_individual_1307",
      "legal_consultancy_individual_1524"
    ],
    "slug": "salha-albasti-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_583",
    "name": "SALHA ALKHALLAFI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "16/12/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_583",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971505588450",
        "email": "salha.kk@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "salha-alkhallafi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_585",
    "name": "SALWA OMAR ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_585",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148769883 / 971048769883",
        "email": "info@salwaadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1323",
      "advocacy_individual_1324"
    ],
    "slug": "salwa-omar-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_586",
    "name": "SAMI ALSAWALHI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/04/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_586",
        "address": "",
        "emirate": "Dubai",
        "phone": "97148818001",
        "email": "info@sqadvo.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1327",
      "advocacy_individual_1328"
    ],
    "slug": "sami-alsawalhi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_587",
    "name": "SAMIRA ABDULLA ALI GARGASH ADVOCATE AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "18/10/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_587",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144504430 / 97144504430",
        "email": "samira@samiragargash.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "samira-abdulla-ali-gargash-advocate-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_589",
    "name": "SAMIRA ALZAROONI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_589",
        "address": "samira ismail  ,الطابق التاسع - مكتب 902 ,برج سعيد 2 ,بنفس المبنى كنتاكي ,22223 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148873880 / 971585323296",
        "email": "info.zaroonilawyers@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "samira-alzarooni-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_590",
    "name": "SAOUD MOHAMAD ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/11/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_590",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144356173 / 971509444622",
        "email": "saoud.m222@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saoud-mohamad-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_591",
    "name": "SARA ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "08/05/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_591",
        "address": "Sara Shah Baik Elbloshi ,الطابق 13 - مكتب 1306 ,CLOVER BAY ,بجوار SONDER HOTEL ,112773 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143514666",
        "email": "admin@saraadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_2116",
      "legal_consultancy_individual_2448"
    ],
    "slug": "sara-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_592",
    "name": "SARA ALBAQISHI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "30/03/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_592",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143468388",
        "email": "albaqishilaw@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "sara-albaqishi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_594",
    "name": "SARA IBRAHIM ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "28/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_594",
        "address": "sara ibrahim  ,m1 ,ملك محمد عتيق احمد المري ,شارع المركاض ,14049 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142545233 / 971554080104",
        "email": "info@thecounsels.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "sara-ibrahim-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_596",
    "name": "SAT & CO ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "16/11/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_596",
        "address": "الجناح الشمالي الطابق التاسع الوحدة 902 ,بنك المشرق جلوبال اتش كيه  ,برج خليفة  ,41422 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145514441",
        "email": "info@sat-law.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "sat-co-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_598",
    "name": "SAUD ALZAROONI  ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/11/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_598",
        "address": "SAUD AHMED ,الاول  مكتب 115 ,مكاتب عود ميثاء ,مقابل فندق رافلز  وخلف بناية ستي بنك  ,47700 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145476944 / 97142350070",
        "email": "info@salzarooni.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "saud-alzarooni-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_599",
    "name": "SENDEYYAH ALHANTOOBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "13/02/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_599",
        "address": "Second Floor - Office No. 202 ,Union Building ,Makani No: 3234793883 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97140000000 / 971569848432",
        "email": "info@advsendeyyah.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "sendeyyah-alhantoobi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_601",
    "name": "SHAIKH RASHID BIN NASSER AL NUAIMI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/07/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_601",
        "address": "مكتب رقم 303 ,NAEMA ALI BUAMIM رقم مكاني 2937992197 ,المركز التجاري الماليزي ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144475234 / 971547447744",
        "email": "RASHIDALNUIMIEST@GMAIL.COM",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1360",
      "advocacy_individual_1361",
      "legal_consultancy_individual_147"
    ],
    "slug": "shaikh-rashid-bin-nasser-al-nuaimi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_602",
    "name": "SHAIKHA AHMAD ADVOCATES&LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "25/07/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_602",
        "address": "مكتب رقم 403 – 504 - 102 ,القرن الواحد وعشرون ,مركز القبائل للتخفيضات ,68441 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142388763",
        "email": "shaikha.advo@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_652",
      "advocacy_individual_653",
      "advocacy_individual_1394"
    ],
    "slug": "shaikha-ahmad-advocateslegal-consultants"
  },
  {
    "id": "advocacy_firms_604",
    "name": "SHAMSA ALBEDWAWI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "09/03/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_604",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145872888 / 971556022223",
        "email": "Shamsa@shadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "shamsa-albedwawi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_606",
    "name": "SUAD MOHAMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "13/06/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_606",
        "address": "SUAD MOHAMMED ,Mezzanine102-08 ,ملك الشيخة مهره احمد الغرير ,Al Tawar Center ,446009 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145477711 / 971558800890",
        "email": "suad.lawyer@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1403",
      "advocacy_individual_1404"
    ],
    "slug": "suad-mohamed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_608",
    "name": "SUHAD ALJUBOORI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "06/05/2018",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_608",
        "address": "SUHAD FADHIL JABBAR MAHADI ALJUBOORI  ,1602 ,ذا اتش ,المركز التجارى الاول  ,99827 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142711100 / 971508661717",
        "email": "sj@suhadaljuboorilawfirm.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "suhad-aljuboori-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_610",
    "name": "SULAIMAN AL NAQBI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/04/2017",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_610",
        "address": "SULAIMAN ALNAQBI ,5 ,Emaar Business Park 1 ,Emaar Business Park 1 ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "",
        "email": "hsrgro@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1413",
      "legal_consultancy_individual_1223"
    ],
    "slug": "sulaiman-al-naqbi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_612",
    "name": "SULAIMAN SALEM ALKARBI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/09/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_612",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145686887 / 971566665693",
        "email": "info@alkirbilaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1414",
      "legal_consultancy_individual_216"
    ],
    "slug": "sulaiman-salem-alkarbi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_593",
    "name": "Sara Alsaedi Advocates and Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 4,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "04/02/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_593",
        "address": "",
        "emirate": "Dubai",
        "phone": "97150399980 / 971501547188",
        "email": "advocatesaraalsaedi@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1345",
      "advocacy_individual_1346",
      "legal_consultancy_individual_1897",
      "legal_consultancy_individual_2328"
    ],
    "slug": "sara-alsaedi-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_603",
    "name": "Shaikha Saqer Almansoori Advocates & Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "12/10/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_603",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143333040 / 971000000000",
        "email": "info@ssm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_808",
      "advocacy_individual_809"
    ],
    "slug": "shaikha-saqer-almansoori-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_127",
    "name": "Shurooq Zainal Legal Consultants LLC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "21/05/2025",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_127",
        "address": "Office No.08-150 ,Dubai World Trade Centre ,Dubai World Trade Centre ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971504598323",
        "email": "Shurooq.f.zainal@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "shurooq-zainal-legal-consultants-llc"
  },
  {
    "id": "legal_consultancy_firms_128",
    "name": "Sidley Austin LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/09/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_128",
        "address": "",
        "emirate": "Dubai",
        "phone": "/ 971000000000",
        "email": "tthesing@sidley.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_330",
      "legal_consultancy_individual_1248"
    ],
    "slug": "sidley-austin-llp"
  },
  {
    "id": "legal_consultancy_firms_129",
    "name": "Silk Legal Company Limited",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "28/09/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_129",
        "address": "Unit 03-OF-02-03-OF-09, Level 03 ,Gate Village Building 08 ,Dubai International Financial Centre ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97100000000 / 971501051651",
        "email": "gabriel@uae.silklegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "silk-legal-company-limited"
  },
  {
    "id": "legal_consultancy_firms_131",
    "name": "Simmons & Simmons (Middle East) LLP-DIFC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 35,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "13/09/2004",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_131",
        "address": "1 ,ICD Brookfield Place ,DIFC ,506688 ,Dubai",
        "emirate": "Dubai",
        "phone": "97147096600 / 971503556811",
        "email": "muneer.khan@simmons-simmons.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_87",
      "legal_consultancy_individual_88",
      "legal_consultancy_individual_230",
      "legal_consultancy_individual_231",
      "legal_consultancy_individual_301",
      "legal_consultancy_individual_302",
      "legal_consultancy_individual_337",
      "legal_consultancy_individual_452",
      "legal_consultancy_individual_453",
      "legal_consultancy_individual_800",
      "legal_consultancy_individual_826",
      "legal_consultancy_individual_827",
      "legal_consultancy_individual_1006",
      "legal_consultancy_individual_1045",
      "legal_consultancy_individual_1046",
      "legal_consultancy_individual_1285",
      "legal_consultancy_individual_1290",
      "legal_consultancy_individual_1333",
      "legal_consultancy_individual_1334",
      "legal_consultancy_individual_1351",
      "legal_consultancy_individual_1352",
      "legal_consultancy_individual_1599",
      "legal_consultancy_individual_1600",
      "legal_consultancy_individual_1765",
      "legal_consultancy_individual_1766",
      "legal_consultancy_individual_2244",
      "legal_consultancy_individual_2407",
      "legal_consultancy_individual_2408",
      "legal_consultancy_individual_2628",
      "legal_consultancy_individual_2716",
      "legal_consultancy_individual_2717",
      "legal_consultancy_individual_2774",
      "legal_consultancy_individual_2775",
      "legal_consultancy_individual_2857",
      "legal_consultancy_individual_2858"
    ],
    "slug": "simmons-simmons-middle-east-llp-difc"
  },
  {
    "id": "legal_consultancy_firms_132",
    "name": "Squire Patton Boggs (MEA) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "15/03/2007",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_132",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144478700 / 971528553200",
        "email": "Thomas.Wilson@squirepb.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "squire-patton-boggs-mea-llp"
  },
  {
    "id": "advocacy_firms_611",
    "name": "Sulaiman Alshebli Advocates and Legal Consultants",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 3,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "24/05/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_611",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142693680",
        "email": "info@sas-advocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_1415",
      "advocacy_individual_1416",
      "legal_consultancy_individual_971"
    ],
    "slug": "sulaiman-alshebli-advocates-and-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_134",
    "name": "Support Legal ( DIFC) Limited",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "18/05/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_134",
        "address": "IH-00-01-CP-05 ,DIFC ,506832 ,",
        "emirate": "Dubai",
        "phone": "/ 971506957753",
        "email": "admin@supportlegal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "support-legal-difc-limited"
  },
  {
    "id": "advocacy_firms_613",
    "name": "TAREQ THABIT ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "05/09/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_613",
        "address": "الثالث ,بناية الجوهرة  ,مركز برجمان ,635 ,Dubai",
        "emirate": "Dubai",
        "phone": "/ 971505777314",
        "email": "tariqthabit1975@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "tareq-thabit-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_614",
    "name": "TARISH ALMANSOORI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 12,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "31/10/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_614",
        "address": "14th Floor, No.2 ,Al Burj Al Salam ,Makani No: 27412 91443 ,000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97148823210 / 971565301153",
        "email": "info@tarishlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "advocacy_individual_575",
      "advocacy_individual_576",
      "advocacy_individual_577",
      "advocacy_individual_578",
      "advocacy_individual_579",
      "advocacy_individual_580",
      "advocacy_individual_581",
      "advocacy_individual_582",
      "advocacy_individual_583",
      "legal_consultancy_individual_1001",
      "legal_consultancy_individual_1546",
      "legal_consultancy_individual_1547"
    ],
    "slug": "tarish-almansoori-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_617",
    "name": "THE ADVOCATES",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "05/10/2022",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_617",
        "address": "KHALED AHMED ABDULLA AHMED ,24 ,Clover Bay ,SAAS Tower  ,288 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143453233",
        "email": "info@theadvocates.io",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "the-advocates"
  },
  {
    "id": "advocacy_firms_619",
    "name": "THE FUTURE ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "13/03/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_619",
        "address": "Salah Abdelkarim Abdellah Alhamadani ,1st Floor, Office F46 ,Warba Centre ,Al Muraqqabat Police Station ,12898 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142963333",
        "email": "salah653@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "the-future-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_141",
    "name": "TWS Legal Consultants DMCC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 20,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2010",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_141",
        "address": "",
        "emirate": "Dubai",
        "phone": "97144484284 / 971559776272",
        "email": "nita@willsuae.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_626",
      "legal_consultancy_individual_627",
      "legal_consultancy_individual_634",
      "legal_consultancy_individual_635",
      "legal_consultancy_individual_704",
      "legal_consultancy_individual_765",
      "legal_consultancy_individual_863",
      "legal_consultancy_individual_864",
      "legal_consultancy_individual_879",
      "legal_consultancy_individual_880",
      "legal_consultancy_individual_1479",
      "legal_consultancy_individual_1620",
      "legal_consultancy_individual_1794",
      "legal_consultancy_individual_2216",
      "legal_consultancy_individual_2217",
      "legal_consultancy_individual_2245",
      "legal_consultancy_individual_2246",
      "legal_consultancy_individual_2508",
      "legal_consultancy_individual_2747",
      "legal_consultancy_individual_2748"
    ],
    "slug": "tws-legal-consultants-dmcc"
  },
  {
    "id": "legal_consultancy_firms_136",
    "name": "The International Law Firm",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "24/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_136",
        "address": "Sapphire Tower ,Port Saeed ,28411 ,",
        "emirate": "Dubai",
        "phone": "97142287730 / 971506284004",
        "email": "lawfirm@ilf.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "the-international-law-firm"
  },
  {
    "id": "legal_consultancy_firms_138",
    "name": "Trench & Associates DMCC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/02/1996",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_138",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143553146 / 971506240472",
        "email": "ct@trenchlaw.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "trench-associates-dmcc"
  },
  {
    "id": "legal_consultancy_firms_140",
    "name": "Trowers & Hamlins LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "26/06/1991",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_140",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143025100 / 971501501837",
        "email": "ccairns@trowers.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_1128",
      "legal_consultancy_individual_1129"
    ],
    "slug": "trowers-hamlins-llp"
  },
  {
    "id": "advocacy_firms_621",
    "name": "UNION ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "08/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_621",
        "address": "first/105 ,Al Shafar Investment ,noor bank metro station ,34655 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143386111",
        "email": "unionadvocates1@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "union-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_623",
    "name": "WAFA ALI ALHOSANYI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "04/02/2021",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_623",
        "address": "WAFA_ALI_ALHOSANY ,الطابق الأول - مكتب 110 ,مجمع محكمة التمييز  ,محاكم دبي  ,0000 ,Dubai",
        "emirate": "Dubai",
        "phone": "97155828080 / 971507329805",
        "email": "777lawyer.wafa@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "wafa-ali-alhosanyi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_625",
    "name": "WALEED ALMARZOOQI AND KHALID MOHAMED ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "08/05/2016",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_625",
        "address": "الطابق 33/ الوحدة : 3304 ,مبني المنارة /   الطابق 33/ الوحدة : 3304 ,فندق جي دبليو ماركيز  ,24002 ,Dubai",
        "emirate": "Dubai",
        "phone": "97144254373",
        "email": "info@wkadvocates.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "waleed-almarzooqi-and-khalid-mohamed-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_627",
    "name": "WORLD CENTER ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "21/02/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_627",
        "address": "",
        "emirate": "Dubai",
        "phone": "97145539555",
        "email": "world-center@hotmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "world-center-advocates-legal-consultants"
  },
  {
    "id": "legal_consultancy_firms_142",
    "name": "Walkers (Middle East) LLP",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "28/11/2005",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_142",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143637999 / 971506525633",
        "email": "daniel.wood@walkersglobal.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "walkers-middle-east-llp"
  },
  {
    "id": "legal_consultancy_firms_144",
    "name": "White & Case LLP-DIFC",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 74,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "22/04/2013",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_legal_consultancy_firms_144",
        "address": "ICD Brookfield Place  ,Zabeel ,9705 ,",
        "emirate": "Dubai",
        "phone": "97143816200 / 971563715991",
        "email": "jan.jensen@whitecase.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_0",
      "legal_consultancy_individual_63",
      "legal_consultancy_individual_64",
      "legal_consultancy_individual_232",
      "legal_consultancy_individual_233",
      "legal_consultancy_individual_307",
      "legal_consultancy_individual_308",
      "legal_consultancy_individual_371",
      "legal_consultancy_individual_372",
      "legal_consultancy_individual_437",
      "legal_consultancy_individual_498",
      "legal_consultancy_individual_669",
      "legal_consultancy_individual_742",
      "legal_consultancy_individual_743",
      "legal_consultancy_individual_759",
      "legal_consultancy_individual_760",
      "legal_consultancy_individual_776",
      "legal_consultancy_individual_777",
      "legal_consultancy_individual_849",
      "legal_consultancy_individual_850",
      "legal_consultancy_individual_998",
      "legal_consultancy_individual_1027",
      "legal_consultancy_individual_1035",
      "legal_consultancy_individual_1036",
      "legal_consultancy_individual_1291",
      "legal_consultancy_individual_1292",
      "legal_consultancy_individual_1307",
      "legal_consultancy_individual_1308",
      "legal_consultancy_individual_1316",
      "legal_consultancy_individual_1317",
      "legal_consultancy_individual_1347",
      "legal_consultancy_individual_1348",
      "legal_consultancy_individual_1442",
      "legal_consultancy_individual_1512",
      "legal_consultancy_individual_1513",
      "legal_consultancy_individual_1516",
      "legal_consultancy_individual_1517",
      "legal_consultancy_individual_1615",
      "legal_consultancy_individual_1616",
      "legal_consultancy_individual_1714",
      "legal_consultancy_individual_1745",
      "legal_consultancy_individual_1746",
      "legal_consultancy_individual_1763",
      "legal_consultancy_individual_1793",
      "legal_consultancy_individual_1864",
      "legal_consultancy_individual_1865",
      "legal_consultancy_individual_2181",
      "legal_consultancy_individual_2353",
      "legal_consultancy_individual_2354",
      "legal_consultancy_individual_2376",
      "legal_consultancy_individual_2377",
      "legal_consultancy_individual_2435",
      "legal_consultancy_individual_2436",
      "legal_consultancy_individual_2445",
      "legal_consultancy_individual_2496",
      "legal_consultancy_individual_2497",
      "legal_consultancy_individual_2574",
      "legal_consultancy_individual_2575",
      "legal_consultancy_individual_2600",
      "legal_consultancy_individual_2601",
      "legal_consultancy_individual_2661",
      "legal_consultancy_individual_2662",
      "legal_consultancy_individual_2693",
      "legal_consultancy_individual_2694",
      "legal_consultancy_individual_2790",
      "legal_consultancy_individual_2791",
      "legal_consultancy_individual_2792",
      "legal_consultancy_individual_2793",
      "legal_consultancy_individual_2838",
      "legal_consultancy_individual_3034",
      "legal_consultancy_individual_3035",
      "legal_consultancy_individual_3079",
      "legal_consultancy_individual_3134",
      "legal_consultancy_individual_3135"
    ],
    "slug": "white-case-llp-difc"
  },
  {
    "id": "advocacy_firms_629",
    "name": "YASIN ALHAMED ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "10/03/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_629",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142955575",
        "email": "info@yalhamed.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "yasin-alhamed-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_631",
    "name": "YOUNIS MOHAMMED AL BLOOSHI LAWYER & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "29/09/2020",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_631",
        "address": "YOUNIS MOHAMMED ALBLOOSHI ,3 - 1 ,the icon ,السيلكون ,117548 ,Dubai",
        "emirate": "Dubai",
        "phone": "97145693206 / 971000000000",
        "email": "info@yblooshiadvocates.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "younis-mohammed-al-blooshi-lawyer-legal-consultants"
  },
  {
    "id": "advocacy_firms_633",
    "name": "YOUSIF AL ALI ADVOCATES AND LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "24/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_633",
        "address": "lujain waleed ,2 ,AL Bakhit Center ,Next to Abu Dhabi First Bank ,14916 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142977706",
        "email": "yousefa3@emirates.net.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "yousif-al-ali-advocates-and-legal-consultants"
  },
  {
    "id": "advocacy_firms_635",
    "name": "YOUSIF ALHAMMADI ADVOCATES & LEGAL CONSULTANCY",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "01/07/2015",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_635",
        "address": "yousif alhammadi ,الخامس 513،514 ,بيزنس افينيو ,وكالة نيسان ,414145 ,Dubai",
        "emirate": "Dubai",
        "phone": "97143307771",
        "email": "yousifadv@alhammadilegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "yousif-alhammadi-advocates-legal-consultancy"
  },
  {
    "id": "advocacy_firms_636",
    "name": "YOUSUF AL SHARIF ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 2,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "19/12/2011",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_636",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142566660",
        "email": "dlr@ysalc.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [
      "legal_consultancy_individual_165",
      "legal_consultancy_individual_1224"
    ],
    "slug": "yousuf-al-sharif-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_637",
    "name": "ZAYED AL SHAMSI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "26/04/2012",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_637",
        "address": "zayed saeed saif alshamsi ,الرابع مكتب رقم 414 ,قرية الاعمال ,بجانب دائرة التنمية الاقتصادية - دوار الساعة  ,6030 ,Dubai",
        "emirate": "Dubai",
        "phone": "97142680800",
        "email": "info@zayedalshamsi.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "zayed-al-shamsi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_639",
    "name": "ZAYED ALMAZROUEI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Corporate Law",
      "Civil Law",
      "Legal Consultation"
    ],
    "languages": [
      "English",
      "Arabic"
    ],
    "tradeLicense": "29/04/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_639",
        "address": "",
        "emirate": "Dubai",
        "phone": "97142366520 / 971506177071",
        "email": "zayed@zayedlegal.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "zayed-almazrouei-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_640",
    "name": "ZUBAIDA BIN HENDI ADVOCATES & LEGAL CONSULTANTS",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Legal_Consultancy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "01/04/2024",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_640",
        "address": "",
        "emirate": "Dubai",
        "phone": "97143979948",
        "email": "info@zbh-lawfirm.ae",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "zubaida-bin-hendi-advocates-legal-consultants"
  },
  {
    "id": "advocacy_firms_615",
    "name": "test",
    "logo": "/lawyer_photos/Lawyers-Dubai-Logo.png",
    "description": "Licensed Advocacy_Firms providing comprehensive legal services in Dubai, UAE.",
    "founded": 2000,
    "lawyerCount": 0,
    "clientCount": 500,
    "casesWon": 100,
    "specializations": [
      "Civil Law",
      "Corporate Law",
      "Legal Consultation"
    ],
    "languages": [
      "Arabic",
      "English"
    ],
    "tradeLicense": "07/12/2023",
    "licenseStatus": "active",
    "verified": true,
    "offices": [
      {
        "id": "office_advocacy_firms_615",
        "address": "",
        "emirate": "Dubai",
        "phone": "97100000000",
        "email": "as@gmail.com",
        "isMain": true
      }
    ],
    "awards": [],
    "emirates": [
      "Dubai"
    ],
    "individuals": [],
    "slug": "test"
  }
];
